import * as types from '../actions/actiontype'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as appConstants from '../../../overrides/appconstants'
import * as constants from '../constants'
const initialState = {
}

initialState.checkPermissions = {
    hasPolicySearch: false,
    hasResetPolicySearch: false,
    hasEditPolicy: false,
    hasPolicySave: false,
    hasEditEndorsement: false,
    hasQuotationEndorsement: false,
    hasResetPolicyInfo: false,
    hasResetInsuredCode: false,
    hasInsuredCodeSearch: false,
    hasIndividualInsuredSave: false,
    hasCompanyInsuredSave: false,
    hasInsuredAMLVerification: false,
    hasAccountNumberScreen: false,
    hasPolEndBackDate: false,

    hasAddEndorsement: false,
    hasDeleteEndorsement: false,
    hasResetNewEndosement: false,
    hasSaveNewEndorsement: false,
    hasApproveEndorsement: false,

    hasExcelUploadMember: false,
    hasPhotoUploadBulk: false,
    hasValidateDHADOHBulkMember: false,
    hasValidateTPABulkMember: false,
    hasGenerateBulkMemberId: false,
    hasDownloadMemberTemplate: false,

    hasAttachMemberPhoto: false,
    hasGenerateCardNumberMember: false,
    hasDHADOHVerificationMember: false,
    hasDOHPenaltyMember: false,
    hasFirstPolicyY: false,
    hasFirstPolicyN: false,
    hasMemberDocumentsTab: false,
    hasSaveMember: false,

    hasSelectFileMemberImport: false,
    hasUploadMemberImport: false,
    hasCancelMemberImport: false,
    hasProceedMemberImport: false,
    hasResetMemberImport: false,

    hasApprovePolicy: false,
    hasSaveSummary: false,
    hasInstallments: false,
    hasSubgroupBilling: false,
    hasIndividualBrokerCommEdit: false,
    hasHaadManualToggle: false,

    //job assignment //
    hasAssignTask: false,
    //job assignment //
    hasRefundCharges: false,
    
    hasExpiredPolicyEndorsementCreation: false,
}

initialState.masters = {
    statusMasters: [
        { minorCode: 0, statusName: null, moduleType: 0 }
    ],
    businessTypeMaster: [
        { domainValue: 0, domainValueName: null }
    ],
    stageMasters: [
        { stageStatusId: 0, stageName: null, majorCode: 0, moduleType: 0 }
    ],
    productMasters: [
        { productId: 0, productName: null, productCode: null, regionId: 0, regionName: null, }
    ],
    agentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    allAgentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    tpaMasters: [
        { tpaId: 0, tpaName: null }
    ],
    agentSearchMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    planMasters: [
        { planId: 0, planName: null, planCode: null, categoryId: null }
    ],
    branchMasters: [
        { brCode: 0, brName: null }
    ],
    visaEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    documentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredVisaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    entityTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    maritalStatusMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    nationalityMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salutationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    collectionPointMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    ageSlabMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    schemeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    tariffCalculationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    premiumLocalCurrMasters: [
        { currencyId: 0, currencyName: null, currencyShortName: null }
    ],
    premiumForeignCurrMasters: [
        { currencyId: 0, currencyName: null, currencyShortName: null }
    ],
    typeMaster: [
        { id: 1, name: "Type-1" },
        { id: 2, name: "Type-2", }
    ],
    relationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salaryBandMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    idTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    dhaMemberTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    workingEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    residentEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    memberVisaLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    dependentVisaLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    memberWorkLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    dependentWorkLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    memberResidentLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    dependentResidentLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    vatTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    chargesTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    transactionTypeMasters: [
        { domainValue: 1, domainValueName: "Convert Policy to Policy" },
        { domainValue: 2, domainValueName: "Revision Required" },
        { domainValue: 3, domainValueName: "Print Policy Summary" },
    ],
    principalMasters: [
        { principalId: 0, principalName: null }
    ],
    applyTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    visaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    categoryMasters: [
        { categoryId: 0, categoryName: null }
    ],
    amlMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    sponsorMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    promoCodeMasters: [
        { promoId: 0, promoName: null }
    ],
    productTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    endorsementMastersOriginal: [
        { endorsementId: 0, endorsementName: null, endorsementCode: null, operationMode: null }
    ],
    endorsementMasters: [
        { endorsementId: 0, endorsementName: null, endorsementCode: null, operationMode: null }
    ],
    regionMasters: [
        { regionId: 0, regionName: null, emirateId: 0, emirateName: null, }
    ],
    regulatoryMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    cashModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    premiumModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    installmentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    userMasters: [
        { userId: 0, userName: null }
    ],
    claimSourceMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    priorityMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    batchTypeClaimsMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    poTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    payableToMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    departmentMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    countryMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    cashierMasters: [
        { userId: 0, userName: null, branchId: 0, branchName: null }
    ],
    dataTypeUploadMasters: [
        { uploadTypeId: 1, uploadTypeName: 'Option 1 (Unified Number + Date Of Birth + Passport Number)' },
        { uploadTypeId: 2, uploadTypeName: 'Option 2 (Emirated ID Number + Date Of Birth + Passport Number)' }
    ],
    monthMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    vatTypeRateMasters: [
        { taxId: 0, taxrId: 0, taxCode: null, taxName: null, taxrRatePerc: null }
    ],
    subgroupMasters: [
        { subgroupId: 0, subgroupCode: null }
    ],
    installmentConfigMasters: [
        { installmentId: 0, installmentNo: 0 }
    ],
    fobMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    providerTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    paymentModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    encounterTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    diagnosisTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    dateTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    dispatchModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    beneficaryIdTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    natureOfGroupMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    memberFieldMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    operatorMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    paymentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    yearMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    userMastersByGroup: [
        { userId: null, userName: null, designation: null }
    ],
    bankMasters: [
        { bankId: null, bankName: null, swiftCode: null, routingCode: null, bankCode: null }
    ],
    gc03TypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    claimsSubmissionPortalMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    claimsHealthAuthorityMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    treatyMasters: [
        { treatyId: null, treatyCode: null, treatyName: null, treatyProductName: null }
    ],
}

initialState.initOptions = {
    page: null, //temp
    mode: null,//can be edit or view
    moduleType: null, // policy or endorsement 

}
/*Policy Search*/
initialState.policySearch = {
    product: null,
    plan: null,
    branch: null,
    insuredName: null,
    issueFromDate: appUtility.getMinusOneYearToCurrentDate(),
    issueToDate: appUtility.getCurrentDate(),
    policyNo: null,
    businessType: null,
    status: null,
    emiratesId: null,
    medicalCardNo: null,
    agent: null,
    phoneNo: null,
    stage: null,
    isSubmit: false,
    action: null,
    endorsementNo: null,
    transactionType: null,
    isAgentEnabled: false,
    documentType: null,
    oldPolicyNo: null,
    searchResult: [],
    hasCheckedBoxInSearchResult: false,
    searchResultClass: "collapse show",
    searchClass: "collapse show",
    showSearchResult: false,
    sortString: null,
    sortStringDirection: 0,
    productMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    initOptions: [],
    policySearchSubGrid: [],
    currentPolicyNo: '',
    assignedYN: null,
    assignedUser: null,
    hasCheckedBoxInSearchResult: false,

}
/*
initialState.policyEndorsementInformation = {
    
    documentNo: null,
    policyIssueDate: null,
    policyEffectiveDate: null,
    policyExpiryDate: null,
    documentType: null,
    product: null,
    branch: null,
    endorsementNumber: null,
    endorsementCode: null,
    endorsementDescription: null,
    serialNumber: null,
    year: null,
    endorsementIssueDate: null,
    endorsementEffectiveDate: null,
    endorsementExpiryDate: null,
    endorsementApprovedBy: null,
    endorsementApprovedDate: null,
    endorsementStage: null,
    endorsementStatus: null,
}*/
initialState.policyEndorsement = {
    insuredTransId: null,
    endorsementId: null,
    endorsementTypeId: null,
    endorsementNumber: null,
    endorsementIssueDate: appUtility.getCurrentDate(),
    endorsementSerialNumber: null,
    endorsementEffectiveDateFrom: null,
    documentNo: null,
    documentType: null,
    product: null,
    branch: null,
    endorsementCode: null,
    endorsementApprovedBy: null,
    endorsementApprovedDate: null,
    policyIssueDate: null,
    policyEffectiveDate: null,
    policyExpiryDate: null,
    endorsementDescription: null,
    endorsementReason: null,
    endorsementStatus: null,
    partyAcCode: null,
    partyName: null,
    endorsementYear: appUtility.getCurrentYear(),
    shortPeriod: null,
    updateEntryExitDate: null,
    AMLScreen: null,
    policyId: null,
    productTypeId: null,
    endorsementQuotationNo: null,
    rowVersion: null,
    operationMode: null,
    isRefundChargesYN: null,
    endorsementSerialNumberToUpdate: null,
    endorsementIdToUpdate: null,
    isAddChargesYN: null,
    reflectInMainPolicyYN: null,
    isHAADPenaltyYN: false,
}
initialState.accountDetails = {
    searchText: null,
    accountDetailResult: [],
}
initialState.policyInformation = {
    product: "",
    plan: "",
    policyNo: null,
    policyId: null,
    photoId: null,
    photoName: null,
    photoSrc: null,
    department: null,
    departmentName: null,
    branch: "",
    insuredCode: null,
    insuredName: null,
    prospectCode: null,
    prospectName: null,
    isAccountCodeGeneration: false,
    accountNo: null,
    accountName: null,
    insuredVisaType: "",
    isSubgroupExisting: false,
    businessType: "",
    agent: "",
    stage: "",
    ageSlab: null,
    scheme: null,
    tariffCalculation: null,
    actionStatus: "",
    effectiveDate: null,
    issueDate: null,
    policyValidityDays: null,
    policyExpiry: null,
    expiryDate: null,
    inceptionDate: null,
    documentType: "New Policy",
    visaEmirate: "",
    promoCode: null,
    premiumLocalCurr: null,
    premiumForeignCurr: null,
    insuredType: null,
    docCollectPt: "",
    showPolicyInformation: false,
    showCurrentPolicyInformation: false,
    isAgentEnabled: false,
    oldPolicyNumber: null,
    approvalDate: null,
    totalMembers: null,
    totalPrincipals: null,
    totalDependents: null,
    approvedBy: null,
    underwritingYear: null,
    currentPolicyId: null,
    currentPolicyStage: null,
    customerId: null,
    maternityMinAge: null,
    maternityMaxAge: null,
    childMinAge: null,
    childMaxAge: null,
    tpaName: null,
    rate: 0,
    checkVisaEmirate: false,
    goToMemberInformation: false,
    productType: null,
    isInsuredYN: null,
    proposalId: null,
    quotationNo: null,
    quotationId: null,
    jurisdictionAr: null,
    jurisdictionEn: null,
    subgroupBilling: "N",
    isFac: "N",
    renewedTo: null,
    regulatoryAuthority: null,
    vatLocation: appConstants.COUNTRY_UNITED_ARAB_EMIRATES,
    remarks: null,
    cashTaggedUser: null,
    haadTaggedUser: null,
    haadStatus: null,
    cashMode: null,
    premiumMode: null,
    installment: "N",
    installmentNos: null,
    installmentType: null,
    markForCollectionCash: "N",
    markForCollectionHaad: "N",
    endorsementConfig: null,
    showAddtoPolicy: null,
    stageId: null,
    actionStatusId: null,
    isWorkFlowProcessInProgressYN: null,
    isProductSubTypeYN: null,
    subProductTypeId: null,
    cashReceiptNo: null,
    haadReceiptNo: null,
    isMigratedYN: null,
    isVatApplicableYN: null,
    paidAmount: null,
    outstandingAmount: null,
    treatyId: null,
    productMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    planMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ],
    branchMasters: [
        { brCode: 0, brName: null }
    ],
    ageMasters: [
        { ageBand: null, ageBandId: 0 }
    ],
    currentEndorsementId: null
}
initialState.isFeildsDisabled = true

initialState.category = {
    result: []
}
initialState.installments = {
    result: []
}
initialState.subgroupBilling = {
    result: [],
    hasCheckedBoxInTable: null,
}
initialState.checkList = []

initialState.policyTOB = {
    category: null,
    deductible: null,
    opCoPay: null,
    pharmacy: null,
    maternity: null,
    dental: null,
    optical: null,
    dohApprovalNo: null,
    remarks1: null,
    remarks2: null,
    result: []
}
initialState.loadingDistribution = {
    result: []
}
initialState.benefit = {
    srlNo: null,
    categoryCode: null,
    categoryDescription: null,
    benefitCode: null,
    benefitDescription: null,
    aggregateLimit: null,
    result: []
}
initialState.costingSheet = {
    result: {
        result: [
            {
                benefitName: null,
                categoryName: null,
                networkName: null,
                genderName: null,
                ageSlab: null,
                relationName: null,
                numberOfLives: null,
                pPPAPremium: null,
            },
        ],
    },
    filterdResults: [],
    resultOriginal: [],

    benefitName: null,
    categoryName: null,
    networkName: null,
    genderName: null,
    ageSlab: null,
    relation: null,
}
initialState.premiumBifurcation = {
    memberName: null,
    memberId: null,
    premium: null,
    bmiLoading: null,
    maternityLoading: null,
    gerdLoading: null,
    arthritisLoading: null,
    diabetesMellitusLoading: null,
    highBloodPressureLoading: null,
    highLipidsLoading: null,
    asthmaLoading: null,
    netLoadingPerc: null,
    netLoading: null,
    discountPerc: null,
    discount: null,
    hcvFee: null,
    basmaFee: null,
    icpFee: null,
    haadPenalty: null,
    oldPremium: null,
    renewLoading: null,
}

initialState.accountDetails = {
    searchText: null,
    accountDetailResult: [],
}
initialState.modalsState = {
    showEndorsementModal: false,
    showAccountsModal: false,
    showInsuredMasterCodesModal: false,
    showPolicyInformationModal: false,
    showCategoryListModal: false,
    showCheckListModal: false,
    showPolicyTOBModal: false,
    showLoadingDistributionModal: false,
    showBaseBenefitModal: false,
    showCostingSheetModal: false,
    showInsuredInformationModal: false,
    showMemberImportModal: false,
    showDohMemberModal: false,
    showDhaMemberModal: false,
    showProspectInformationModal: false,
    showInstallmentModal: false,
    showSubgroupBillingModal: false,
    showRemarksModal: false,
    showCommunicationModal: false,
    showPremiumBifurcationModal: false,
    showIndividualQuoteSummaryCharges: false,
    showGroupQuoteSummaryCharges: false,
    showPolicySummaryCharges: false,
    showTPADownloadModal: false,
    showApprovalModal: false,
    showMemberCreateCardBatchModal: false,
    showRenewalsUpload: false,
    showChangeProductModal: false,
    showJobAssignmentModal: false,

    showNasMemberModal: false,
    showUploadCustomTarriff: false,

}
initialState.brokerageInfo = {
    brokerId: null,
    brokerName: null,
    selfBilling: false,
    rate: null,
    amount: null,
    vatType: null,
    vat: null,
    netAmount: null,
    commMinPerc: null,
    commMaxPerc: null,
    commPerc: null,
    vatPerc: null,
    originalGrossPremium: null,
    isVatApplicable: null
}
initialState.tpaFees = {
    tpaId: null,
    tpaName: null,
    selfBilling: false,
    rate: null,
    amount: null,
    vatType: null,
    vat: null,
    netAmount: null,
    vatPerc: null,

}
initialState.finalAmounts = {
    grossPremiumFC: null,
    loadingFC: null,
    discountFC: null,
    splLoadingFC: null,
    splDiscountFC: null,
    netPremiumFC: null,
    netToCustomerFC: null,
    netToBrokerFC: null,
    chargesFC: null,
    vatFC: null,
    vatAdditionalFC: null,
    brokerageFC: null,
    grossPremiumLC: null,
    loadingLC: null,
    discountLC: null,
    splLoadingLC: null,
    splDiscountLC: null,
    netPremiumLC: null,
    netToCustomerLC: null,
    netToBrokerLC: null,
    chargesLC: null,
    vatLC: null,
    vatAdditionalLC: null,
    brokerageLC: null,
}
initialState.tpaMasters = {
    tpaMaster: [],
}
initialState.TaxTable = {
    taxMaster: [],
}
initialState.memberPremium = []
initialState.memberPremiumFiltered = []

initialState.charges = {
    chargesTable: [],
    grossPremiumSection: null,
    grossChargesSection: null,
    grossChargesWithoutVAT: null,
    basePremiumTotal: null,
    uwAmt: null,
    netAmt: null,
    netPERc: null,
    uwPerc: null,
    renewalAmt: null,
    renewalPerc: null,
    autoAmt: null,
    autoPerc: null,
    disAmt: null,
    disPerc: null,
    chargesVAT: null,
    vatAmount: null,
    quotationVatPercentage: null,
    vatTypeId: null,
    defaultChargesSetup: [], //conatains master Charges From Charges Setup Table
    validatedCharges: [],
}
initialState.insuredInformation = {
    insuredTransId: null,
    insuredId: null,
    insuredType: null,
    emiratesId: null,
    mobile: null,
    salutation: null,
    firstName: null,
    middleName: null,
    lastName: null,
    fullName: null,
    firstNameAr: null,
    middleNameAr: null,
    lastNameAr: null,
    gender: null,
    maritalSatus: null,
    dateofBirth: null,
    nationality: null,
    email: null,
    policyInsuredType: null,
    policyPolicyType: null,
    companyCRNumber: null,
    policysalutation: null,
    tradeLicenseNo: null,
    tradeLicenseExpiryDate: null,
    policyEmail: null,
    entityType: null,
    entityId: null,
    isInsuredTypeIndividual: true,
    companyMobile: null,
    masterValues: [],
    insuredCodes: [],
    nameSearch: null,
    fullNameArabic: null,
    showAddnewSection: false,
    customerId: null,
    customerInPolicyYN: 'N',
    poBox: null,
    residenceVisa: null,
    sponsorType: null,
    height: null,
    weight: null,
    address1: null,
    address2: null,
    amlType: null,
    trn: null,
    vatLocation: null,
}
initialState.prospectInformation = {
    insuredType: null,
    emiratesId: null,
    mobile: null,
    salutation: null,
    firstName: null,
    fullName: null,
    gender: null,
    maritalSatus: null,
    dateofBirth: null,
    nationality: null,
    companyCRNumber: null,
    tradeLicenseNo: null,
    tradeLicenseExpiryDate: null,
    policyEmail: null,
    entityType: null,
    entityId: null,
    isInsuredTypeIndividual: true,
}
/*Member Page*/
initialState.currentMemberType = constants.BENEFFICARY_SECTION_MEMBER
initialState.searchMember = null
initialState.memberDetails = {
    details: [],
    memberFilteredDetails: [],
    mafFilteredDetails: [],
    hasCheckedBoxInSearchResult: false,
    isAdditionOfMember: false,
    showMembers: false,
    isPrincipal: false,
    currentMemberName: null,
    memberUpload: {
        censusDataCheck: false,
        currentMemberImportPageId: 0,
        memberImportFile: null,
        memberImportFileName: null,
        memberImportFileType: null,
        memberImportFileEncryptedId: null,
        memberImportFileId: null,
        memberImportFileCheck: false,
        importMemberDetails: [],
        importMemberDetailsOriginal: [],
        importMemberDataIsValid: null,
        duplicationMessage: null,
        isDuplicated: false,
        isPrincipalMessage: null,
        principalMessage: null,
        encryptedFileIdWithErrors: null,
    },
    sortString: null,
    sortStringDirection: 0
}
initialState.memberInformation = {
    params: {
        policyNo: null,
        memberId: null,
        employeeId: null,
        photoID: null,
        salutation: null,
        firstName: null,
        middleName: null,
        lastName: null,
        dateofBirth: null,
        age: null,
        ageInMonths: null,
        isAgeLessThan1: false,
        isPrincipal: false,
        isPrincipalExisting: false,
        category: null,
        initialCategory: null,
        relation: null,
        principal: null,
        plan: null,
        emiratesId: null,
        visaEmirates: null,
        gender: null,
        nationality: null,
        maritalStatus: null,
        passportNo: null,
        mobile: null,
        email: null,
        salaryBand: null,
        salary: null,
        minSalary: null,
        maxSalary: null,
        height: null,
        weight: null,
        bmi: null,
        profession: null,
        idType: null,
        dhaMemberType: null,
        dhaMemberId: null,
        dhaVerified: null,
        workEmirate: null,
        workLocation: null,
        residentEmirate: null,
        residentLocation: null,
        birthCertificate: null,
        uidNumber: null,
        cutOffDate: null,
        elapsedDays: null,
        dhaStatus: null,
        firstPolicy: true,
        previousInsuranceCompany: null,
        previousInsuranceNumber: null,
        previousInsuranceExpiryDt: null,
        entryDate: null,
        visaExpiryDate: null,
        isFirstPolicy: true,
        ageIsLessThan6Months: null,

        employeeId: null,
        firstNameAr: null,
        middleNameAr: null,
        lastNameAr: null,
        visaFileNo: null,
        plan: null,
        visaLocation: null,
        medicalCardNumber: null,
        visaType: null,
        isNewEntry: false,
        isResident: null,
        inceptionDate: null,
        expiryDate: null,
        dependentsCount: null,
        isActive: null,

        premiumPerPerson: null,
        extraPremium: null,
        maternityPremium: null,
        autoLoadingPerc: null,
        autoLoadingAmt: null,
        uwLoadingPerc: null,
        uwLoadingAmt: null,
        netLoadingPerc: null,
        netLoadingAmt: null,
        discountPerc: null,
        discountAmt: null,
        vatPerc: null,
        initialNetPremiumAmt: null,
        netPremiumAmt: null,
        renewalLoadingPerc: null,
        renewalLoadingAmt: null,

        showMemberDetails: false,
        basmaFee: 19,
        haadPenalty: 0,
        hcvFee: 18,
        finalPenalty: 0,
        showDubaiRegionFee: false,
        showAbuDhabiRegionFee: false,
        showDOHPenaltyButton: false,
        isLocationMandatory: true,
        memberInformationClass: false,
        isAdditionOfMember: false,
        isDohVerifiedYN: null,
        principalCardNumber: null,
        commissionYN: false,
        uhcgMemberYN: false,
        uhcTransmitId: null,
        altId: null,
        changeOfCategoryHasError: false,
        remarks: null,
        waiveOffAmt: null,
        waiveOffBy: null,
        waiveOffReason: null,

        cocVerifiedYN: null,
        cocBatchId: null,
        cocLogBatchId: null,
        cocRefNo: null,
        haadManualYN: null,
        isHaadManualYN: false,



        icpFee: null,
    },
    flags: {
        showMemberDependents: false
    }
}
initialState.dependentDetails = {
    details: [],
    dependentFilteredDetails: [],
    hasCheckedBoxInSearchResult: false,
    showDependents: false,
    currentMemberName: null,
    sortString: null,
    sortStringDirection: 0
}
initialState.dependentInformation = {
    params: {
        policyNo: null,
        memberId: null,
        photoId: null,
        photoName: null,
        photoSrc: null,
        salutation: null,
        firstName: null,
        middleName: null,
        lastName: null,
        dateofBirth: null,
        age: null,
        ageInMonths: null,
        isAgeLessThan1: false,
        isPrincipal: false,
        relation: null,
        category: null,
        initialCategory: null,
        principal: null,
        emiratesId: null,
        visaEmirates: null,
        gender: null,
        nationality: null,
        maritalStatus: null,
        passportNo: null,
        mobile: null,
        email: null,
        salaryBand: null,
        salary: null,
        minSalary: null,
        maxSalary: null,
        height: null,
        weight: null,
        bmi: null,
        profession: null,
        idType: null,
        dhaMemberType: null,
        dhaMemberId: null,
        dhaVerified: null,
        workEmirate: null,
        workLocation: null,
        residentEmirate: null,
        residentLocation: null,
        birthCertificate: null,
        uidNumber: null,
        cutOffDate: null,
        elapsedDays: null,
        dhaStatus: null,
        firstPolicy: true,
        previousInsuranceCompany: null,
        previousInsuranceNumber: null,
        previousInsuranceExpiryDt: null,
        entryDate: null,
        visaExpiryDate: null,
        isFirstPolicy: true,
        isLocationMandatory: true,
        employeeId: null,
        firstNameAr: null,
        middleNameAr: null,
        lastNameAr: null,
        visaFileNo: null,
        plan: null,
        visaLocation: null,
        medicalCardNumber: null,
        visaType: null,
        isNewEntry: false,
        isResident: null,
        memberInformationClass: false,
        isAdditionOfMember: false,
        inceptionDate: null,
        isActive: null,

        premiumPerPerson: null,
        extraPremium: null,
        maternityPremium: null,
        autoLoadingPerc: null,
        autoLoadingAmt: null,
        uwLoadingPerc: null,
        uwLoadingAmt: null,
        netLoadingPerc: null,
        netLoadingAmt: null,
        discountPerc: null,
        discountAmt: null,
        varPerc: null,
        netPremiumAmt: null,
        showDependentInformation: false,
        basmaFee: 19,
        haadPenalty: 0,
        hcvFee: 18,
        finalPenalty: 0,
        showDubaiRegionFee: false,
        showAbuDhabiRegionFee: false,
        showDOHPenaltyButton: false,
        isDohVerifiedYN: null,
        principalCardNumber: null,
        commissionYN: false,
        uhcgMemberYN: false,
        uhcTransmitId: null,
        altId: null,
        changeOfCategoryHasError: false,
        remarks: null,
        waiveOffAmt: null,
        waiveOffBy: null,
        waiveOffReason: null,
        icpFee: null,
        haadManualYN: null,
        isHaadManualYN: false,
    }
}
initialState.tpaDownloadExcel = {
    selectedTPA: null,
    tpaId: null,
    tpaName: null,
    selectedExcelFormat: null
}

/*Member filter */
initialState.memberSearchFilter = {
    isPolicySearch: true,
    policyWise: true,
    memberWise: false,
    policyNo: null,
    policyId: null,
    //component a
    policyNo: null,
    isActiveList: false,
    isMemberList: false,
    insuredName: null,
    isActiveListSearched: false,
    //component b
    selectedMemberField: null,

    memberFieldValue: null,

    //search result
    isSearchMemberResult: false,
    showMembers: false,
    memberFilteredDetails: [],
    memberTableDisplay: [],
    selectAll: false,
    memberFieldId: null,

    memberFieldValue: null,
    searchMember: null

}

/*Document Tab*/
initialState.currentDocumentPageId = null
initialState.policyDocuments = {
    documentList: [],
    mandatoryDocumentMaster: [],
    documentMaster: [],
    hasCheckedBoxInDocuments: false
}
initialState.memberDocuments = {
    documentList: [],
    mandatoryDocumentMaster: [],
    documentMaster: [],
    isPolicyModuleDocument: false,
    isMemberDocument: false,
    hasCheckedBoxInDocuments: false
}
initialState.dohShafafiyaUpload = {
    uploadTypeId: null,
    membersUploadedRecords: [],
    memberDetails: [],
}
initialState.shafafiyaVerification = {

    shafafiyaBatchListing: [],
    shafafiyaBatchDetails: [],
}
initialState.dohVerification = {
    currentBatchId: null,
    currentActionSource: null,
    actionSourceType: null,//to be used for search
    batchStatusType: null,
    batchId: null,
    referNo: null,
    showBatchDetails: false,
    dohBatchListing: [],
    filterdBatchDetailsResult: [],
    dohBatchDetails: [],

    dhaBatchDetails: [],
    filterdDhaBatchDetailsResult: [],
    batchFilterBy: null,
    nasBatchDetails: [],
    cocBatchDetails: [],
    icpMemberBatchDetails: null,
    icpPolicyDetail: null,
    fullName: null,

}

initialState.shafafiyaMemberDetail = {
    id: null,
    policyNumber: null,
    medicalCardNumber: null,
    memberFullNameEN: null,
    memberFirstNameEN: null,
    memberSecondNameEN: null,
    memberThirdNameEN: null,
    memberFirstNameAR: null,
    memberSecondNameAR: null,
    memberThirdNameAR: null,
    documentApprovalDate: null,
    unifiedNumber: null,
    contactNumber: null,
    relation: null,
    relationTo: null,
    gender: null,
    nationality: null,
    nationalityCode: null,
    dob: null,
    countryofResidence: null,
    emirateofResidence: null,
    city: null,
    cityCode: null,
    passportNumber: null,
    emiratesIDNumber: null,
    memberMinOccurs: null,
    payer: null,
    tpa: null,
    packageName: null,
    startDate: null,
    renewalDate: null,
    expiryDate: null,
    grossPremium: null,
    policyHolder: null,
    company: null,
    collectedPremium: null,
    vat: null,
    vatPerc: null,
    status: null,
    errorCode: null,
    errorDesc: null,
}
initialState.dohMemberDetail = {
    policyNumber: null,
    documentId: null,
    mstMemberId: null,
    quotationId: null,
    transmissionLastTryDate: null,
    transmissionTryCount: null,
    dohVerificationResponse: null,
    shafafiyaUploadResponse: null,
    isDohVerifiedYn: null,
    isDohUploadedYn: null,
    unifiedNumber: null,
    identityCardNumber: null,
    identityCardIssueDt: null,
    identityCardExpiryDt: null,
    nationalityId: null,
    nationalityShaId: null,
    nationalityDescAr: null,
    nationalityDescEn: null,
    personFullNameAr: null,
    personFirstNameAr: null,
    personSecondNameAr: null,
    personThirdNameAr: null,
    personFourthNameAr: null,
    personClanNameAr: null,
    personFullNameEn: null,
    personFirstNameEn: null,
    personSecondNameEn: null,
    personThirdNameEn: null,
    personFourthNameEn: null,
    personClanNameEn: null,
    personKhulasitQaidNumber: null,
    personFamilyBookNumber: null,
    personEdbarahNumber: null,
    genderId: null,
    genderDescAr: null,
    genderDescEn: null,
    occupationId: null,
    occupationDescAr: null,
    occupationDescEn: null,
    faithId: null,
    faithDescAr: null,
    faithDescEn: null,
    dob: null,
    countryOfBirthId: null,
    countryOfBirthShaId: null,
    countryOfBirthDescAr: null,
    countryOfBirthDescEn: null,
    emirateOfBirthId: null,
    emirateOfBirthDescAr: null,
    emirateOfBirthDescEn: null,
    cityOfBirthId: null,
    cityOfBirthDescAr: null,
    cityOfBirthDescEn: null,
    placeOfBirthAr: null,
    placeOfBirthEn: null,
    maritalStatusId: null,
    maritalStatusDescAr: null,
    maritalStatusDescEn: null,
    religionId: null,
    religionDescAr: null,
    religionDescEn: null,
    sponsorNumber: null,
    sponsorNameEn: null,
    sponsorNameAr: null,
    personTypeId: null,
    personTypeDescAr: null,
    personTypeDescEn: null,
    errorCode: null,
    errorDesc: null,
    passportExpiryDate: null,
    passportIssueDate: null,
    passportNumber: null,
    passportIssueCountryId: null,
    passportIssueCountryDescAr: null,
    passportIssueCountryDescEn: null,
    passportIssuePlace: null,
    passportType: null,
    passportTypeId: null,
    passportTypeDescAr: null,
    passportTypeDescEn: null,
    immigrationNumber: null,
    immigrationIssueDate: null,
    immigartionExpiryDate: null,
    batchId: null,
    transactionId: null,
    endorsementId: null,
    transmissionDate: null,
    dohLogMemberId: null,
    createdDt: null,
    updatedDt: null,
    createdBy: null,
    updatedBy: null,
    finalStatus: null,
    // for shafafiya
    firstName: null,
    firstNameEN: null,
    middleNameEN: null,
    lastNameEN: null,
    firstNameAR: null,
    middleNameAR: null,
    lastNameAR: null,
    contactNumber: null,
    nationalityCode: null,
    city: null,
    medicalIdNo: null,
    relation: null,
    relationTo: null,
    payerId: null,
    packageName: null,
    startDate: null,
    renewalDate: null,
    expiryDate: null,
    grossPremium: null,
    policyHolder: null,
    companyId: null,
    collectedPremium: null,
    vat: null,
    vatPerc: null,
    status: null,
    shafafiyaStatusType: null


}
initialState.dhaMemberDetail = {
    registrationUploadId: null,
    batchId: null,
    documentId: null,
    endorsementId: null,
    memberId: null,
    header: null,
    senderId: null,
    receiverId: null,
    payerId: null,
    tpaId: null,
    intermediaryId: null,
    transactionDate: null,
    recordCount: null,
    dispositionFlag: null,
    memberType: null,
    fullName: null,
    contactNumber: null,
    dob: null,
    gender: null,
    nationality: null,
    passportNumber: null,
    maritalStatus: null,
    emirate: null,
    residentialLocation: null,
    workLocation: null,
    salary: null,
    commission: null,
    emiratesIdNumber: null,
    uidNumber: null,
    gdrfaFileNumber: null,
    birthCertificateNumber: null,
    relation: null,
    relationTo: null,
    productOrigin: null,
    productCode: null,
    productId: null,
    policySequence: null,
    topUpPolicy: null,
    enrollmentDate: null,
    deletionDate: null,
    grossPremium: null,
    netPremium: null,
    intermediaryFee: null,
    tpaFees: null,
    tpaFeeType: null,
    ipCopay: null,
    opCopay: null,
    opConsultationCopay: null,
    pharmacyCopay: null,
    dentalCopay: null,
    opticalCopay: null,
    maternityCopay: null,
    entityType: null,
    entityId: null,
    establishmentEmail: null,
    photo: null,
    responseStatusCode: null,
    responseTransactionId: null,
    dhaMemberId: null,
    responseMessage: null,
    responseReport: null,
    approvalDate: null,
    createdDateTime: null,
    createdBy: null,
    nationalityId: null,
    memberTypeId: null,
    genderId: null,
}

initialState.medicalCardNoBatchUpload = {
    tpaId: null,
    batchUploadedEncryptedFileId: null,
    batchUploadedFileName: null,
    batchUploadedFileType: null,
    batchUploadFileId: null,
    batchUploadFile: null,
    duplicationCount: null,
    successCount: null,
    duplicatedRecords: [],
}
initialState.communication = {
    originalCommunication: [
        {
            srlNo: 1,
            referredBy: null,
            referralStatus: null,
            referralStatusId: null,
            referralMessage: '',
            referralDate: appUtility.formatDate(appConstants.TODAY),
            premium: 0,
            disabled: false
        }
    ],
    filteredCommunication: [
        {
            srlNo: 1,
            referredBy: null,
            referralStatus: null,
            referralStatusId: null,
            referralMessage: '',
            referralDate: appUtility.formatDate(appConstants.TODAY),
            premium: 0,
            disabled: false
        }
    ],
}
initialState.remarks = {
    originalRemarks: [
        {
            srlNo: 1,
            remarks: '',
            name: null,
            disabled: false,
            referralDate: appUtility.formatDate(appConstants.TODAY),
        }
    ],
    filteredRemarks: [
        {
            srlNo: 1,
            remarks: '',
            name: null,
            disabled: false,
            referralDate: appUtility.formatDate(appConstants.TODAY),
        }
    ],
}


initialState.summaryStageStatus = {
    stage: null,
    actionStatus: null,
    statusMasters: [
        { statusName: null, minorCode: null, moduleType: null }
    ]
}


initialState.paymentTransactions = {
    agreeTerms: false,
    paymentMode: null,
    cashReceiptNo: null,
    cashReceiptDate: null,
}
initialState.paymentInformation = {
    customerEmail: null,
    customerPhone: null,
    customerName: null,
    referenceId: null,
    referenceText: null
}
initialState.emailInformation = {
    openEmail: false,
    customerEmail: null,
    referenceId: null,
    referenceNo: null,
    paymentLink: null,
    rowVersion: null
}
initialState.approvalInformation = {
    accountName: null,
    accountCode: null,
    accountId: null,
    insuredName: null,
    insuredCode: null,
    insuredId: null,
    policyApprovalDate: appUtility.getCurrentDate(),
    endorsementApprovalDate: appUtility.getCurrentDate(),
    tpaGenYN: true,
    premiumGenYN: true,
    brokerGenYN: true,
    facGenYN: true,
    policyId: null,
    policyNo: null,
    policyEffectiveDate: null,
    policyExpiryDate: null,
    policyBrokerId: null,
    commission: null,
    commissionAmount: null,
    product: null,
    businessType: null,
    netToCustomer: null,
    endorsementEffectiveDate: null,
    endorsementExpiryDate: null,
    endorsementSerialNo: null,
    treatyId: null,
}

initialState.medicalCardMembersSearch = {
    policyId: null,
    policyNo: null,
    endorsementNo: null,
    category: null,
    subGroup: null,      // above this are values from select and below are the ones from input field
    staffId: null,
    cardPrinterId: null,
    memberName: null,
    memberId: null,
    cardNo: null,
    endorsementDropdownResult: [],
    categoryDropdownResult: [],
    subGroupDropdownResult: [],
    printStatusYN: "N",
    isSubmit: false,
    selectAll: false,
    showSearchResult: false,
    searchResult: [],
    searchResultClass: "collapse show",
    searchClass: "collapse show",
    //printMessage: {},
    selectedMembers: null,
    searchSelector: null, //this is supposed to store the value from the select to be used to change the input
    //Page: null
}
initialState.cardbatchInformation = {
    //search params
    policyNo: '',
    printStatusYN: 'N',
    cardPrinterId: '',
    //table params
    showSearchResult: false,
    isSubmit: false,

    searchResultClass: "collapse show",
    searchClass: "collapse show",
    batchFilteredResults: [],
    batchTableDisplay: [],
    isSearchResultPendingPrint: false
}
///////ExcelReportByDate/////////////   
initialState.excelReportByDate = {

    //flow control param
    reportType: null,

    //form submission params
    fromDate: null,
    toDate: null,
    prodTypeId: null
}
///////ExcelReportByDate/////////////   
///////JobAssignment/////////////////
// initialState.testJob = {
//     userVal: {
//         assignedTo: null,
//         assignedDate: null,        
//     },
//     sectionInfo: {
//         isActive: false,
//         userMasters: [],
//         assignedDocType: null,
//         selectedResults:[],

//     },
//     selectedResults:[]


// }
initialState.jobAssignment = {
    //task  params
    assignedTo: null,
    assignedToGroup: [],
    assignedDate: appUtility.formatDate(appConstants.TODAY),
    assignedBy: null,
    assignedByGroup: [],

    //section info
    moduleId: null,
    systemId: appConstants.SYSTEM_ID_MEDICAL_CORE_ID,
    isActive: false,
    userMasters: [
        { userId: null, userName: null, designation: null }
    ],
    assignedDocType: null,
    selectedResults: [],
}
///////JobAssignment/////////////////
///////DocumentListings//////////////
initialState.documentsListing = {
    //search
    searchClass: "collapse show",
    approveFrom: appUtility.formatDate(appConstants.TODAY),
    approveTo: appUtility.formatDate(appConstants.TODAY),
    policyNo: null,
    isPremiumPosted: null,
    isTPAPosted: null,
    isCommisionPosted: null,
    isPenalty: null,
    isMigrated: null,
    isRenewals: null,
    //search result
    isSearchSubmit: false,
    searchResultClass: "collapse show",
    showSearchResult: false,
    searchResult: []
}
///////DocumentListings//////////////


initialState.changeProduct = {
    changeItem: null,
    newVisaEmirate: null,
    newProduct: null,
    newPortalPlanType: null,
    newPlan: null,
    newVisaEmirateMasters: [
        { regionId: 0, regionName: null, emirateId: 0, emirateName: null, }
    ],
    newProductMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    newPortalPlanMasters: [
        { domainValue: null, domainValueName: null }

    ],
    newPlanMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ]
}

initialState.nasMemberDetail = {
    documentId: null,
    endorsementId: null,
    memberDocId: null,
    memberTransId: null,
    firstName: null,
    middleName: null,
    lastName: null,
    emiratesId: null,
    dob: null,
    uidNo: null,
    passportNo: null,
    salaryBandId: null,
    salary: null,
    locationEmirateId: null,
    residentEmirateId: null,
    workLocationId: null,
    nationalityId: null,
    workEmirateId: null,
    workLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    residentLocationMasters: [
        { cityId: 0, cityName: null }
    ],


}

initialState.tariffUpload = {
    categoryId: null,
    ageBandsList: [],
    categoriesList: [],
}
initialState.memberShafafiyaHist = []

/*Policy Search*/
initialState.groupRenewalSearch = {
    product: null,
    branch: null,
    insuredName: null,
    expiryFromDate: appUtility.addDays(appUtility.getCurrentDate(), 1),
    expiryToDate: appUtility.getPlusOneMonthToCurrentDate(),
    policyNo: null,
    businessType: null,
    agent: null,
    isSubmit: false,
    isAgentEnabled: false,
    documentType: null,
    searchResult: [],
    /*  hasCheckedBoxInSearchResult: false, */
    searchResultClass: "collapse show",
    searchClass: "collapse show",
    showSearchResult: false,
    sortString: null,
    sortStringDirection: 0,
    productMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    hasCheckedBoxInSearchResult: false,

}
initialState.medicalOldAGeCUttOffDate = {
    ageCutOffDate: null,
}
export default function miCoreSharedReducer(state = initialState, action) {
    switch (action.type) {
        /* Permission  Starts*/
        case types.UPDATE_MICORE_MODULE_PERMISSIONS_PARAMS_MICORESHARED:
            return {
                ...state,
                checkPermissions: {
                    ...state.checkPermissions,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_MICORE_MASTERS_END_MICORESHARED:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    // planMasters: action.result.planTypeMasters,
                    promoCodeMasters: action.result.promoCodeMasters,
                    agentMasters: action.result.agentMasters,
                    agentSearchMasters: action.result.agentMasters,
                    allAgentMasters: action.result.allAgentMasters,
                    tpaMasters: action.result.tpaMasters,
                    categoryMasters: action.result.categories,
                    bankMasters: action.result.bankMasters,
                    regionMasters: action.result.region,

                }
            }
        case types.GET_VAT_RATE_AND_PERC_MASTERS_END:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    // planMasters: action.result.planTypeMasters,
                    vatTypeRateMasters: action.payload,
                }
            }

        case types.GET_USER_MASTERS_END_MICORESHARED:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    userMasters: action.result,
                }
            }
        case types.GET_INSURED_INFORMATION_MASTERS_END_MICORESHARED:
            console.log("action.result.endorsementMaster", action.result.endorsementMaster)

            return {
                ...state,
                masters: {
                    ...state.masters,
                    insuredTypeMasters: action.result.insuredType,
                    businessTypeMaster: action.result.businessType,
                    documentTypeMasters: action.result.documentType,
                    visaEmirateMasters: action.result.emirates,
                    insuredVisaTypeMasters: action.result.insuredVisaType,
                    stageMasters: action.result.stageType,
                    branchMasters: action.result.branchType,
                    productMasters: action.result.productType,
                    amlMasters: action.result.amlType,
                    sponsorMasters: action.result.sponsorType,
                    productTypeMasters: action.result.productTypeMasters,
                    regulatoryMasters: action.result.regulatoryName,
                    cashModeMasters: action.result.cashMode,
                    premiumModeMasters: action.result.premiumMode,
                    installmentTypeMasters: action.result.installmentType,
                    //agentMasters: action.result.agent,
                    ageSlabMasters: action.result.ageSlab,
                    schemeMasters: action.result.scheme,
                    tariffCalculationMasters: action.result.tariffCalculation,
                    maritalStatusMasters: action.result.maritalStatus,
                    entityTypeMasters: action.result.entityType,
                    nationalityMasters: action.result.nationality,
                    salutationMasters: action.result.salutation,
                    collectionPointMasters: action.result.collectionPoint,
                    premiumLocalCurrMasters: action.result.currency,
                    premiumForeignCurrMasters: action.result.currency,
                    /*Member Page*/
                    relationMasters: action.result.relation,
                    salaryBandMasters: action.result.salaryBand,
                    professionMasters: action.result.profession,
                    idTypeMasters: action.result.idType,
                    dhaMemberTypeMasters: action.result.dhaMemberType,
                    workingEmirateMasters: action.result.emirates,
                    residentEmirateMasters: action.result.emirates,
                    vatTypeMasters: action.result.vatType,
                    chargesTypeMasters: action.result.chargesType,
                    applyTypeMasters: action.result.applyType,
                    visaTypeMasters: action.result.visaType,
                    endorsementMastersOriginal: action.result.endorsementMaster,
                    endorsementMasters: [...new Map(action.result.endorsementMaster.map(item => [item["endorsementId"], item])).values()],
                    claimSourceMasters: action.result.claimSource,
                    priorityMasters: action.result.priority,
                    batchTypeClaimsMasters: action.result.batchTypeClaims,
                    payableToMasters: action.result.payableTo,
                    departmentMasters: action.result.departmentMaster,
                    countryMasters: action.result.countryMaster,
                    poTypeMasters: action.result.poType,
                    monthMasters: action.result.month,
                    yearMasters: appUtility.getYearMasters(),
                    installmentConfigMasters: action.result.installmentConfig,
                    natureOfGroupMasters: action.result.natureOfGroup,

                    /*New masters*/
                    fobMasters: action.result.fobMasters,
                    providerTypeMasters: action.result.providerTypeMasters,
                    paymentModeMasters: action.result.paymentModeMasters,
                    encounterTypeMasters: action.result.encounterTypeMasters,
                    diagnosisTypeMasters: action.result.diagnosisTypeMasters,
                    memberFieldMasters: action.result.memberFieldMasters,
                    operatorMasters: action.result.operatorMasters,
                    //for claims
                    paymentTypeMasters: action.result.paymentTypeMasters,
                    gc03TypeMasters: action.result.gC03TypeMasters,
                    claimsSubmissionPortalMasters: action.result.claimsSubmissionPortalMasters,
                    claimsHealthAuthorityMasters: action.result.claimsHealthAuthorityMasters,
                }
            }
        case types.UPDATE_PRODUCT_BY_PRODUCT_TYPE_MICORESHARED: {

            if (action.payload.section == "policySearch") {
                return {
                    ...state,
                    policySearch: {
                        ...state.policySearch,
                        productMasters: action.payload.result,
                    }
                }
            }
            else if (action.payload.section == "groupRenewalSearch") {
                return {
                    ...state,
                    groupRenewalSearch: {
                        ...state.groupRenewalSearch,
                        productMasters: action.payload.result,
                    }
                }
            }
            else {
                return {
                    ...state
                }
            }
        }
        case types.GET_STATUS_MASTER_END_MICORESHARED:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    statusMasters: action.result.actionStatusType
                }
            }
        case types.GET_AGENT_MASTERS_END_MICORESHARED:
            {
                var agent = action.payload.agentMasters.length == 1 ? action.payload.agentMasters[0].agentId : state.policyInformation.agent;
                if (action.payload.section == "policySearch") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            agentSearchMasters: action.payload.agentMasters
                        },
                        policySearch: {
                            ...state.policySearch,
                            isAgentEnabled: action.payload.status
                        }
                    }
                }
                if (action.payload.section == "policyInformation") {
                    return {
                        ...state,
                        masters: {
                            ...state.masters,
                            agentMasters: action.payload.agentMasters
                        },
                        policyInformation: {
                            ...state.policyInformation,
                            isAgentEnabled: action.payload.status,
                            agent: agent
                        }
                    }
                }
            }
        case types.CLEAR_POLICY_SEARCH_PARAMS_MICORESHARED:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    product: null,
                    plan: null,
                    endorsementNo: null,
                    branch: null,
                    insuredName: null,
                    issueFromDate: appUtility.getMinusOneYearToCurrentDate(),
                    issueToDate: appUtility.getCurrentDate(),
                    policyNo: null,
                    businessType: null,
                    status: null,
                    emiratesId: null,
                    agent: null,
                    medicalCardNo: null,
                    stage: null,
                    isSubmit: false,
                    isAgentEnabled: false,
                    productType: null,
                    currentPolicyNo: null,
                    policySearchSubGrid: [],
                    productMasters: [
                        { productId: 0, productName: null, productCode: null }
                    ],
                    documentType: null,
                    oldPolicyNo: null,
                    assignedYN: null,
                    assignedUser: null,
                }
            }
        case types.UPDATE_POLICY_SEARCH_RESULT_MICORESHARED:
            let hasCheckedBoxInSearchResult = false
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    searchResult: action.pagedResult,
                    hasCheckedBoxInSearchResult: hasCheckedBoxInSearchResult
                }
            }
        case types.SHOW_TABLE_SEARCH_RESULTS_MICORESHARED:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    currentPolicyNo: null,
                    policySearchSubGrid: [],
                    showSearchResult: action.payload
                }
            }
        case types.SHOW_SEARCH_RESULTS_MICORESHARED:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    isSubmit: true
                }
            }
        case types.UPDATE_POLICY_SEARCH_PARAMS_MICORESHARED:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.INIT_POLICY_SEARCH: {
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    initOptions: action.options
                }
            }
        }
        case types.FILTER_ENDORSMENT_MASTER: {
            var filteredEndorsement = [];
            var unqiueEndorsements = [...new Map(state.masters.endorsementMastersOriginal.map(item => [item["endorsementId"], item])).values()]; //filter to display only unqiue endorsement types
            if (action.payload == constants.PRODUCT_TYPE_INDIVIDUAL) {
                unqiueEndorsements.forEach(e => e.endorsementId != constants.ENDO_CONFG_CHANGING_MEMBER_CATEGORY_DOWN && e.endorsementId != constants.ENDO_CONFG_CHANGING_MEMBER_CATEGORY_UPGRADE ? filteredEndorsement.push(e) : filteredEndorsement);
                console.log(filteredEndorsement);
            }
            else {
                filteredEndorsement = unqiueEndorsements;
            }
            return {
                ...state,
                masters: {
                    ...state.masters,
                    endorsementMasters: filteredEndorsement
                }
            }
        }
        case types.UPDATE_ENDORSEMENT_PARAMS_CHANGE: {
            return {
                ...state,
                policyEndorsement: {
                    ...state.policyEndorsement,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_TPADOWNLOAD_PARAMS_CHANGE: {
            return {
                ...state,
                tpaDownloadExcel: {
                    ...state.tpaDownloadExcel,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_TPA_DOWNLOAD_EXCEL: {
            return {
                ...state,
                tpaDownloadExcel: {
                    ...state.tpaDownloadExcel,
                    selectedTPA: null,
                    tpaId: null,
                    tpaName: null,
                    selectedExcelFormat: null
                }
            }
        }
        case types.UPDATE_NEW_ENDORSEMENT_POLICY_EXPIRY_DATE:
            return {
                ...state,
                policyEndorsement: {
                    ...state.policyEndorsement,
                    policyExpiryDate: appUtility.addDays(action.payload, 364) /*changed from 365 to 364*/
                }
            }
        case types.CLEAR_ENDORSEMENT_PARAMS: {
            return {
                ...state,
                policyEndorsement: {
                    ...state.policyEndorsement,
                    endorsementId: null,
                    endorsementTypeId: null,
                    endorsementNumber: null,
                    endorsementIssueDate: appUtility.getCurrentDate(),
                    endorsementSerialNumber: null,
                    endorsementEffectiveDateFrom: null,
                    endorsementEffectiveDateTo: null,
                    // documentNo: null,
                    //policyEffectiveDate: null,
                    //policyExpiryDate: null,
                    endorsementDescription: null,
                    endorsementReason: null,
                    partyAcCode: null,
                    partyName: null,
                    endorsementYear: appUtility.getCurrentYear(),
                    shortPeriod: null,
                    updateEntryExitDate: null,
                    AMLScreen: null,
                    rowVersion: null,
                    operationMode: null,
                    isRefundChargesYN: null,
                    endorsementSerialNumberToUpdate: null,
                    endorsementIdToUpdate: null,
                    isAddChargesYN: null,
                    policyId: null,
                    tariffCalculation: null,
                    reflectInMainPolicyYN: null,
                    isHAADPenaltyYN: false,
                }
            }
        }

        case types.UPDATE_IS_ACCOUNT_CODE_GENERATION: {
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    isAccountCodeGeneration: action.payload.value == true ? "Y" : "N"
                }
            }
        }
        case types.UPDATE_ACCOUNT_DETAILS_PARAMS: {
            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    [action.payload.name]: action.payload.value
                }
            }
        }

        case types.CLEAR_ACCOUNT_DETAILS_PARAMS: {
            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    searchText: '',
                    accountDetailResult: [],
                }
            }
        }
        case types.GET_ACCOUNT_DETAILS_END: {
            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    accountDetailResult: action.pagedResult,
                }
            }
        }
        case types.CLEAR_ACCOUNT_DETAILS_IN_ENDORSEMENT:
            return {
                ...state,
                policyEndorsement: {
                    ...state.policyEndorsement,
                    partyAcCode: '',
                    partyName: '',
                },
                policyInformation: {
                    ...state.policyInformation,
                    accountNo: '',
                    accountName: '',
                }
            }
        case types.GET_SUB_GRID_END:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    policySearchSubGrid: action.result,

                }
            }
        case types.CLEAR_SUB_GRID:
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    currentPolicyNo: null,
                    policySearchSubGrid: [],

                }
            }
        case types.UPDATE_MODAL_DISPLAY_STATE: {
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_TAB_MODAL_DISPLAY_STATE: {
            ///Deep copy of object to make rest of the policy tabs false 
            let modal = JSON.parse(JSON.stringify(state.modalsState));
            let checkTabStatus = ["showCategoryListModal", "showCheckListModal", "showPolicyTOBModal",
                "showLoadingDistributionModal", "showBaseBenefitModal", "showCostingSheetModal", "showSubgroupBillingModal", "showCommunicationModal", "showRemarksModal"]
            checkTabStatus = checkTabStatus.filter(x => x != action.payload.name)
            if (checkTabStatus.length < 9) {
                for (const key in modal) {
                    checkTabStatus.map((item) => {
                        if (modal.hasOwnProperty(key) && item == key) {
                            modal[key] = false
                            //console.log(`${key}: ${modal[key]}`);
                        }
                    })
                    if (key == action.payload.name) {
                        modal[key] = action.payload.value
                    }
                }
            }
            //Make all tabs false when new policy is selected
            else {
                for (const key in modal) {
                    checkTabStatus.map((item) => {
                        if (modal.hasOwnProperty(key) && item == key) {
                            modal[key] = false
                        }
                    })
                }
            }
            return {
                ...state,
                modalsState: modal
            }
        }
        case types.UPDATE_POLICY_EXPIRY_DATE_MICORESHARED:
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    expiryDate: appUtility.addDays(action.payload, 364) /*changed from 365 to 364*/
                }
            }
        case types.GET_REGULATORY_BY_EMIRATE_END:

            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    regulatoryAuthority: action.result.domainValue
                }
            }

        case types.UPDATE_POLICY_INFORMATION_PARAMS_MICORESHARED:
            {
                let isProductTypeIndiviual = state.policyInformation.productType == appConstants.PRODUCT_TYPE_INDIVIDUAL ? true : false;
                let checkVisaEmirates = state.policyInformation.checkVisaEmirate;
                if (action.payload.name == "visaEmirate" && (action.payload.value == appConstants.VISA_EMIRATE_ABU_DHABI || action.payload.value == appConstants.VISA_EMIRATE_AL_AIN) && !isProductTypeIndiviual) {
                    checkVisaEmirates = true
                }
                else if (action.payload.name == "visaEmirate" && (action.payload.value != appConstants.VISA_EMIRATE_ABU_DHABI && action.payload.value != appConstants.VISA_EMIRATE_AL_AIN) && !isProductTypeIndiviual) {
                    checkVisaEmirates = false
                }
                return {
                    ...state,
                    policyInformation: {
                        ...state.policyInformation,
                        [action.payload.name]: action.payload.value,
                        checkVisaEmirate: checkVisaEmirates
                    }
                }
            }
        case types.UPDATE_POLICY_INSURED_INFORMATION_CODES_MICORESHARED:
            return {
                ...state,
                insuredInformation: {
                    ...state.insuredInformation,
                    insuredCodes: action.payload
                }
            }
        case types.ADD_POLICY_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED:

            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    insuredCode: action.payload.insuredcode,
                    insuredName: action.payload.insuredname,
                    showAddInsured: false

                }
            }
        case types.UPDATE_CURRENT_POLICY_ID_MICORESHARED:
            let stage = (action.payload.stage === 1 || action.payload.stage === 2) ? false : true
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    currentPolicyId: action.payload.policyNo,
                    currentPolicyStage: stage,
                }
            }
        case types.UPDATE_POLICY_INSURED_TYPE_INDIVIDUAL_MICORESHARED:
            return {
                ...state,
                insuredInformation: {
                    ...state.insuredInformation,
                    isInsuredTypeIndividual: action.payload.status
                }
            }
        case types.UPDATE_POLICY_PROSPECT_TYPE_INDIVIDUAL_MICORESHARED:
            return {
                ...state,
                prospectInformation: {
                    ...state.prospectInformation,
                    isInsuredTypeIndividual: action.payload.status
                }
            }
        case types.COLLAPSE_POLICY_SEARCH_RESULT_MICORESHARED:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    searchResultClass: collapseClass
                }
            }

        case types.COLLAPSE_POLICY_SEARCH_MICORESHARED:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                policySearch: {
                    ...state.policySearch,
                    searchClass: collapseClass
                }
            }
        case types.CLEAR_POLICY_INFORMATION_PARAMS_MICORESHARED:
            {
                let endorsementType = state.policyEndorsement.endorsementTypeId;
                if (endorsementType == appConstants.ENDORSEMENT_TYPE_GENERAL_ENDORSEMENT) {
                    return {
                        ...state,
                        policyInformation: {
                            ...state.policyInformation,
                            scheme: null,
                            insuredVisaType: null,
                            tariffCalculation: null,
                        }
                    }
                }
                if (endorsementType == appConstants.ENDORSEMENT_TYPE_CHANGE_OF_CLIENT) {
                    return {
                        ...state,
                        policyInformation: {
                            ...state.policyInformation,
                            accountNo: null,
                            accountName: null,
                            insuredCode: null,
                            insuredName: null,
                        }
                    }
                }
                if (endorsementType == null) {
                    return {
                        ...state,
                        policyInformation: {
                            ...state.policyInformation,
                            branch: null,
                            accountNo: null,
                            accountName: null,
                            visaEmirate: null,
                            inceptionDate: null,
                            expiryDate: null,
                            businessType: null,
                            agent: null,
                            tariffCalculation: null,
                            childMinAge: null,
                            childMaxAge: null,
                            premiumForeignCurr: null,
                            premiumLocalCurr: null,
                            //stage: null,
                            scheme: null,
                            regulatoryAuthority: null,
                            jurisdictionAr: null,
                            jurisdictionEn: null,
                            subgroupBilling: null,
                            isFac: null,
                            cashMode: null,
                            premiumMode: null,
                            installment: null,
                            installmentType: null,
                            installmentNos: null,
                            cashTaggedUser: null,
                            markForCollectionCash: null,
                            haadTaggedUser: null,
                            haadStatus: null,
                            markForCollectionHaad: null,
                            vatLocation: appConstants.COUNTRY_UNITED_ARAB_EMIRATES,
                            promoCode: null,
                            remarks: null,
                            checkVisaEmirate: false,
                            isSubgroupExisting: false,
                            currentEndorsementId: null,
                            paidAmount: null,
                            outstandingAmount: null,
                            treatyId: null,
                            // actionStatus: null,
                            // 
                            // issueDate: null,
                            // policyValidityDays: null,
                            // policyExpiry: null,
                            //  
                            //  
                            // documentType: "New Policy",

                            //promoCode: null,
                            // insuredType: null,
                            //insuredVisaType: null,
                            // quotationNo: null,
                            // oldPolicyNumber: null,
                            // approvalDate: null,
                            // approvedBy: null,
                            // underwritingYear: null,
                            //tpaName: null,
                            // maternityMinAge: null,
                            // maternityMaxAge: null,

                            // isAgentEnabled: false,
                            // currentPolicyId: null,
                            //  currentPolicyStage: null,
                            // showAddInsured: true,
                            //  customerId: null,
                            //rate: 0,

                        }
                    }
                }
            }
        case types.GET_POLICY_INSURED_INFORMATION_END_MICORESHARED:
            console.log("inured result", action.payload);
            return {
                ...state,
                insuredInformation: {
                    ...state.insuredInformation,
                    insuredId: action.payload.insureD_ID,
                    insuredTransId: action.payload.insuredTransId,
                    insuredType: action.payload.insureD_TYPE,
                    isInsuredTypeIndividual: action.payload.insureD_TYPE == appConstants.INSURED_TYPE_INDIVIDUAL ? true : false,
                    emiratesId: action.payload.emirateS_ID,
                    mobile: action.payload.insureD_TYPE != appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.phonE_NO,
                    salutation: action.payload.salutation == null ? (action.payload.insureD_TYPE != appConstants.INSURED_TYPE_INDIVIDUAL ? constants.DOMAIN_SALUTATION_MS_COMPANY : null) : action.payload.salutation,
                    firstName: action.payload.firsT_NAME_EN,
                    middleName: action.payload.middlE_NAME_EN,
                    lastName: action.payload.lasT_NAME_EN,
                    gender: action.payload.gender,
                    maritalSatus: action.payload.maritaL_STATUS,
                    dateofBirth: action.payload.dob == null ? null : appUtility.formatDate(action.payload.dob),
                    nationality: action.payload.nationality,
                    email: action.payload.insureD_TYPE != appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.emaiL_ID,
                    companyCRNumber: action.payload.companY_CR_NO,
                    policysalutation: action.payload.salutation,
                    fullName: action.payload.insureD_TYPE != appConstants.INSURED_TYPE_INDIVIDUAL ? action.payload.fulL_NAME_EN : "",
                    tradeLicenseNo: action.payload.tradE_LICENSE_NO,
                    tradeLicenseExpiryDate: action.payload.tradE_LICENSE_EXPIRY_DT == null ? "" : appUtility.formatDate(action.payload.tradE_LICENSE_EXPIRY_DT),
                    policyEmail: action.payload.insureD_TYPE == appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.emaiL_ID,
                    entityType: action.payload.entitY_TYPE,
                    entityId: action.payload.entitY_ID,
                    companyMobile: action.payload.insureD_TYPE == appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.phonE_NO,
                    fullNameArabic: action.payload.fulL_NAME_AR,
                    firstNameAr: action.payload.firsT_NAME_AR,
                    middleNameAr: action.payload.middlE_NAME_AR,
                    lastNameAr: action.payload.lasT_NAME_AR,
                    insuredId: action.payload.insureD_ID,
                    isInsuredYN: action.payload.isInsuredYN == null ? "N" : action.payload.isInsuredYN,
                    poBox: action.payload.pO_BOX,
                    residenceVisa: action.payload.residencE_VISA,
                    sponsorType: action.payload.sponsoR_TYPE_ID,
                    address1: action.payload.addresS1,
                    address2: action.payload.addresS2,
                    amlType: action.payload.amL_TYPE == 0 ? null : action.payload.amL_TYPE,
                    trn: action.payload.trn,
                    vatLocation: action.payload.vaT_LOCATION_ID,
                    passportNo: action.payload.passporT_NO,
                }
            }
        case types.GET_POLICY_PROSPECT_INFORMATION_END_MICORESHARED: {
            return {
                ...state,
                prospectInformation: {
                    ...state.prospectInformation,
                    insuredType: action.payload.insuredType,
                    salutation: action.payload.salutation,
                    fullName: action.payload.fullName,
                    companyCRNumber: action.payload.companyCRNumber,
                    tradeLicenseNo: action.payload.tradeLicenseNumber,
                    tradeLicenseExpiryDate: action.payload.tradeLicenseExpiryDate == null ? null : appUtility.formatDate(action.payload.tradeLicenseExpiryDate),
                    mobile: action.payload.phoneNumber,
                    policyEmail: action.payload.email,
                    entityId: action.payload.entityId,
                    entityType: action.payload.entityTypeId,

                    firstName: action.payload.firstName,
                    dateofBirth: action.payload.dateOfBirth == null ? null : appUtility.formatDate(action.payload.dateOfBirth),
                    gender: action.payload.gender,
                    emiratesId: action.payload.emiratesId,
                    nationality: action.payload.nationality,
                    maritalStatus: action.payload.maritalStatus
                }
            }
        }
        case types.GET_CURRENT_POLICY_INFORMATION_END_MICORESHARED:
            {

                let checkVisaEmirates = state.policyInformation.checkVisaEmirate;
                if (action.payload.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || action.payload.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) {
                    checkVisaEmirates = true
                }
                else {
                    checkVisaEmirates = false
                }
                return {
                    ...state,
                    masters: {
                        ...state.masters,
                        planMasters: action.payload.masters.miCoreMaster.planTypeMasters
                    },
                    policyInformation: {
                        ...state.policyInformation,
                        totalMembers: action.payload.totalMembers,
                        totalPrincipals: action.payload.totalPrincipals,
                        totalDependents: action.payload.totalDependents,
                        policyId: action.payload.documentId == null ? null : action.payload.documentId,
                        proposalId: action.payload.proposalId,
                        quotationId: action.payload.quotationId,
                        policyNo: action.payload.policyNo == null ? "" : action.payload.policyNo,
                        quotationNo: action.payload.quotationNo == null ? "" : action.payload.quotationNo,
                        department: action.payload.department == null ? "" : action.payload.department,
                        departmentName: action.payload.department == null ? "" : action.payload.departmentName,
                        stage: action.payload.stage == null ? "" : action.payload.stage,
                        actionStatus: action.payload.actionStatus == null ? "" : action.payload.actionStatus,
                        approvalDate: action.payload.approvalDate == null ? "" : new Date(action.payload.approvalDate).toLocaleString('en-GB'),
                        approvedBy: action.payload.approvedBy == null ? "" : action.payload.approvedBy,
                        underwritingYear: action.payload.uwYear == null ? "" : action.payload.uwYear,
                        issueDate: action.payload.issueDate == null ? new Date() : appUtility.formatDate(action.payload.issueDate),
                        oldPolicyNumber: action.payload.oldPolicyNumber == null ? "" : action.payload.oldPolicyNumber,
                        policyExpiry: action.payload.policyExpiry == null ? "" : appUtility.formatDate(action.payload.policyExpiry),
                        product: action.payload.product,
                        productType: action.payload.productType,
                        plan: action.payload.plan,
                        branch: action.payload.branch,
                        insuredCode: action.payload.insuredCode,
                        insuredName: action.payload.insuredName,
                        prospectCode: action.payload.prospectCode,
                        prospectName: action.payload.prospectName,
                        insuredType: action.payload.insuredType,
                        isAccountCodeGeneration: action.payload.isAccountCodeGeneration,
                        accountName: action.payload.accountName,
                        accountNo: action.payload.accountNo,
                        scheme: action.payload.scheme,
                        insuredVisaType: action.payload.insuredVisaType,
                        documentType: action.payload.documentType,
                        inceptionDate: action.payload.inceptionDate == null ? action.payload.inceptionDate : appUtility.formatDate(action.payload.inceptionDate),
                        expiryDate: action.payload.expiryDate == null ? action.payload.expiryDate : appUtility.formatDate(action.payload.expiryDate),
                        visaEmirate: action.payload.visaEmirate,
                        ageSlab: action.payload.ageSlab,
                        tpaName: action.payload.tpaName,
                        maternityMaxAge: action.payload.maternityMaxAge,
                        maternityMinAge: action.payload.maternityMinAge,
                        childMaxAge: action.payload.childMaxAge,
                        childMinAge: action.payload.childMinAge,
                        businessType: action.payload.businessType,
                        agent: action.payload.agent == null ? "" : action.payload.agent,
                        tariffCalculation: action.payload.tariffCalculation,
                        premiumForeignCurr: action.payload.premiumForeignCurr,
                        premiumLocalCurr: action.payload.premiumLocalCurr,
                        rate: action.payload.rate == null ? 0 : action.payload.rate,
                        promoCode: action.payload.promoCode == null ? "" : action.payload.promoCode,
                        customerId: action.payload.customerId,
                        goToMemberInformation: false,
                        productMasters: action.payload.masters.products,
                        planMasters: action.payload.masters.miCoreMaster.planTypeMasters,
                        ageMasters: action.payload.masters.ageMaster,
                        branchMasters: action.payload.masters.branch,
                        isInsuredYN: action.payload.isInsuredYN,
                        productType: action.payload.productType,
                        checkVisaEmirate: checkVisaEmirates,
                        cashTaggedUser: action.payload.cashTaggedUser,
                        haadTaggedUser: action.payload.haadTaggedUser,
                        jurisdictionAr: action.payload.jurisdictionAr,
                        jurisdictionEn: action.payload.jurisdictionEn,
                        subgroupBilling: action.payload.subgroupBilling,
                        isFac: action.payload.fac,
                        renewedTo: action.payload.renewedTo,
                        regulatoryAuthority: action.payload.regulatoryAuthority,
                        vatLocation: action.payload.vatLocation,
                        remarks: action.payload.remarks,
                        cashMode: action.payload.cashMode,
                        premiumMode: action.payload.premiumMode,
                        installment: action.payload.installment,
                        installmentNos: action.payload.installmentNos,
                        installmentType: action.payload.installmentType,
                        markForCollectionCash: action.payload.markForCollecionCash,
                        markForCollectionHaad: action.payload.markForCollecionHaad,
                        stageId: action.payload.stageId,
                        actionStatusId: action.payload.actionStatusId,
                        netPremium: action.payload.netPremium,
                        isWorkFlowProcessInProgressYN: action.payload.isWorkFlowProcessInProgressYN == 'Y' ? true : false,
                        isSubgroupExisting: action.payload.isSubgroupExisting,
                        subProductTypeId: action.payload.subTypeId,
                        isProductSubTypeYN: action.payload.isSubTypeYN,
                        lineOfBusiness: action.payload.lineOfBusiness,
                        currentEndorsementId: action.payload.currentEndorsementId,
                        cashReceiptNo: action.payload.cashReceiptNo,
                        haadReceiptNo: action.payload.haadReceiptNo,
                        isMigratedYN: action.payload.isMigratedYN,
                        isVatApplicableYN: action.payload.isVatApplicableYN == "Y" ? true : false,
                        ageBandBatchId: action.payload.ageBandBatchId,
                        paidAmount: action.payload.paidAmount,
                        outstandingAmount: action.payload.outstandingAmount, 
                        treatyId: action.payload.treatyId,
                      
                    },
                    policyEndorsement: {
                        ...state.policyEndorsement,
                        insuredTransId: action.payload.insuredTransId,
                        documentNo: action.payload.policyNo == null ? "" : action.payload.policyNo,
                        policyIssueDate: action.payload.issueDate == null ? null : appUtility.formatDate(action.payload.issueDate),
                        policyEffectiveDate: action.payload.inceptionDate == null ? action.payload.inceptionDate : appUtility.formatDate(action.payload.inceptionDate),
                        policyExpiryDate: action.payload.expiryDate == null ? null : appUtility.formatDate(action.payload.expiryDate),
                        documentType: action.payload.documentType,
                        product: action.payload.productType,
                        branch: action.payload.branch,
                        endorsementId: action.payload.endorsementId,
                        endorsementTypeId: action.payload.endorsementType,
                        endorsementNumber: action.payload.endorsementNo,
                        endorsementCode: action.payload.endorsementCode,
                        endorsementDescription: action.payload.endorsementDesc,
                        endorsementSerialNumber: action.payload.endorsementSlNo,
                        endorsementYear: action.payload.endorsementYear == null ? appUtility.getCurrentYear() : action.payload.endorsementYear,
                        endorsementIssueDate: action.payload.endorsementIssueDate == null ? appUtility.formatDate(new Date()) : appUtility.formatDate(action.payload.endorsementIssueDate),
                        endorsementEffectiveDateFrom: action.payload.endorsementEffectiveDate == null ? null : appUtility.formatDate(action.payload.endorsementEffectiveDate),
                        endorsementEffectiveDateTo: action.payload.endorsementEffectiveDate == null ? null : appUtility.formatDate(action.payload.endorsementExpiryDate),
                        endorsementApprovedBy: action.payload.endorsementApprovedBy,
                        endorsementApprovedDate: action.payload.endorsementApprovedDate == null ? null : appUtility.formatDate(action.payload.endorsementApprovedDate),
                        endorsementStage: action.payload.endorsementStage,
                        endorsementStageId: action.payload.endorsementStageId,
                        endorsementStatus: action.payload.endorsementStatus,
                        endorsementStatusId: action.payload.endorsementStatusId,
                        endorsementReason: action.payload.endorsementReason,
                        endorsementNo: action.payload.endorsementNo,
                        partyAcCode: action.payload.partyAcCode,
                        partyName: action.payload.partyName,
                        shortPeriod: action.payload.shortPeriod == 'Y' ? true : false,
                        updateEntryExitDate: action.payload.updateEntryExitDate == 'Y' ? true : false,
                        AMLScreen: action.payload.amlScreen == 'Y' ? true : false,
                        policyId: action.payload.documentId == null ? null : action.payload.documentId,
                        rowVersion: action.payload.rowVersion,
                        netPremium: action.payload.netPremium,
                        isRefundChargesYN: action.payload.isRefundChargesYN,
                        endorsementSerialNumberToUpdate: action.payload.endorsementSerialNumberToUpdate,
                        endorsementIdToUpdate: action.payload.endorsementIdToUpdate,
                        isAddChargesYN: action.payload.isAddChargesYN,
                        tariffCalculation: action.payload.tariffCalculation,
                        reflectInMainPolicyYN: action.payload.reflectInMainPolicyYN,
                        isHAADPenaltyYN: action.payload?.isHaadRefundYN == 'Y' ? true : false,

                    },
                    accountDetails: {
                        ...state.accountDetails,
                        searchText: action.payload.accountNo,
                    },
                    summaryStageStatus: {
                        ...state.summaryStageStatus,
                        stage: action.payload.endorsementStageId ?? action.payload.stageId ?? "",
                        actionStatus: action.payload.endorsementStatusId ?? action.payload.actionStatusId ?? "",
                    }

                }
            }
        case types.HIDE_POLICY_INSURED_CODE_BUTTON_MICORESHARED:
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    showAddInsured: action.payload.status
                }
            }
        case types.GET_CATEGORY_DETAILS_BY_PROPOSAL_END_MICORESHARED: {
            return {
                ...state,
                category: {
                    ...state.category,
                    result: action.result,
                }
            }
        }
        case types.UPDATE_EDITABLE_FEILDS_MICORESHARED:
            {
                return {
                    ...state,
                    isFeildsDisabled: action.payload
                }
            }
        case types.GET_POLICY_TOB_MASTER_END_MICORESHARED: {
            return {
                ...state,
                policyTOB: {
                    ...state.policyTOB,
                    result: action.result,
                }
            }
        }
        case types.UPDATE_POLICY_TOB_PARAMS_MICORESHARED:
            return {
                ...state,
                policyTOB: {
                    ...state.policyTOB,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_CATEGORY_MASTERS_END_MICORESHARED: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    categoryMasters: action.payload
                }
            }
        }
        case types.GET_POLICY_LOADING_DISTRIBUTION_END_MICORESHARED: {
            return {
                ...state,
                loadingDistribution: {
                    ...state.loadingDistribution,
                    result: action.result,
                }
            }
        }
        case types.GET_POLICY_BASE_BENEFIT_MASTER_END_MICORESHARED: {
            return {
                ...state,
                benefit: {
                    ...state.benefit,
                    result: action.result,
                }
            }
        }
        case types.GET_POLICY_COSTING_SHEET_END_MICORESHARED: {
            var currentPage = constants.COSTING_SHEET_FIRST_PAGE;
            var pageSize = constants.COSTING_SHEET_PAGE_SIZE
            var sort = null
            var totalCount = action.result.length;
            var totalPages = Math.ceil(totalCount / constants.COSTING_SHEET_PAGE_SIZE)
            var hasNextPage = currentPage == totalPages ? false : true
            var hasPreviousPage = false
            var result = action.result.slice(0, constants.COSTING_SHEET_PAGE_SIZE);
            var pagedResult = {
                currentPage: currentPage,
                pageSize: pageSize,
                sort: sort,
                totalCount: totalCount,
                totalPages: totalPages,
                hasNextPage: hasNextPage,
                hasPreviousPage: hasPreviousPage,
                result: result
            }
            return {
                ...state,
                costingSheet: {
                    ...state.costingSheet,
                    result: pagedResult,
                    resultOriginal: action.result,
                    filterdResults: action.result,
                    benefitName: null,
                    categoryName: null,
                    networkName: null,
                    genderName: null,
                    ageSlab: null,
                    relation: null,
                }
            }
        }
        case types.GET_POLICY_COSTING_SHEET_DETAILS_PAGED_RESULT_MICORESHARED:
            // var costingSheetDetails = state.costingSheet.resultOriginal;
            var costingSheetDetails = state.costingSheet.filterdResults;
            var currentPage = action.payload.page;
            var pageSize = constants.COSTING_SHEET_PAGE_SIZE
            var sort = null
            var totalCount = costingSheetDetails.length;
            var totalPages = Math.ceil(totalCount / constants.COSTING_SHEET_PAGE_SIZE)
            currentPage = currentPage < constants.COSTING_SHEET_FIRST_PAGE ? constants.COSTING_SHEET_FIRST_PAGE : currentPage;
            currentPage = currentPage > totalPages ? totalPages : currentPage;
            var hasNextPage = currentPage == totalPages ? false : true
            var hasPreviousPage = currentPage == constants.COSTING_SHEET_FIRST_PAGE ? false : true;
            var startingIndex = constants.COSTING_SHEET_PAGE_SIZE * currentPage - constants.COSTING_SHEET_PAGE_SIZE;
            var endingIndex = startingIndex + constants.COSTING_SHEET_PAGE_SIZE
            var filteredPages = costingSheetDetails.slice(startingIndex, endingIndex);
            var pagedResult = {
                currentPage: currentPage,
                pageSize: pageSize,
                sort: sort,
                totalCount: totalCount,
                totalPages: totalPages,
                hasNextPage: hasNextPage,
                hasPreviousPage: hasPreviousPage,
                result: filteredPages
            }
            return {
                ...state,
                costingSheet: {
                    ...state.costingSheet,
                    result: pagedResult,
                }
            }


        case types.UPDATE_TPA_FEE_PARAMS: {
            let Arr = {
                ...state.tpaFees,
                [action.payload.name]: action.payload.value
            }
            var ratetoapply = 0;
            for (let i = 0; i < state.tpaMasters.tpaMaster.length; i++) {
                if (Arr.tpaName == state.tpaMasters.tpaMaster[i].tpaId) {
                    ratetoapply = state.tpaMasters.tpaMaster[i].tpaRate;
                }
            }
            let vatrate = 0;
            let productCode1 = 0;
            let vattype = 0;
            for (let i = 0; i < state.masters.productMasters.length; i++) {
                if (state.quoteInformation.product == state.masters.productMasters[i].productId) {
                    productCode1 = state.masters.productMasters[i].productCode;

                }
            }
            for (let i = 0; i < state.TaxTable.taxMaster.length; i++) {
                if (productCode1 == state.TaxTable.taxMaster[i].taxrProductId) {
                    vatrate = state.TaxTable.taxMaster[i].taxrRatePerc;
                    vattype = state.TaxTable.taxMaster[i].taxrId;
                }
            }
            let grosspremiumC = state.finalAmounts.grossPremiumLC ? state.finalAmounts.grossPremiumLC : 0;
            //let rateC = Arr.rate == null ? 0 : Arr.rate;
            let rateC = ratetoapply;
            let amountC = (((rateC / 100) * grosspremiumC));
            let vatC = (((vatrate / 100) * (Number(amountC))));
            let netC = (Number(amountC) + (((vatrate / 100) * (Number(amountC)))));
            let tpaNameC = Arr.tpaName;
            let selfBillingC = Arr.selfBilling;
            let vatTypeC = vattype;

            return {
                ...state,
                tpaFees: {
                    ...state.tpaFees,
                    tpaName: tpaNameC,
                    selfBilling: selfBillingC,
                    rate: appUtility.round(rateC),
                    amount: appUtility.round(amountC),
                    vatType: vatTypeC,
                    vat: appUtility.round(vatC),
                    netAmount: appUtility.round(netC),
                    vatPerc: appUtility.round(vatrate),
                }
            }
        }
        case types.UPDATE_TPA_SELF_BILLING_CHANGE:
            return {
                ...state,
                tpaFees: {
                    ...state.tpaFees,
                    selfBilling: action.payload.value
                }
            }
        case types.UPDATE_BROKERAGE_INFORMATION_PARAMS: {
            {
                let Arr1 = {
                    ...state.brokerageInfo,
                    [action.payload.name]: action.payload.value
                }
                console.log("action.payload.value", action.payload.value)
                let grosspremiumC1 = state.finalAmounts.grossPremiumLC == null ? Number(0) : state.finalAmounts.grossPremiumLC;

                let rateC1 = 0;
                let amountC1 = 0;
                let vatC1 = 0;
                let netC1 = 0;
                let brokerAmt = 0;
                let vattype2 = state.brokerageInfo.vatType;
                let vatrate2 = state.brokerageInfo.vatPerc;
                let brokerNameC1 = Arr1.tpaName;
                let selfBillingC1 = Arr1.selfBilling;
                if (state.policyEndorsement.endorsementTypeId == appConstants.ENDORSEMENT_TYPE_CHANGE_IN_BROKERAGE) {
                    if (action.payload.name == "rate") {
                        grosspremiumC1 = state.brokerageInfo.originalGrossPremium == null ? Number(0) : state.brokerageInfo.originalGrossPremium;
                        rateC1 = Arr1.rate == null || Arr1.rate == "" ? Number(0) : Arr1.rate;
                        if (rateC1 > state.brokerageInfo.commMaxPerc) {
                            rateC1 = state.brokerageInfo.commMaxPerc;
                        }
                        amountC1 = (((rateC1 / 100) * grosspremiumC1));
                        vatC1 = vatrate2 == null ? Number(0) : (((vatrate2 / 100) * (Number(amountC1))));
                        if (state.brokerageInfo.isVatApplicable == 'N') {
                            vatC1 = 0;
                        }
                        netC1 = (Number(amountC1) + Number(vatC1));
                    }
                    else if (action.payload.name == "amount") {
                        grosspremiumC1 = state.brokerageInfo.originalGrossPremium == null ? Number(0) : state.brokerageInfo.originalGrossPremium;
                        amountC1 = Arr1.amount == null || Arr1.amount == "" ? Number(0) : Arr1.amount;

                        if (rateC1 > state.brokerageInfo.commMaxPerc) {
                            rateC1 = state.brokerageInfo.commMaxPerc;
                        }
                        rateC1 = (amountC1 * 100) / grosspremiumC1;


                        vatC1 = vatrate2 == null ? Number(0) : (((vatrate2 / 100) * (Number(amountC1))));
                        if (state.brokerageInfo.isVatApplicable == 'N') {
                            vatC1 = 0;
                        }
                        netC1 = (Number(amountC1) + Number(vatC1));
                    }

                } else {
                    rateC1 = Arr1.rate == null || Arr1.rate == "" ? Number(0) : Arr1.rate;
                    //alert(state.checkPermissions.hasIndividualBrokerCommEdit)
                    if (!state.checkPermissions.hasIndividualBrokerCommEdit) {
                        if (rateC1 > state.brokerageInfo.commMaxPerc) {
                            rateC1 = state.brokerageInfo.commMaxPerc;
                            console.log("rateC max", rateC1);

                        }
                        if (rateC1 < state.brokerageInfo.commMinPerc) {
                            rateC1 = state.brokerageInfo.commMinPerc;
                            console.log("rateC min", rateC1);
                        }
                    }
                    amountC1 = (((rateC1 / 100) * grosspremiumC1));
                    vatC1 = vatrate2 == null ? Number(0) : (((vatrate2 / 100) * (Number(amountC1))));
                    if (state.brokerageInfo.isVatApplicable == 'N') {
                        vatC1 = 0;
                    }
                    // netC1 = (Number(amountC1) + (((vatrate2 / 100) * (Number(amountC1)))));
                    netC1 = (Number(amountC1) + (vatC1));
                }
                return {
                    ...state,
                    brokerageInfo: {
                        ...state.brokerageInfo,
                        brokerName: brokerNameC1,
                        selfBilling: selfBillingC1,
                        rate: appUtility.round(rateC1),
                        amount: appUtility.round(amountC1),
                        vatType: vattype2,
                        vat: appUtility.round(vatC1),
                        netAmount: appUtility.round(netC1),
                        vatPerc: appUtility.round(vatrate2),
                        //[action.payload.name]: action.payload.value
                    }
                }
            }
        }
        case types.UPDATE_BROKERAGE_SELF_BILLING_CHANGE:
            return {
                ...state,
                brokerageInfo: {
                    ...state.brokerageInfo,
                    selfBilling: action.payload.value
                }
            }
        case types.UPDATE_MEMBER_PREMIUM_SEARCH_PARAMS: {
            let memberTableValuesOriginal = state.memberPremium;
            let filteredValues = memberTableValuesOriginal.result.filter((e) => e.fullName.toLowerCase().match(action.payload.value.toLowerCase()));
            console.log(filteredValues)
            return {
                ...state,

                memberPremiumFiltered: {
                    ...state.memberPremiumFiltered,
                    result: filteredValues

                }
            }

        }
        case types.CALCULATE_GROSS_PREMIUM: {
            var totalPremiumAmount = 0;
            var basePremiumTotal = 0;
            var chargeswithOutVAT = 0;
            var uwAmt = 0;
            var netAmt = 0;
            var netPERc = 0;
            var uwPerc = 0;
            var autoAmt = 0;
            var autoPerc = 0;
            var disAmt = 0;
            var disPerc = 0;
            var chargesVAT = 0;
            var vatAmt = 0;
            var renewalAmt = 0;
            var renewalPerc = 0;
            for (let i = 0; i < state.memberPremiumFiltered.result.length; i++) {
                basePremiumTotal += Number(state.memberPremiumFiltered.result[i].memberPremiumPerPerson == null ? 0 : state.memberPremiumFiltered.result[i].memberPremiumPerPerson);
                totalPremiumAmount += Number(state.memberPremiumFiltered.result[i].memberNetPremium == null ? 0 : state.memberPremiumFiltered.result[i].memberNetPremium);
                uwAmt += Number(state.memberPremiumFiltered.result[i].uwLoadingAMT == null ? 0 : state.memberPremiumFiltered.result[i].uwLoadingAMT);
                netAmt += Number(state.memberPremiumFiltered.result[i].netLoadingAMT == null ? 0 : state.memberPremiumFiltered.result[i].netLoadingAMT);
                netPERc += Number(state.memberPremiumFiltered.result[i].netLoadingPerc == null ? 0 : state.memberPremiumFiltered.result[i].netLoadingPerc);
                uwPerc += Number(state.memberPremiumFiltered.result[i].uwLoadingPerc == null ? 0 : state.memberPremiumFiltered.result[i].uwLoadingPerc);
                autoAmt += Number(state.memberPremiumFiltered.result[i].autoLoadingAMT == null ? 0 : state.memberPremiumFiltered.result[i].autoLoadingAMT);
                autoPerc += Number(state.memberPremiumFiltered.result[i].autoLoadingPerc == null ? 0 : state.memberPremiumFiltered.result[i].autoLoadingPerc);
                disAmt += Number(state.memberPremiumFiltered.result[i].discountAMT == null ? 0 : state.memberPremiumFiltered.result[i].discountAMT);
                disPerc += Number(state.memberPremiumFiltered.result[i].discountPerc == null ? 0 : state.memberPremiumFiltered.result[i].discountPerc);
                vatAmt += Number(state.memberPremiumFiltered.result[i].vatAmount == null ? 0 : state.memberPremiumFiltered.result[i].vatAmount);
                renewalAmt += Number(state.memberPremiumFiltered.result[i].renewalLoadingAMT == null ? 0 : state.memberPremiumFiltered.result[i].renewalLoadingAMT);
                renewalPerc += Number(state.memberPremiumFiltered.result[i].renewalLoadingPerc == null ? 0 : state.memberPremiumFiltered.result[i].renewalLoadingPerc);
            }
            var TotalCharges = 0;
            for (let i = 0; i < state.charges.chargesTable.length; i++) {
                TotalCharges += Number(state.charges.chargesTable[i].chargeLCAMT == null ? 0 : state.charges.chargesTable[i].chargeLCAMT);
                chargesVAT += Number(state.charges.chargesTable[i].vatamt == null ? 0 : state.charges.chargesTable[i].vatamt);
                chargeswithOutVAT += Number(state.charges.chargesTable[i].memberCharges == null ? 0 : state.charges.chargesTable[i].memberCharges);
            }
            totalPremiumAmount = totalPremiumAmount;
            TotalCharges = TotalCharges;
            return {
                ...state,
                charges: {
                    ...state.charges,
                    grossPremiumSection: appUtility.round(totalPremiumAmount),
                    grossChargesSection: appUtility.round(TotalCharges),
                    grossChargesWithoutVAT: appUtility.round(chargeswithOutVAT),
                    basePremiumTotal: appUtility.round(basePremiumTotal),
                    uwAmt: appUtility.round(uwAmt),
                    netAmt: appUtility.round(netAmt),
                    netPERc: appUtility.round(netPERc),
                    uwPerc: appUtility.round(uwPerc),
                    autoAmt: appUtility.round(autoAmt),
                    autoPerc: appUtility.round(autoPerc),
                    disAmt: appUtility.round(disAmt),
                    disPerc: appUtility.round(disPerc),
                    chargesVAT: appUtility.round(chargesVAT),
                    vatAmount: appUtility.round(vatAmt),
                    renewalAmt: appUtility.round(renewalAmt),
                    renewalPerc: appUtility.round(renewalPerc)
                }
            }

        }
        case types.UPDATE_POLICY_CUSTOMER_AGE_MICORESHARED:
            return {
                ...state,
                customerInformation: {
                    ...state.customerInformation,
                    age: action.age
                }
            }
        case types.UPDATE_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED:
            return {
                ...state,
                insuredInformation: {
                    ...state.insuredInformation,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.CLEAR_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED:

            return {
                ...state,
                insuredInformation: {
                    ...state.insuredInformation,
                    insuredId: null,
                    insuredType: null,
                    emiratesId: null,
                    mobile: null,
                    salutation: null,
                    firstName: null,
                    middleName: null,
                    lastName: null,
                    gender: null,
                    maritalSatus: null,
                    dateofBirth: null,
                    nationality: null,
                    email: null,
                    policyInsuredType: null,
                    policyPolicyType: null,
                    companyCRNumber: null,
                    policysalutation: null,
                    fullName: null,
                    tradeLicenseNo: null,
                    tradeLicenseExpiryDate: null,
                    policyEmail: null,
                    entityType: null,
                    entityId: null,
                    isInsuredTypeIndividual: true,
                    companyMobile: null,
                    nameSearch: null,
                    fullNameArabic: null,
                    showAddnewSection: false,
                    customerId: null,
                    customerInPolicyYN: 'N',
                }

            }

        /***** Member Page *****/

        case types.GO_TO_POLICY_MEMBER_INFORMATION_MICORESHARED:
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    goToMemberInformation: action.payload
                }
            }
        case types.UPDATE_IS_ADDITION_OF_MEMBER: {
            let memberInceptionDate = action.payload ? state.initOptions.moduleType == appConstants.ENDORSEMENT_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyEndorsement.endorsementEffectiveDateFrom :
                state.initOptions.moduleType == appConstants.POLICY_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyInformation.inceptionDate : null : null;
            let memberExpiryDate = state.policyInformation.expiryDate;
            return {
                ...state,
                [action.payload.section]: {
                    ...state[action.payload.section],
                    params: {
                        ...state[action.payload.section].params,
                        memberId: null,
                        memberTransId: null,
                        employeeId: null,
                        photoId: null,
                        photoName: null,
                        photoSrc: null,
                        salutation: null,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        plan: state.policyInformation.productType == appConstants.PRODUCT_TYPE_INDIVIDUAL ? state.policyInformation.plan + " null" : null,
                        maritalStatus: null,
                        dateofBirth: null,
                        age: null,
                        gender: null,
                        firstNameAr: null,
                        middleNameAr: null,
                        lastNameAr: null,
                        emiratesId: "",
                        visaEmirates: null,
                        visaLocation: null,
                        visaFileNo: null,
                        nationality: null,
                        passportNo: null,
                        principal: null,
                        isPrincipal: false,
                        relation: null,
                        mobile: "",
                        email: "",
                        height: null,
                        weight: null,
                        bmi: null,
                        salaryBand: null,
                        salary: null,
                        profession: null,
                        idType: null,
                        dhaMemberType: null,
                        dhaMemberId: null,
                        dhaVerified: false,
                        workEmirate: null,
                        workLocation: null,
                        residentEmirate: null,
                        residentLocation: null,
                        birthCertificate: "",
                        medicalCardNumber: null,
                        uidNumber: "",
                        haadPenalty: 0,
                        cutOffDate: "",
                        finalPenalty: 0,
                        dhaStatus: "",
                        firstPolicy: true,
                        previousInsuranceCompany: "",
                        previousInsuranceNumber: "",
                        previousInsuranceExpiryDt: "",
                        entryDate: "",
                        visaExpiryDate: "",
                        isFirstPolicy: null,
                        isResident: false,
                        isEntry: false,
                        visaType: null,
                        showAbuDhabiRegionFee: false,
                        showDubaiRegionFee: false,
                        isAgeLessThan1: false,
                        premiumPerPerson: null,
                        extraPremium: null,
                        maternityPremium: null,
                        autoLoadingPerc: null,
                        autoLoadingAmt: null,
                        uwLoadingPerc: null,
                        uwLoadingAmt: null,
                        netLoadingPerc: null,
                        netLoadingAmt: null,
                        discountPerc: null,
                        discountAmt: null,
                        initialNetPremiumAmt: null,
                        netPremiumAmt: null,
                        showMemberDetails: false,
                        basmaFee: 19,
                        haadPenalty: 0,
                        hcvFee: 18,
                        finalPenalty: 0,
                        showDOHPenaltyButton: false,
                        isLocationMandatory: true,
                        inceptionDate: memberInceptionDate,
                        expiryDate: memberExpiryDate,
                        isActive: true,
                        isAdditionOfMember: action.payload,
                        isDohVerifiedYN: null,
                        elapsedDays: null,
                        cocVerifiedYN: null,
                        cocBatchId: null,
                        cocLogBatchId: null,
                        cocRefNo: null,
                        icpFee: null,
                        haadManualYN: null,
                        isHaadManualYN: false,
                    }
                }
            }
        }
        case types.UPDATE_CURRENT_POLICY_MEMBER_ID_MICORESHARED:
            return {
                ...state,
                memberInformation: {
                    ...state.memberInformation,
                    params: {
                        ...state.memberInformation.params,
                        memberId: action.payload.memberId,
                        memberTransId: action.payload.memberTransId
                    }
                }
            }
        case types.UPDATE_CURRENT_MEMBER_TYPE_MICORESHARED:
            return {
                ...state,
                currentMemberType: action.payload
            }
        case types.UPDATE_ALL_MEMBER_CHECKBOX_PARAMS_MICORESHARED: {
            let searchResults = state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails];
            let details = state[action.payload.memberDetailsSection].details;
            let isSearchResultsCheckBoxChecked = action.payload.checked
            // Use map() to update the isChecked property of each member
            let updatedSearchResults = searchResults.result.map((member) => {
                return {
                    ...member,
                    isChecked: isSearchResultsCheckBoxChecked
                }
            });
            let updatedDetails = details.map((member) => {
                return {
                    ...member,
                    isChecked: isSearchResultsCheckBoxChecked
                }
            });
            let member = false;
            let deleteMember = null;
            if (updatedDetails/* updatedSearchResults */.length > 0) {
                deleteMember = updatedDetails/* updatedSearchResults */.filter(p => p.isChecked == true);
                member = deleteMember.find(m =>
                    m.relation == appConstants.RELATION_PRINCIPAL
                ) == undefined ? false : true;
            } if (action.payload.memberDetailsSection == constants.BENEFFICARY_SECTION_MEMBER_DETAILS) {

                return {
                    ...state,
                    [action.payload.memberDetailsSection]: {
                        ...state[action.payload.memberDetailsSection],
                        [action.payload.memberFilteredDetails]: {
                            ...state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails],
                            result: updatedSearchResults
                        },
                        isPrincipal: member,
                        hasCheckedBoxInSearchResult: isSearchResultsCheckBoxChecked,
                        hasAllCheckBoxInSearchResult: isSearchResultsCheckBoxChecked,
                        details: updatedDetails
                    }
                }
            }
            else {
                return {
                    ...state,
                    [action.payload.memberDetailsSection]: {
                        ...state[action.payload.memberDetailsSection],
                        [action.payload.memberFilteredDetails]: {
                            ...state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails],
                            result: updatedSearchResults
                        },
                        hasAllCheckBoxInSearchResult: isSearchResultsCheckBoxChecked,
                    },
                    memberDetails: {
                        ...state.memberDetails,
                        hasCheckedBoxInSearchResult: isSearchResultsCheckBoxChecked,
                        isPrincipal: member
                    }
                }
            }
        }
        case types.UPDATE_ALL_MEMBER_IN_PAGE_CHECKBOX_PARAMS_MICORESHARED: {
            let searchResults = state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails];
            let isSearchResultsCheckBoxChecked = action.payload.checked
            // Use map() to update the isChecked property of each member
            let updatedSearchResults = searchResults.result.map((member) => {
                return {
                    ...member,
                    isChecked: isSearchResultsCheckBoxChecked
                }
            });
            let member = false;
            let deleteMember = null;
            if (updatedSearchResults.length > 0) {
                deleteMember = updatedSearchResults.filter(p => p.isChecked == true);
                member = deleteMember.find(m =>
                    m.relation == appConstants.RELATION_PRINCIPAL
                ) == undefined ? false : true;
            } if (action.payload.memberDetailsSection == constants.BENEFFICARY_SECTION_MEMBER_DETAILS) {

                return {
                    ...state,
                    [action.payload.memberDetailsSection]: {
                        ...state[action.payload.memberDetailsSection],
                        [action.payload.memberFilteredDetails]: {
                            ...state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails],
                            result: updatedSearchResults
                        },
                        isPrincipal: member,
                        hasCheckedBoxInSearchResult: isSearchResultsCheckBoxChecked
                    }
                }
            }
            else {
                return {
                    ...state,
                    [action.payload.memberDetailsSection]: {
                        ...state[action.payload.memberDetailsSection],
                        [action.payload.memberFilteredDetails]: {
                            ...state[action.payload.memberDetailsSection][action.payload.memberFilteredDetails],
                            result: updatedSearchResults
                        }
                    },
                    memberDetails: {
                        ...state.memberDetails,
                        hasCheckedBoxInSearchResult: isSearchResultsCheckBoxChecked,
                        isPrincipal: member
                    }
                }
            }
        }
        case types.UPDATE_MEMBER_CHECKBOX_PARAMS_MICORESHARED: {
            let searchResults = state[action.payload.section][action.payload.filteredDetails];
            let details = state[action.payload.section].details;
            let isAdditionOfMember = false;
            for (let j = 0; j < searchResults.result.length; j++) {
                if (searchResults.result[j].rNo == action.payload.id) {
                    searchResults.result[j].isChecked = action.payload.checked
                }
            }
            for (let j = 0; j < details.length; j++) {
                if (details[j].rNo == action.payload.id) {
                    details[j].isChecked = action.payload.checked
                }
            }
            let hasCheckedBoxInSearchResult = state.memberDetails.details.filter(p => p.isChecked == true).length > 0 ||
                state.dependentDetails.details?.filter(p => p.isChecked == true).length ||
                state.memberDetails.memberFilteredDetails.result.filter(p => p.isChecked == true).length > 0 ||
                state.dependentDetails.dependentFilteredDetails.result?.filter(p => p.isChecked == true).length > 0 ? true : false;
            let hasAllCheckBoxInSearchResult = state.memberDetails.details.filter(p => p.isChecked == false).length > 0 ||
                state.dependentDetails.details?.filter(p => p.isChecked == false).length > 0 ? false : true;
            if (state.policyEndorsement.endorsementTypeId == constants.ENDO_CONFG_ADDITION_OF_MEMBER) {
                isAdditionOfMember =
                    state.memberDetails.memberFilteredDetails.result.filter(p => p.isChecked == true && !p.isAdditionOfMember).length > 0 ||
                        state.dependentDetails.dependentFilteredDetails.result?.filter(p => p.isChecked == true && !p.isAdditionOfMember).length > 0 ? false :
                        state.memberDetails.memberFilteredDetails.result.filter(p => p.isChecked == true && p.isAdditionOfMember).length > 0 ||
                            state.dependentDetails.dependentFilteredDetails.result?.filter(p => p.isChecked == true && p.isAdditionOfMember).length > 0 ? true : false;
            }

            let member = false;
            let deleteMember = null;
            if (state[action.payload.section].details/* [action.payload.filteredDetails].result */.length > 0) {
                deleteMember = state[action.payload.section].details/* [action.payload.filteredDetails].result */.filter(p => p.isChecked == true);
                member = deleteMember.find(m =>
                    m.relation == appConstants.RELATION_PRINCIPAL
                ) == undefined ? false : true;
                console.log("is prinicpal", deleteMember.find(m =>
                    m.relation == appConstants.RELATION_PRINCIPAL
                ) == undefined ? false : true);
            }
            if (action.payload.section == constants.BENEFFICARY_SECTION_MEMBER_DETAILS) {
                return {
                    ...state,
                    [action.payload.section]: {
                        ...state[action.payload.section],
                        [action.payload.filteredDetails]: searchResults,
                        hasCheckedBoxInSearchResult: hasCheckedBoxInSearchResult,
                        isAdditionOfMember: isAdditionOfMember,
                        isPrincipal: member,
                        hasAllCheckBoxInSearchResult: hasAllCheckBoxInSearchResult
                    }
                }
            }
            else {
                return {
                    ...state,
                    memberDetails: {
                        ...state.memberDetails,
                        hasCheckedBoxInSearchResult: hasCheckedBoxInSearchResult,
                        isAdditionOfMember: isAdditionOfMember,
                        isPrincipal: member
                    },
                    [action.payload.section]: {
                        ...state[action.payload.section],
                        [action.payload.filteredDetails]: searchResults,
                        //hasCheckedBoxInSearchResult: hasCheckedBoxInSearchResult,
                    }
                }
            }
        }

        case types.UPDATE_HAS_CHECKBOX_IN_MEMBER_DETAILS_MICORESHARED:
            return {
                ...state,
                [action.payload.memberDetailsSection]: {
                    ...state[action.payload.memberDetailsSection],
                    hasCheckedBoxInSearchResult: action.payload.data
                }
            }

        /* case types.SET_MEMBER_QUOTE_ID: {
            return {
                ...state,
                memberInformation: {
                    ...state.memberInformation,
                    params:{
                        ...state.memberInformation.params,
                        quotationId: action.quoteId
                    }
                }
            }
        } */
        case types.UPDATE_MEMBER_TABLE_SEARCH_PARAMS_MICORESHARED: {
            let searchMembers = {
                currentPage: constants.MEMBER_DETAILS_FIRST_PAGE,
                pageSize: constants.MEMBER_DETAILS_PAGE_SIZE,
                sort: null,
                totalCount: action.payload.result.length,
                totalPages: Math.ceil(action.payload.result.length / constants.MEMBER_DETAILS_PAGE_SIZE),
                hasNextPage: constants.MEMBER_DETAILS_FIRST_PAGE == Math.ceil(action.payload.result.length / constants.MEMBER_DETAILS_PAGE_SIZE) ? false : true,
                hasPreviousPage: false,
                result: action.payload.result.slice(constants.IS_ZERO, constants.MEMBER_DETAILS_PAGE_SIZE)
            }
            return {
                ...state,
                searchMembers: action.payload.value,
                memberDetails: {
                    ...state.memberDetails,
                    details: action.payload.result,
                    showMembers: action.payload.result.length != 0,
                    memberFilteredDetails: searchMembers
                }

            }
        }
        case types.UPDATE_MEMBERS_MICORESHARED:
            let filteredDetails = action.payload.section == constants.BENEFFICARY_SECTION_MEMBER_DETAILS ? constants.MEMBER_FILTERED_DETAILS : constants.DEPENDENT_FILTERED_DETAILS;
            let memberPagedResult = {
                currentPage: constants.MEMBER_DETAILS_FIRST_PAGE,
                pageSize: constants.MEMBER_DETAILS_PAGE_SIZE,
                sort: null,
                totalCount: action.payload.pagedResult.length,
                totalPages: Math.ceil(action.payload.pagedResult.length / constants.MEMBER_DETAILS_PAGE_SIZE),
                hasNextPage: constants.MEMBER_DETAILS_FIRST_PAGE == Math.ceil(action.payload.pagedResult.length / constants.MEMBER_DETAILS_PAGE_SIZE) ? false : true,
                hasPreviousPage: false,
                result: action.payload.pagedResult.slice(constants.IS_ZERO, constants.MEMBER_DETAILS_PAGE_SIZE)
            }
            return {
                ...state,
                [action.payload.section]: {
                    ...state[action.payload.section],
                    details: action.payload.pagedResult,
                    [filteredDetails]: memberPagedResult,
                    mafFilteredDetails: memberPagedResult
                }
            }
        case types.GET_PAGED_MEMBERS_MICORESHARED:
            let pagedFilteredDetails = action.payload.section == constants.BENEFFICARY_SECTION_MEMBER_DETAILS ? constants.MEMBER_FILTERED_DETAILS : constants.DEPENDENT_FILTERED_DETAILS;
            let startIndex = constants.MEMBER_DETAILS_PAGE_SIZE * action.payload.page - constants.MEMBER_DETAILS_PAGE_SIZE;
            let endIndex = startIndex + constants.MEMBER_DETAILS_PAGE_SIZE;
            let changePagedResult = {
                currentPage: action.payload.page,
                pageSize: constants.MEMBER_DETAILS_PAGE_SIZE,
                sort: null,
                totalCount: state[action.payload.section].details.length,
                totalPages: Math.ceil(state[action.payload.section].details.length / constants.MEMBER_DETAILS_PAGE_SIZE),
                hasNextPage: action.payload.page == Math.ceil(state[action.payload.section].details.length / constants.MEMBER_DETAILS_PAGE_SIZE) ? false : true,
                hasPreviousPage: action.payload.page == constants.IMPORT_MEMBER_FIRST_PAGE ? false : true,
                result: state[action.payload.section].details.slice(startIndex, endIndex)
            }
            return {
                ...state,
                [action.payload.section]: {
                    ...state[action.payload.section],
                    [pagedFilteredDetails]: changePagedResult,
                    mafFilteredDetails: changePagedResult
                }
            }
        case types.SHOW_MEMBERS_MICORESHARED:
            let showMembers = action.payload.section == constants.BENEFFICARY_SECTION_MEMBER_DETAILS ? constants.SHOW_MEMBERS : constants.SHOW_DEPENDENTS;
            return {
                ...state,
                [action.payload.section]: {
                    ...state[action.payload.section],
                    [showMembers]: action.payload.data
                }
            }

        case types.GET_POLICY_DISTINCT_MEMBER_IMPORT_PAGE_ID_MICORESHARED: {
            return {
                ...state,
                memberDetails: {
                    ...state.memberDetails,
                    memberUpload: {
                        ...state.memberDetails.memberUpload,
                        currentMemberImportPageId: action.payload.id,
                    }
                }
            }
        }
        case types.POLICY_UPDATE_CURRENT_MEMBER_NAME_MICORESHARED:
            return {
                ...state,
                [action.payload.memberDetailsSection]: {
                    ...state[action.payload.memberDetailsSection],
                    currentMemberName: action.payload.memberName
                }
            }
        case types.UPDATE_SALARY_VALIDATION_END_MICORESHARED: {
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        salary: action.payload.salary,
                        isSalaryZero: action.payload.isSalaryZero,
                        minSalary: action.payload.minSalary,
                        maxSalary: action.payload.maxSalary
                    }
                }
            }
        }
        case types.UPDATE_IS_PRINCIPAL_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        principal: action.payload.updatedValue.principalValue,
                        isPrincipal: action.payload.updatedValue.isPrincipal,
                        salaryBand: action.payload.updatedValue.salaryBand,
                        isPrincipalExisting: action.payload.updatedValue.isPrincipalExisting
                    }
                }
            }
        case types.UPDATE_MEMBER_AGE_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        age: action.payload.ageInYears,
                        ageInMonths: action.payload.ageInMonths == null ? null : action.payload.ageInMonths + " month(s)",
                        isAgeLessThan1: action.payload.ageInYears < 1
                    }
                }
            }
        case types.CLEAR_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED:
            let isNewMember = state[action.payload].params.isAdditionOfMember;
            let memberInceptionDate = isNewMember ? state.initOptions.moduleType == appConstants.ENDORSEMENT_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyEndorsement.endorsementEffectiveDateFrom :
                state.initOptions.moduleType == appConstants.POLICY_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyInformation.inceptionDate : null : null;
            let memberExpiryDate = state.policyInformation.expiryDate;/*isNewMember ? state.initOptions.moduleType == appConstants.ENDORSEMENT_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyEndorsement.expiryDate : 
            state.initOptions.moduleType == appConstants.POLICY_MODULE && state.initOptions.mode == appConstants.EDIT_MODE ? state.policyInformation.expiryDate : null : null;*/
            return {
                ...state,
                [action.payload]: {
                    ...state[action.payload],
                    params: {
                        ...state[action.payload].params,
                        memberId: null,
                        memberTransId: null,
                        employeeId: null,
                        photoId: null,
                        photoName: null,
                        photoSrc: null,
                        salutation: null,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        plan: null,
                        maritalStatus: null,
                        dateofBirth: null,
                        age: null,
                        gender: null,
                        firstNameAr: null,
                        middleNameAr: null,
                        lastNameAr: null,
                        emiratesId: "",
                        visaEmirates: null,
                        visaLocation: null,
                        visaFileNo: null,
                        nationality: null,
                        passportNo: null,
                        principal: null,
                        isPrincipal: false,
                        relation: null,
                        mobile: "",
                        email: "",
                        height: null,
                        weight: null,
                        bmi: null,
                        salaryBand: null,
                        salary: null,
                        profession: null,
                        idType: null,
                        dhaMemberType: null,
                        dhaMemberId: null,
                        dhaVerified: false,
                        workEmirate: null,
                        workLocation: null,
                        residentEmirate: null,
                        residentLocation: null,
                        birthCertificate: "",
                        medicalCardNumber: null,
                        uidNumber: "",
                        haadPenalty: 0,
                        cutOffDate: "",
                        finalPenalty: 0,
                        dhaStatus: "",
                        firstPolicy: true,
                        previousInsuranceCompany: "",
                        previousInsuranceNumber: "",
                        previousInsuranceExpiryDt: "",
                        entryDate: "",
                        visaExpiryDate: "",
                        isFirstPolicy: null,
                        isResident: false,
                        isEntry: false,
                        visaType: null,
                        showAbuDhabiRegionFee: false,
                        showDubaiRegionFee: false,
                        isAgeLessThan1: false,
                        premiumPerPerson: null,
                        extraPremium: null,
                        maternityPremium: null,
                        autoLoadingPerc: null,
                        autoLoadingAmt: null,
                        uwLoadingPerc: null,
                        uwLoadingAmt: null,
                        netLoadingPerc: null,
                        netLoadingAmt: null,
                        discountPerc: null,
                        discountAmt: null,
                        initialNetPremiumAmt: null,
                        netPremiumAmt: null,
                        showMemberDetails: false,
                        basmaFee: 19,
                        haadPenalty: 0,
                        hcvFee: 18,
                        finalPenalty: 0,
                        showDOHPenaltyButton: false,
                        isLocationMandatory: true,
                        inceptionDate: memberInceptionDate,
                        expiryDate: memberExpiryDate,
                        isActive: true,
                        isDohVerifiedYN: null,
                        principalCardNumber: null,
                        commissionYN: false,
                        uhcgMemberYN: false,
                        uhcTransmitId: null,
                        altId: null,
                        icpFee: null,


                    }

                }
            }
        case types.GET_MEMBER_DETAILS_END_MICORESHARED:
            {
                let region = state.masters.regionMasters.filter(x => x.emirateId == action.payload.data.visaEmirates);
                let isLocationMandatory = true;
                if (region.length != 0) {
                    if (region[0].regionId == appConstants.REGION_EMIRATE_NE || region[0].regionId == appConstants.REGION_EMIRATE_ABUDHABI) {
                        isLocationMandatory = false
                    }
                }
                let memberInformation = action.payload.section == constants.POLICY_BENEFICIARY_MEMBER ? constants.BENEFFICARY_SECTION_MEMBER : constants.BENEFFICARY_SECTION_DEPENDENT;
                return {
                    ...state,
                    [memberInformation]: {
                        ...state[memberInformation],
                        params: {
                            ...state[memberInformation].params,
                            policyId: action.payload.data.policyId,
                            mstMemberId: action.payload.data.mstMemberId == null ? "" : action.payload.data.mstMemberId,
                            memberTransId: action.payload.data.memberTransId,
                            memberId: action.payload.data.memberId == null ? "" : action.payload.data.memberId,
                            photoId: action.payload.data.photoId == null ? "" : action.payload.data.photoId,
                            photoName: action.payload.data.photoName == null ? "" : action.payload.data.photoName,
                            photoSrc: action.payload.data.photoSrc == null ? "" : action.payload.data.photoSrc,
                            salutation: action.payload.data.salutation,
                            firstName: action.payload.data.firstName,
                            middleName: action.payload.data.middleName,
                            lastName: action.payload.data.lastName,
                            firstNameAr: action.payload.data.firstNameAr,
                            middleNameAr: action.payload.data.middleNameAr,
                            lastNameAr: action.payload.data.lastNameAr,
                            dateofBirth: appUtility.formatDate(action.payload.data.dateOfBirth),
                            age: action.payload.data.age,
                            ageInMonths: action.payload.data.ageInMonths,
                            isAgeLessThan1: action.payload.data.isAgeLessThan1,
                            isPrincipal: action.payload.data.isPrincipal,
                            relation: action.payload.data.relation,
                            principal: action.payload.data.principal + action.payload.data.isPrincipalExisting + " " + action.payload.data.principalCardNumber,
                            isPrincipalExisting: action.payload.data.isPrincipalExisting,
                            principalCardNumber: action.payload.data.principalCardNumber,
                            category: action.payload.data.category,
                            initialCategory: action.payload.data.initialCategory,
                            emiratesId: action.payload.data.emiratesId,
                            visaEmirates: action.payload.data.visaEmirates,
                            gender: action.payload.data.gender,
                            nationality: action.payload.data.nationality,
                            maritalStatus: action.payload.data.maritalStatus,
                            passportNo: action.payload.data.passportNo == null ? "" : action.payload.data.passportNo,
                            mobile: action.payload.data.mobile,
                            email: action.payload.data.email,
                            salaryBand: action.payload.data.salaryBand,
                            salary: action.payload.data.salary,
                            isSalaryZero: action.payload.data.salaryDisabled,
                            height: action.payload.data.height,
                            weight: action.payload.data.weight,
                            bmi: action.payload.data.bmi,
                            profession: action.payload.data.profession,
                            idType: action.payload.data.idType,
                            dhaMemberType: action.payload.data.dhaMemberType,
                            dhaMemberId: action.payload.data.dhaMemberId,
                            dhaVerified: action.payload.data.dhaVerified,
                            workEmirate: action.payload.data.workEmirate,
                            workLocation: action.payload.data.workLocation,
                            visaLocation: action.payload.data.visaLocation,
                            residentEmirate: action.payload.data.residentEmirate,
                            residentLocation: action.payload.data.residentLocation,
                            birthCertificate: action.payload.data.birthCertificate,
                            uidNumber: action.payload.data.uidNumber,
                            cutOffDate: action.payload.data.cutOffDate == null ? "" : appUtility.formatDate(action.payload.data.cutOffDate),
                            basmaFee: action.payload.data.basmaFee == null ? 19 : action.payload.data.basmaFee,
                            hcvFee: action.payload.data.hcvFee == null ? 0 : action.payload.data.hcvFee,
                            haadPenalty: action.payload.data.haadPenalty == null ? 0 : action.payload.data.haadPenalty,
                            finalPenalty: action.payload.data.finalPenalty == null ? 0 : action.payload.data.finalPenalty,
                            dhaStatus: action.payload.data.dhaStatus,
                            firstPolicy: action.payload.data.firstPolicy,
                            previousInsuranceCompany: action.payload.data.previousInsuranceCompany == null ? "" : action.payload.data.previousInsuranceCompany,
                            previousInsuranceNumber: action.payload.data.previousInsuranceNumber == null ? "" : action.payload.data.previousInsuranceNumber,
                            previousInsuranceExpiryDt: action.payload.data.previousInsuranceExpiryDt == null ? "" : appUtility.formatDate(action.payload.data.previousInsuranceExpiryDt),
                            entryDate: action.payload.data.entryDate == null ? "" : appUtility.formatDate(action.payload.data.entryDate),
                            visaExpiryDate: action.payload.data.visaExpiryDate == null ? "" : appUtility.formatDate(action.payload.data.visaExpiryDate),
                            isFirstPolicy: action.payload.data.firstPolicy,
                            ageIsLessThan6Months: action.payload.data.ageIs6Months,
                            showDOHPenaltyButton: action.payload.data.showDOHPenalty,
                            isLocationMandatory: isLocationMandatory,
                            employeeId: action.payload.data.employeeId,
                            visaFileNo: action.payload.data.visaFileNo,
                            plan: action.payload.data.plan + " " + action.payload.data.category,
                            medicalCardNumber: action.payload.data.medicalCardNumber,
                            principalCardNumber: action.payload.data.principalCardNumber,
                            visaType: action.payload.data.visaType,
                            isNewEntry: action.payload.data.isNewEntry,
                            isResident: action.payload.data.isResident,
                            isAdditionOfMember: action.payload.data.isAdditionOfMember,
                            inceptionDate: appUtility.formatDate(action.payload.data.memberEffectiveDate),
                            expiryDate: appUtility.formatDate(action.payload.data.memberExpiryDate),
                            dependentsCount: action.payload.data.dependentsCount,
                            isActive: action.payload.data.isActive,
                            elapsedDays: action.payload.data.elapsedDays ?? 0,
                            subgroup: action.payload.data.subgroup,

                            commissionYN: action.payload.data.commissionYN == "Y" ? true : false,
                            uhcgMemberYN: action.payload.data.uhcgMemberYN == "Y" ? true : false,
                            uhcTransmitId: action.payload.data.uhcTransmitId,
                            altId: action.payload.data.altId,

                            showDubaiRegionFee: action.payload.data.visaEmirates == appConstants.VISA_EMIRATE_DUBAI ? true : false,
                            showAbuDhabiRegionFee: (action.payload.data.visaEmirates == appConstants.VISA_EMIRATE_ABU_DHABI || action.payload.data.visaEmirates == appConstants.VISA_EMIRATE_AL_AIN) ? true : false,
                            premiumPerPerson: action.payload.data.premiumPerPerson == null ? "" : action.payload.data.premiumPerPerson,
                            extraPremium: action.payload.data.extraPremium == null ? "" : action.payload.data.extraPremium,
                            maternityPremium: action.payload.data.maternityPremium == null ? "" : action.payload.data.maternityPremium,
                            autoLoadingPerc: action.payload.data.autoLoadingPerc == null ? "" : action.payload.data.autoLoadingPerc,
                            autoLoadingAmt: action.payload.data.autoLoadingAmt == null ? "" : action.payload.data.autoLoadingAmt,
                            uwLoadingPerc: action.payload.data.uwLoadingPerc == null ? "" : action.payload.data.uwLoadingPerc,
                            uwLoadingAmt: action.payload.data.uwLoadingAmt == null ? "" : action.payload.data.uwLoadingAmt,
                            netLoadingPerc: action.payload.data.netLoadingPerc == null ? "" : action.payload.data.netLoadingPerc,
                            netLoadingAmt: action.payload.data.netLoadingAmt == null ? "" : action.payload.data.netLoadingAmt,
                            discountPerc: action.payload.data.discountPerc == null ? "" : action.payload.data.discountPerc,
                            discountAmt: action.payload.data.discountAmt == null ? "" : action.payload.data.discountAmt,
                            vatPerc: action.payload.data.vatPerc == null ? "" : action.payload.data.vatPerc,
                            initialNetPremiumAmt: action.payload.data.initialNetPremium,
                            netPremiumAmt: action.payload.data.netPremiumAmt,
                            renewalLoadingPerc: action.payload.data.renewalLoadingPerc == null ? 0 : action.payload.data.renewalLoadingPerc,
                            renewalLoadingAmt: action.payload.data.renewalLoadingAmt == null ? 0 : action.payload.data.renewalLoadingAmt,

                            isDohVerifiedYN: action.payload.data.isDohVerifiedYN == null ? "N" : action.payload.data.isDohVerifiedYN,
                            remarks: action.payload.data.remarks,
                            waiveOffAmt: action.payload.data.waiveOffAmt,
                            waiveOffBy: action.payload.data.waiveOffBy,
                            waiveOffReason: action.payload.data.waiveOffReason,

                            cocVerifiedYN: action.payload.data.cocVerifiedYN == null ? null : action.payload.data.cocVerifiedYN,
                            cocBatchId: action.payload.data.cocBatchId == null ? null : action.payload.data.cocBatchId,
                            cocLogBatchId: action.payload.data.cocLogBatchId == null ? null : action.payload.data.cocLogBatchId,
                            cocRefNo: action.payload.data.cocRefNo == null ? null : action.payload.data.cocRefNo,
                            haadManualYN: action.payload.data.haadManualYN == null ? null : action.payload.data.haadManualYN,
                            isHaadManualYN: action.payload.data.haadManualYN == null || action.payload.data.haadManualYN == 'N' ? false : true,


                            icpFee: action.payload.data.icpFee
                        }

                    }
                }
            }

        case types.SHOW_MEMBER_DETAILS_MICORESHARED: {
            let memberInfoSection = action.payload.section == constants.POLICY_BENEFICIARY_MEMBER ? constants.BENEFFICARY_SECTION_MEMBER : constants.BENEFFICARY_SECTION_DEPENDENT;
            let showMemberDetails = action.payload.section == constants.POLICY_BENEFICIARY_MEMBER ? constants.SHOW_MEMBER_DETAILS : constants.SHOW_DEPENDENT_DETAILS;
            return {
                ...state,
                [memberInfoSection]: {
                    ...state[memberInfoSection],
                    params: {
                        ...state[memberInfoSection].params,
                        [showMemberDetails]: action.payload.data
                    }
                }
            }
        }
        case types.SHOW_MEMBER_DEPENDENTS_MICORESHARED: {
            return {
                ...state,
                memberInformation: {
                    ...state.memberInformation,
                    flags: {
                        ...state.memberInformation.flags,
                        showMemberDependents: action.payload
                    }
                }
            }
        }
        case types.COLLAPSE_POLICY_MEMBER_INFORMATION_MICORESHARED:
            var collapseClass = null
            if (action.payload.data == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        memberInformationClass: collapseClass
                    }
                }
            }

        case types.POLICY_GET_VISA_LOCATION_MASTER_END_MICORESHARED: {
            let beneficaryWorkLocation = action.payload.memberType == constants.BENEFFICARY_SECTION_MEMBER ?
                constants.BENEFICIARY_VISA_LOCATION_MASTERS_MEMBER :
                constants.BENEFICIARY_VISA_LOCATION_MASTERS_DEPENDENT;
            return {
                ...state,
                masters: {
                    ...state.masters,
                    [beneficaryWorkLocation]: action.payload.location
                }
            }
        }

        case types.POLICY_GET_WORK_LOCATION_MASTER_END_MICORESHARED: {
            let beneficaryWorkLocation = action.payload.memberType == constants.BENEFFICARY_SECTION_MEMBER ?
                constants.BENEFICIARY_WORK_LOCATION_MASTERS_MEMBER :
                constants.BENEFICIARY_WORK_LOCATION_MASTERS_DEPENDENT;
            return {
                ...state,
                masters: {
                    ...state.masters,
                    [beneficaryWorkLocation]: action.payload.location
                }
            }
        }

        case types.POLICY_GET_RESIDENT_LOCATION_MASTER_END_MICORESHARED: {
            let beneficaryLocation = action.payload.memberType == constants.BENEFFICARY_SECTION_MEMBER ?
                constants.BENEFICIARY_RESIDENT_LOCATION_MASTERS_MEMBER :
                constants.BENEFICIARY_RESIDENT_LOCATION_MASTERS_DEPENDENT;
            return {
                ...state,
                masters: {
                    ...state.masters,
                    [beneficaryLocation]: action.payload.location
                }
            }
        }

        case types.CLEAR_POLICY_DOCUMENT_LIST_MICORESHARED: {
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    documentList: [],
                    hasCheckedBoxInDocuments: false
                }
            };
        }

        case types.ADD_NEW_DOCUMENT_MICORESHARED: {
            let documentType = action.payload ? constants.POLICY_DOCUMENTS : constants.MEMBER_DOCUMENTS;
            if (state[documentType].documentMaster.length > 0) {
                let documentCount = state[documentType].documentList.length;
                return {
                    ...state,
                    [documentType]: {
                        ...state[documentType],
                        documentList: [
                            ...state[documentType].documentList,
                            {
                                srlNo: documentCount + 1,
                                docType: '',
                                refNo: null,
                                description: null,
                                fileType: null,
                                fileInput: "",
                                isChecked: false,
                                isMandatory: false
                            }
                        ]
                    }
                }
            }
            else {
                return {
                    ...state,
                    [documentType]: {
                        ...state[documentType]
                    }
                }
            }
        }
        case types.UPDATE_FILE_CHANGE_END_MICORESHARED: {
            if (action.payload.isMember || !action.payload.isPolicy) {
                return {
                    ...state,
                    memberDocuments: {
                        ...state.memberDocuments,
                        documentList: action.payload.updatedFile
                    }
                }
            }
            else {
                return {
                    ...state,
                    policyDocuments: {
                        ...state.policyDocuments,
                        documentList: action.payload.updatedFile
                    }
                }
            }
        }
        case types.UPDATE_DOCUMENT_PARAMS_END_MICORESHARED: {
            if (action.payload.isMember || !action.payload.isPolicy) {
                return {
                    ...state,
                    memberDocuments: {
                        ...state.memberDocuments,
                        documentList: action.payload.updatedDocParams
                    }
                }
            }
            else {
                return {
                    ...state,
                    policyDocuments: {
                        ...state.policyDocuments,
                        documentList: action.payload.updatedDocParams
                    }
                }
            }
        }
        case types.UPDATE_DOCUMENT_CHECKBOX_PARAMS_MICORESHARED: {
            // Determine which list of documents to update
            const documentsList = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'policyDocuments';
            // Find the index of the document to update
            const documentIndex = state[documentsList].documentList.findIndex(d => d.srlNo == action.payload.id);
            // Update the isChecked property of the document
            const updatedDocumentList = [...state[documentsList].documentList];
            updatedDocumentList[documentIndex].isChecked = action.payload.checked;
            // Check if there are any checked boxes in the updated document list
            const hasCheckedBoxInDocuments = updatedDocumentList.filter(p => p.isChecked == true).length > 0;
            // Return the updated state
            return {
                ...state,
                [documentsList]: {
                    ...state[documentsList],
                    documentList: updatedDocumentList,
                    hasCheckedBoxInDocuments
                }
            }
        }
        case types.DELETE_DOCUMENT_FROM_GRID_MICORESHARED:
            const documentListType = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'policyDocuments';
            var docsNotSelected = state[documentListType].documentList.filter(p => !p.isChecked);
            return {
                ...state,
                [documentListType]: {
                    ...state[documentListType],
                    documentList: docsNotSelected,
                    hasCheckedBoxInDocuments: false
                }
            }
        case types.UPDATE_DOCUMENTS_TABLE_ID_MICORESHARED: {
            const documentListType = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'policyDocuments';
            let spliceDocumentInfo = []
            for (let i = 0; i < state[documentListType].documentList.length; i++) {
                let Arr = {
                    ...state[documentListType].documentList[i],
                    srlNo: i + 1
                }
                spliceDocumentInfo.push(Arr)
            }
            console.log(state[documentListType].documentList)
            console.log(spliceDocumentInfo)
            return {
                ...state,
                [documentListType]: {
                    ...state[documentListType],
                    documentList: spliceDocumentInfo
                }
            }
        }

        case types.SHOW_DEPENDENT_DETAILS_MICORESHARED: {
            return {
                ...state,
                dependentInformation: {
                    ...state.dependentInformation,
                    params: {
                        ...state.dependentInformation.params,
                        showDependentDetails: action.payload
                    }
                }
            }
        }

        case types.POLICY_CALCULATE_BMI_END_MICORESHARED: {
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        bmi: action.payload.bmi
                    }
                }
            }
        }
        case types.UPDATE_POLICY_MEMBER_IS_LOCATION_MANDATORY_MICORESHARED:
            {
                let region = state.masters.regionMasters.filter(x => x.emirateId == action.payload);
                let isLocationMandatory = true;
                if (region.length != 0) {
                    if (region[0].regionId == appConstants.REGION_EMIRATE_NE || region[0].regionId == appConstants.REGION_EMIRATE_ABUDHABI) {
                        isLocationMandatory = false
                    }
                }
                return {
                    ...state,
                    memberInformation: {
                        ...state.memberInformation,
                        params: {
                            ...state.memberInformation.params,
                            isLocationMandatory: isLocationMandatory
                        }
                    }
                }
            }
        case types.POLICY_SHOW_DUBAI_REGION_PARAMS_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        showDubaiRegionFee: action.payload.status,
                        hcvFee: 18,
                        basmaFee: 19,
                    }
                }
            }
        case types.POLICY_SHOW_ABUDHABI_REGION_PARAMS_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        showAbuDhabiRegionFee: action.payload.status,
                        hcvFee: 18,
                        basmaFee: 19,
                        showDOHPenaltyButton: action.payload.status,
                        visaType: action.payload.status == false ? "" : state[action.payload.memberType].params.visaType,
                        isNewEntry: action.payload.status == false ? false : state[action.payload.memberType].params.isNewEntry,
                        isResident: action.payload.status == false ? false : state[action.payload.memberType].params.isResident,
                        cutOffDate: action.payload.status == false ? "" : state[action.payload.memberType].params.cutOffDate,
                        previousInsuranceCompany: state[action.payload.memberType].isFirstPolicy == true ? "" : state[action.payload.memberType].params.previousInsuranceCompany,
                        previousInsuranceNumber: state[action.payload.memberType].isFirstPolicy == true ? "" : state[action.payload.memberType].params.previousInsuranceNumber,
                        previousInsuranceExpiryDt: state[action.payload.memberType].isFirstPolicy == true ? "" : state[action.payload.memberType].params.previousInsuranceExpiryDt
                    }
                }
            }
        case types.POLICY_CHECK_VISA_TYPE_MICORESHARED: {
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        isNewEntry: action.payload.value == appConstants.VISA_TYPE_NEW_ENTRY,
                        isResident: action.payload.value == appConstants.VISA_TYPE_RESIDENT,
                        isFirstPolicy: action.payload.value == appConstants.VISA_TYPE_RESIDENT ? false : true,
                        previousInsuranceCompany: action.payload.value == appConstants.VISA_TYPE_RESIDENT ? state[action.payload.memberType].params.previousInsuranceCompany : null,
                        previousInsuranceNumber: action.payload.value == appConstants.VISA_TYPE_RESIDENT ? state[action.payload.memberType].params.previousInsuranceNumber : null,
                        previousInsuranceExpiryDt: action.payload.value == appConstants.VISA_TYPE_RESIDENT ? state[action.payload.memberType].params.previousInsuranceExpiryDt : null,
                    }
                }
            }
        }
        case types.UPDATE_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        [action.payload.name]: action.payload.value
                    }
                }
            }
        case types.POLICY_UPDATE_MEMBER_VERIFIED_PARAM_MICORESHARED: {
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        dhaVerified: action.payload.checked
                    }
                }
            }
        }
        case types.GET_POLICY_PRINCIPAL_MASTERS_END_MICORESHARED:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    principalMasters: action.result,
                }
            }
        case types.GET_RELATION_MASTERS_END_MICORESHARED: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    relationMasters: action.result
                }
            }
        }
        case types.UPDATE_FIRST_POLICY_PARAMS_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        previousInsuranceCompany: null,
                        previousInsuranceNumber: null,
                        previousInsuranceExpiryDt: null,
                        isFirstPolicy: action.payload.status
                    }
                }
            }
        case types.UPDATE_MEMBER_PREMIUM_INFORMATION_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        netPremiumAmt: action.payload.netPremiumAmt,
                        extraPremium: action.payload.extraPremium,
                        discountAmt: action.payload.discountAmt,
                        discountPerc: action.payload.discountPerc,
                        premiumPerPerson: action.payload.premiumPerPerson,
                        maternityPremium: action.payload.maternityPremium
                    }
                }
            }
        case types.UPDATE_MEMBER_UW_LOADING_CHANGE_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        uwLoadingPerc: action.payload.uwLoadingPerc,
                        uwLoadingAmt: action.payload.uwLoadingAmt,
                        netLoadingPerc: action.payload.netLoadingPerc,
                        netLoadingAmt: action.payload.netLoadingAmt,
                        netPremiumAmt: action.payload.netPremiumAmt
                    }
                }
            }
        case types.UPDATE_MEMBER_AUTO_LOADING_CHANGE_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        autoLoadingPerc: action.payload.autoLoadingPerc,
                        autoLoadingAmt: action.payload.autoLoadingAmt,
                        netLoadingPerc: action.payload.netLoadingPerc,
                        netLoadingAmt: action.payload.netLoadingAmt,
                        netPremiumAmt: action.payload.netPremiumAmt
                    }
                }
            }
        case types.UPDATE_MEMBER_DISCOUNT_CHANGE_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        discountPerc: action.payload.discountPerc,
                        discountAmt: action.payload.discountAmt,
                        netPremiumAmt: action.payload.netPremiumAmt
                    }
                }
            }
        /************** Document Tab *************/
        case types.POLICY_CHECK_DOCUMENT_TAB_TYPE_MICORESHARED: {
            console.log("ismemberdoc", action.payload.memberType === constants.BENEFFICARY_SECTION_MEMBER || action.payload.memberType === constants.BENEFFICARY_SECTION_DEPENDENT);
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    isPolicyTabDocument: action.payload.tabType === constants.POLICY_PAGE,
                    isMemberDocument: action.payload.memberType === constants.BENEFFICARY_SECTION_MEMBER || action.payload.memberType === constants.BENEFFICARY_SECTION_DEPENDENT
                }
            };
        }
        case types.POLICY_GET_DISTINCT_DOCUMENT_PAGE_ID_MICORESHARED: {
            return {
                ...state,
                currentDocumentPageId: action.payload
            }
        }
        case types.GET_POLICY_DOCUMENT_LIST_END_MICORESHARED: {
            return {
                ...state,
                policyDocuments: {
                    ...state.policyDocuments,
                    documentList: action.payload
                }
            }
        }
        case types.GET_POLICY_DOCUMENT_MASTERS_END_MICORESHARED: {
            var mandatoryDocs = action.payload.filter(p => p.isMandatory);
            return {
                ...state,
                policyDocuments: {
                    ...state.policyDocuments,
                    mandatoryDocumentMaster: mandatoryDocs,
                    documentMaster: action.payload
                }
            }
        }
        case types.POLICY_GET_MEMBER_DOCUMENT_LIST_END_MICORESHARED: {
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    documentList: action.payload
                }
            }
        }
        case types.POLICY_GET_MEMBER_DOCUMENT_MASTERS_END_MICORESHARED: {
            var mandatoryDocs = action.payload.filter(p => p.isMandatory);
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    mandatoryDocumentMaster: mandatoryDocs,
                    documentMaster: action.payload
                }
            }
        }

        case types.UPDATE_POLICY_SORT_PARAMETER_MICORESHARED:
            {
                let sortStringDirection = state.policySearch.sortStringDirection
                let sortString = action.payload.status
                if (sortStringDirection == 0) {
                    sortStringDirection = 1
                    sortString = sortString + " ASC"
                }
                else if (sortStringDirection == 1) {
                    sortStringDirection = 2
                    sortString = sortString + " DESC"
                }
                else if (sortStringDirection == 2) {
                    sortStringDirection = 0
                    sortString = "IssueDate DESC"
                }
                return {
                    ...state,
                    policySearch: {
                        ...state.policySearch,
                        sortString: sortString,
                        sortStringDirection: sortStringDirection
                    }
                }
            }
        case types.UPDATE_POLICY_MEMBER_SORT_PARAMETER_MICORESHARED:
            {
                let sortStringDirection = state[action.payload.section].sortStringDirection
                let sortString = action.payload.status
                if (sortStringDirection == 0) {
                    sortStringDirection = 1
                    sortString = sortString + " ASC"
                }
                else if (sortStringDirection == 1) {
                    sortStringDirection = 2
                    sortString = sortString + " DESC"
                }
                else if (sortStringDirection == 2) {
                    sortStringDirection = 0
                    sortString = "FirstName"
                }
                return {
                    ...state,
                    [action.payload.section]: {
                        ...state[action.payload.section],
                        sortString: sortString,
                        sortStringDirection: sortStringDirection
                    }
                }
            }
        case types.UPDATE_INIT_OPTIONS:

            return {
                ...state,
                initOptions: {
                    ...state.initOptions,
                    [action.payload.name]: action.payload.value,
                }
            }
        case types.GET_POLICY_SUMMARY_END: {
            //console.log('action.result.brokerageInfo.dpsBrokerName', action.result.brokerageInfo.dpsBrokerName,)
            return {
                ...state,
                brokerageInfo: {
                    ...state.brokerageInfo,

                    brokerId: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerId,
                    brokerName: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerName,
                    selfBilling: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerSelfBillingYN == "Y" ? true : false,
                    rate: action.result.brokerageInfo == null ? state.brokerageInfo.rate : action.result.brokerageInfo.dpsBrokerRate,
                    amount: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerAmount,
                    vatType: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerVatType,
                    vat: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerVAT,
                    netAmount: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerNetAmount,
                    vatPerc: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.dpsBrokerVATPerc,
                    originalGrossPremium: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.originalGrossPremium,

                    isVatApplicable: action.result.brokerageInfo == null ? null : action.result.brokerageInfo.isVatApplicable,
                    commMinPerc: 0,// action.result.partyCommission == null ? 0 : action.result.partyCommission.commMinPerc,
                    commMaxPerc: action.result.partyCommission == null ? 0 : action.result.partyCommission.commMaxPerc,
                    commPerc: action.result.partyCommission == null ? 0 : action.result.partyCommission.commPerc,


                },
                tpaFees: {
                    ...state.tpaFees,
                    tpaId: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaId,
                    tpaName: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaName,
                    selfBilling: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaSelfBillingYN == "Y" ? true : false,
                    rate: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaRate,
                    amount: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaAmount,
                    vatType: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaVatType,
                    vat: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpavat,
                    netAmount: action.result.tpaFee == null ? null : action.result.tpaFee.dpstpaNetAmount,
                    //  [action.payload.name]: action.payload.value
                },
                TaxTable: {
                    ...state.TaxTable,
                    taxMaster: action.result.taxDto,
                },
                charges: {
                    ...state.charges,
                    chargesTable: action.result.summaryCharges,
                    quotationVatPercentage: action.result.vatPercentage,
                    vatTypeId: action.result.vatTypeId,
                    defaultChargesSetup: action.result.chargesSetup,


                },
                finalAmounts: {
                    ...state.finalAmounts,
                    //final amounts starts 
                    grossPremiumFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCPrem),
                    loadingFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCLoad),
                    discountFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCDISC),
                    splLoadingFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCSPLLoad),
                    netPremiumFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCPrem),
                    netToCustomerFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsClientNetFCPremium),
                    netToBrokerFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsBrokerNetFCPremium),
                    chargesFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossLCCHG),
                    vatFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsvatNetTOClient),
                    vatAdditionalFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsvatNetTOBroker),
                    brokerageFC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossBrokerFCPrem),
                    grossPremiumLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossLCPrem),
                    loadingLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCLoad),
                    discountLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossLCDISC),
                    splLoadingLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossFCSPLLoad),
                    netPremiumLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossLCPrem),
                    netToCustomerLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsClientNetFCPremium),
                    netToBrokerLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsBrokerNetLCPremium),
                    chargesLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossLCCHG),
                    vatLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsvatNetTOClient),
                    vatAdditionalLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsvatNetTOBroker),
                    brokerageLC: action.result.policyFinalSummary == null ? null : (action.result.policyFinalSummary.dpsGrossBrokerLCPrem),

                },
                tpaMasters: {
                    ...state.tpaMasters,
                    tpaMaster: action.result.tpaMasters
                }, masters: {
                    ...state.masters,
                    chargesTypeMasters: action.result.chargesType,
                }
            }
        }
        case types.GET_POLICY_MEMBER_PREMIUM_DETAILS_END: {

            return {
                ...state,
                memberPremium: action.pagedResult,
                memberPremiumFiltered: action.pagedResult,
            }
        }
        case types.SHOW_ADD_TO_POLICY_INFORMATION:

            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    showAddtoPolicy: action.status
                }
            }

        case types.ADD_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED: {

            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    insuredCode: action.payload.insuredcode,
                    insuredName: action.payload.insuredname,
                    customerId: null,
                    showAddInsured: false

                }
            }
        }
        case types.RESET_INSURED_CODE_INFORMATION_MICORESHARED:
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    insuredCode: '',
                    insuredName: '',
                    customerId: null,
                    showAddInsured: true,
                    showAddtoPolicy: false,
                }
            }
        case types.RESET_ENDORSEMENT_MODULE_STATE:
            return {
                ...state,
                policyEndorsement: {
                    ...state.policyEndorsement,
                    endorsementId: null,
                    endorsementTypeId: null,
                    endorsementNumber: null,
                    endorsementIssueDate: appUtility.getCurrentDate(),
                    endorsementSerialNumber: null,
                    endorsementEffectiveDateFrom: null,
                    documentNo: null,
                    documentType: null,
                    product: null,
                    branch: null,
                    endorsementCode: null,
                    endorsementApprovedBy: null,
                    endorsementApprovedDate: null,
                    policyIssueDate: null,
                    policyEffectiveDate: null,
                    policyExpiryDate: null,
                    endorsementDescription: null,
                    endorsementReason: null,
                    endorsementStatus: null,
                    partyAcCode: null,
                    partyName: null,
                    endorsementYear: appUtility.getCurrentYear(),
                    shortPeriod: null,
                    updateEntryExitDate: null,
                    AMLScreen: null,
                    policyId: null,
                    rowVersion: null,
                    operationMode: null,
                    isRefundChargesYN: null,
                    endorsementSerialNumberToUpdate: null,
                    endorsementIdToUpdate: null,
                    isAddChargesYN: null,
                    reflectInMainPolicyYN: null,
                    isHAADPenaltyYN:false,
                },
                policyInformation: {
                    ...state.policyInformation,
                    product: "",
                    plan: "",
                    policyNo: null,
                    policyId: null,
                    photoId: null,
                    photoName: null,
                    photoSrc: null,
                    department: null,
                    departmentName: null,
                    branch: "",
                    insuredCode: null,
                    insuredName: null,
                    accountNo: null,
                    accountName: null,
                    insuredVisaType: "",
                    accountNo: null,
                    businessType: "",
                    agent: "",
                    stage: "",
                    ageSlab: null,
                    scheme: null,
                    tariffCalculation: null,
                    actionStatus: "",
                    effectiveDate: null,
                    issueDate: null,
                    policyValidityDays: null,
                    policyExpiry: null,
                    expiryDate: null,
                    inceptionDate: null,
                    documentType: "New Policy",
                    visaEmirate: "",
                    promoCode: null,
                    premiumLocalCurr: null,
                    premiumForeignCurr: null,
                    insuredType: null,
                    docCollectPt: "",
                    showPolicyInformation: false,
                    showCurrentPolicyInformation: false,
                    isAgentEnabled: false,
                    oldPolicyNumber: null,
                    approvalDate: null,
                    totalMembers: null,
                    totalPrincipals: null,
                    totalDependents: null,
                    approvedBy: null,
                    underwritingYear: null,
                    currentPolicyId: null,
                    currentPolicyStage: null,
                    customerId: null,
                    maternityMinAge: null,
                    maternityMaxAge: null,
                    childMinAge: null,
                    childMaxAge: null,
                    tpaName: null,
                    rate: 0,
                    checkVisaEmirate: false,
                    goToMemberInformation: false,
                    productType: null,
                    isInsuredYN: null,
                    proposalId: null,
                    quotationNo: null,
                    quotationId: null,
                    jurisdictionAr: null,
                    jurisdictionEn: null,
                    subgroupBilling: "N",
                    isFac: "N",
                    renewedTo: null,
                    regulatoryAuthority: null,
                    vatLocation: null,
                    remarks: null,
                    cashTaggedUser: null,
                    haadTaggedUser: null,
                    haadStatus: null,
                    cashMode: null,
                    premiumMode: null,
                    installment: "N",
                    installmentNos: null,
                    installmentType: null,
                    markForCollectionCash: "N",
                    markForCollectionHaad: "N",
                    endorsementConfig: null,
                    showAddtoPolicy: null,
                    stageId: null,
                    actionStatusId: null,
                    isSubgroupExisting: false,
                    subProductTypeId: '',
                    lineOfBusiness: '',
                    currentEndorsementId: null,
                    cashReceiptNo: null,
                    haadReceiptNo: null,
                    isMigratedYN: null,
                    paidAmount: null,
                    outstandingAmount: null,
                    treatyId: null,
                    productMasters: [
                        { productId: 0, productName: null, productCode: null }
                    ],
                    planMasters: [
                        { planId: 0, planName: null, planCode: null, networkId: null }
                    ],
                    branchMasters: [
                        { brCode: 0, brName: null }
                    ],
                    ageMasters: [
                        { ageBand: null, ageBandId: 0 }
                    ],
                },
                memberInformation: {
                    ...state.memberInformation,
                    params: {
                        ...state.memberInformation.params,
                        policyNo: null,
                        memberId: null,
                        photoID: null,
                        salutation: null,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        dateofBirth: null,
                        age: null,
                        ageInMonths: null,
                        isAgeLessThan1: false,
                        isPrincipal: false,
                        relation: null,
                        principal: null,
                        emiratesId: null,
                        visaEmirates: null,
                        gender: null,
                        nationality: null,
                        maritalStatus: null,
                        passportNo: null,
                        mobile: null,
                        email: null,
                        salaryBand: null,
                        salary: null,
                        minSalary: null,
                        maxSalary: null,
                        height: null,
                        weight: null,
                        bmi: null,
                        profession: null,
                        idType: null,
                        dhaMemberType: null,
                        dhaMemberId: null,
                        dhaVerified: null,
                        workEmirate: null,
                        workLocation: null,
                        residentEmirate: null,
                        residentLocation: null,
                        birthCertificate: null,
                        uidNumber: null,
                        cutOffDate: null,
                        dhaStatus: null,
                        firstPolicy: true,
                        previousInsuranceCompany: null,
                        previousInsuranceNumber: null,
                        previousInsuranceExpiryDt: null,
                        entryDate: null,
                        visaExpiryDate: null,
                        isFirstPolicy: true,
                        elapsedDays: null,

                        memberId: null,
                        employeeId: null,
                        firstNameAr: null,
                        middleNameAr: null,
                        lastNameAr: null,
                        visaFileNo: null,
                        plan: null,
                        visaLocation: null,
                        medicalCardNumber: null,
                        visaType: null,
                        isNewEntry: false,
                        isResident: null,
                        dependentsCount: null,

                        premiumPerPerson: null,
                        extraPremium: null,
                        maternityPremium: null,
                        autoLoadingPerc: null,
                        autoLoadingAmt: null,
                        uwLoadingPerc: null,
                        uwLoadingAmt: null,
                        netLoadingPerc: null,
                        netLoadingAmt: null,
                        discountPerc: null,
                        discountAmt: null,
                        netPremium: null,
                        showMemberDetails: false,
                        basmaFee: 19,
                        haadPenalty: 0,
                        hcvFee: 18,
                        finalPenalty: 0,
                        showDubaiRegionFee: false,
                        showAbuDhabiRegionFee: false,
                        showDOHPenaltyButton: false,
                        isLocationMandatory: true,
                        memberInformationClass: false,
                        waiveOffAmt: null,
                        waiveOffBy: null,
                        waiveOffReason: null,

                        cocVerifiedYN: null,
                        cocBatchId: null,
                        cocLogBatchId: null,
                        cocRefNo: null,
                    },
                    flags: {
                        ...state.memberInformation.flags,
                        showMemberDependents: false
                    }
                },
                memberDetails: {
                    ...state.memberDetails,

                    details: [],
                    memberFilteredDetails: [],
                    mafFilteredDetails: [],
                    hasCheckedBoxInSearchResult: false,
                    showMembers: false,
                    isPrincipal: false,
                    currentMemberName: null,

                    memberUpload: {
                        censusDataCheck: false,
                        currentMemberImportPageId: 0,
                        memberImportFile: null,
                        memberImportFileName: null,
                        memberImportFileType: null,
                        memberImportFileEncryptedId: null,
                        memberImportFileId: null,
                        memberImportFileCheck: false,
                        importMemberDetails: [],
                        importMemberDetailsOriginal: [],
                        importMemberDataIsValid: null,
                        duplicationMessage: null,
                        isDuplicated: false,
                        principalMessage: null,
                        isPrincipalMessage: null,
                        encryptedFileIdWithErrors: null
                    }
                },
                accountDetails: {
                    ...state.accountDetails,
                    searchText: null,
                    accountDetailResult: [],
                },
                insuredInformation: {
                    ...state.insuredInformation,
                    insuredId: null,
                    insuredType: null,
                    emiratesId: null,
                    mobile: null,
                    salutation: null,
                    firstName: null,
                    middleName: null,
                    lastName: null,
                    gender: null,
                    maritalSatus: null,
                    dateofBirth: null,
                    nationality: null,
                    email: null,
                    policyInsuredType: null,
                    policyPolicyType: null,
                    companyCRNumber: null,
                    policysalutation: null,
                    fullName: null,
                    tradeLicenseNo: null,
                    tradeLicenseExpiryDate: null,
                    policyEmail: null,
                    entityType: null,
                    entityId: null,
                    isInsuredTypeIndividual: true,
                    companyMobile: null,
                    masterValues: [],
                    insuredCodes: [],
                    nameSearch: null,
                    fullNameArabic: null,
                    showAddnewSection: false,
                },
                modalsState: {
                    ...state.modalsState,
                    showEndorsementModal: false,
                    showAccountsModal: false,
                    showInsuredMasterCodesModal: false,
                    showPolicyInformationModal: false,
                    showCategoryListModal: false,
                    showCheckListModal: false,
                    showPolicyTOBModal: false,
                    showLoadingDistributionModal: false,
                    showBaseBenefitModal: false,
                    showCostingSheetModal: false,
                    showInsuredInformationModal: false,
                    showSubgroupBillingModal: false,
                    showRemarksModal: false,
                    showCommunicationModal: false,
                    showPremiumBifurcationModal: false,
                    showIndividualQuoteSummaryCharges: false,
                    showGroupQuoteSummaryCharges: false,
                    showPolicySummaryCharges: false,
                    showApprovalModal: false,
                    showNasMemberModal: false,
                },
                brokerageInfo: {
                    ...state.brokerageInfo,
                    brokerId: null,
                    brokerName: null,
                    selfBilling: false,
                    rate: null,
                    amount: null,
                    vatType: null,
                    vat: null,
                    netAmount: null,
                    commMinPerc: null,
                    commMaxPerc: null,
                    commPerc: null,
                    vatPerc: null,
                    isVatApplicable: null,

                },
                tpaFees: {
                    ...state.tpaFees,
                    tpaId: null,
                    tpaName: null,
                    selfBilling: false,
                    rate: null,
                    amount: null,
                    vatType: null,
                    vat: null,
                    netAmount: null,
                    vatPerc: null,

                },
                finalAmounts: {
                    ...state.finalAmounts,
                    grossPremiumFC: null,
                    loadingFC: null,
                    discountFC: null,
                    splLoadingFC: null,
                    splDiscountFC: null,
                    netPremiumFC: null,
                    netToCustomerFC: null,
                    netToBrokerFC: null,
                    chargesFC: null,
                    vatFC: null,
                    vatAdditionalFC: null,
                    brokerageFC: null,
                    grossPremiumLC: null,
                    loadingLC: null,
                    discountLC: null,
                    splLoadingLC: null,
                    splDiscountLC: null,
                    netPremiumLC: null,
                    netToCustomerLC: null,
                    netToBrokerLC: null,
                    chargesLC: null,
                    vatLC: null,
                    vatAdditionalLC: null,
                    brokerageLC: null,
                },
                tpaMasters: {
                    ...state.tpaMasters,
                    tpaMaster: [],
                },
                TaxTable: {
                    ...state.TaxTable,
                    taxMaster: [],
                },
                memberPremium: {
                    ...state.memberPremium,

                    memberPremium: []
                },
                memberPremiumFiltered: {
                    ...state.memberPremiumFiltered,

                    memberPremiumFiltered: []
                },

                charges: {
                    ...state.charges,
                    chargesTable: [],
                    grossPremiumSection: null,
                    grossChargesSection: null,
                    grossChargesWithoutVAT: null,
                    basePremiumTotal: null,
                    uwAmt: null,
                    netAmt: null,
                    netPERc: null,
                    uwPerc: null,
                    autoAmt: null,
                    autoPerc: null,
                    disAmt: null,
                    disPerc: null,
                    chargesVAT: null,
                },
                dependentDetails: {
                    ...state.dependentDetails,

                    details: [],
                    dependentFilteredDetails: [],
                    hasCheckedBoxInSearchResult: false,
                    showDependents: false,
                    currentMemberName: null
                },
                dependentInformation: {
                    ...state.dependentInformation,

                    params: {
                        policyNo: null,
                        memberId: null,
                        photoId: null,
                        photoName: null,
                        photoSrc: null,
                        salutation: null,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        dateofBirth: null,
                        age: null,
                        ageInMonths: null,
                        isAgeLessThan1: false,
                        isPrincipal: false,
                        relation: null,
                        principal: null,
                        emiratesId: null,
                        visaEmirates: null,
                        gender: null,
                        nationality: null,
                        maritalStatus: null,
                        passportNo: null,
                        mobile: null,
                        email: null,
                        salaryBand: null,
                        salary: null,
                        minSalary: null,
                        maxSalary: null,
                        height: null,
                        weight: null,
                        bmi: null,
                        profession: null,
                        idType: null,
                        dhaMemberType: null,
                        dhaMemberId: null,
                        dhaVerified: null,
                        workEmirate: null,
                        workLocation: null,
                        residentEmirate: null,
                        residentLocation: null,
                        birthCertificate: null,
                        uidNumber: null,
                        cutOffDate: null,
                        dhaStatus: null,
                        firstPolicy: true,
                        previousInsuranceCompany: null,
                        previousInsuranceNumber: null,
                        previousInsuranceExpiryDt: null,
                        entryDate: null,
                        visaExpiryDate: null,
                        isFirstPolicy: true,
                        isLocationMandatory: true,
                        employeeId: null,
                        firstNameAr: null,
                        middleNameAr: null,
                        lastNameAr: null,
                        visaFileNo: null,
                        plan: null,
                        visaLocation: null,
                        medicalCardNumber: null,
                        visaType: null,
                        isNewEntry: false,
                        isResident: null,
                        premiumPerPerson: null,
                        extraPremium: null,
                        maternityPremium: null,
                        autoLoadingPerc: null,
                        autoLoadingAmt: null,
                        uwLoadingPerc: null,
                        uwLoadingAmt: null,
                        netLoadingPerc: null,
                        netLoadingAmt: null,
                        discountPerc: null,
                        discountAmt: null,
                        netPremium: null,
                        showDependentInformation: false,
                        basmaFee: 19,
                        haadPenalty: 0,
                        hcvFee: 18,
                        finalPenalty: 0,
                        showDubaiRegionFee: false,
                        showAbuDhabiRegionFee: false,
                        showDOHPenaltyButton: false,
                        elapsedDays: null,
                        waiveOffAmt: null,
                        waiveOffBy: null,
                        waiveOffReason: null
                    }
                },

                /*Document Tab*/
                // initialState.currentDocumentPageId = null
                policyDocuments: {
                    ...state.policyDocuments,
                    documentList: [],
                    mandatoryDocumentMaster: [],
                    documentMaster: [],
                    hasCheckedBoxInDocuments: false
                },
                memberDocuments: {
                    ...state.memberDocuments,
                    documentList: [],
                    mandatoryDocumentMaster: [],
                    documentMaster: [],
                    isPolicyModuleDocument: false,
                    isMemberDocument: false,
                    hasCheckedBoxInDocuments: false
                }
            }
        case types.RESET_ENDORSEMENT_SEARCH_STATE:
            return {
                ...state,
                policyInformation: initialState.policyInformation,
                policySearch: initialState.policySearch,
                modalsState: {
                    ...state.modalsState,
                    showEndorsementModal: false,
                    showAccountsModal: false,
                    showInsuredMasterCodesModal: false,
                    showPolicyInformationModal: false,
                    showCategoryListModal: false,
                    showCheckListModal: false,
                    showPolicyTOBModal: false,
                    showLoadingDistributionModal: false,
                    showBaseBenefitModal: false,
                    showCostingSheetModal: false,
                    showInsuredInformationModal: false,
                    showSubgroupBillingModal: false,
                    showRemarksModal: false,
                    showCommunicationModal: false,
                    showPremiumBifurcationModal: false,
                    showApprovalModal: false,
                },
            }
        case types.RESET_MODAL_STATE:
            return {
                ...state,
                modalsState: initialState.modalsState,
            }
        case types.UPDATE_POLICY_FILE_CHANGE_END_MICORESHARED: {
            var memberImportedFileCheck = state.memberDetails.memberUpload.importMemberDetails.length == constants.IS_ZERO ? false : true;
            return {
                ...state,
                memberDetails: {
                    ...state.memberDetails,
                    memberUpload: {
                        ...state.memberDetails.memberUpload,
                        memberImportFileName: action.payload.updatedFile.memberImportFileName,
                        memberImportFileType: action.payload.updatedFile.memberImportFileType,
                        memberImportFileEncryptedId: action.payload.updatedFile.memberImportFileEncryptedId,
                        memberImportFileId: action.payload.updatedFile.memberImportFileId,
                        memberImportFileCheck: memberImportedFileCheck,
                    }
                }
            }
        }
        case types.GET_MEMBER_DETAILS_PAGED_RESULT_MICORESHARED:
            {
                let memberDetails = state.memberDetails.memberUpload.importMemberDetailsOriginal;
                let currentPage = action.payload.page;
                let pageSize = constants.IMPORT_MEMBER_PAGE_SIZE
                let sort = null
                let totalCount = memberDetails.length;
                let totalPages = Math.ceil(totalCount / constants.IMPORT_MEMBER_PAGE_SIZE)
                currentPage = currentPage < constants.IMPORT_MEMBER_FIRST_PAGE ? constants.IMPORT_MEMBER_FIRST_PAGE : currentPage;
                currentPage = currentPage > totalPages ? totalPages : currentPage;
                let hasNextPage = currentPage == totalPages ? false : true
                let hasPreviousPage = currentPage == constants.IMPORT_MEMBER_FIRST_PAGE ? false : true;
                let startingIndex = constants.IMPORT_MEMBER_PAGE_SIZE * currentPage - constants.IMPORT_MEMBER_PAGE_SIZE;
                let endingIndex = startingIndex + constants.IMPORT_MEMBER_PAGE_SIZE
                let filteredPages = memberDetails.slice(startingIndex, endingIndex);
                let memberImportFileCheck = memberDetails.length == constants.IS_ZERO ? false : true;
                let pagedResult = {
                    currentPage: currentPage,
                    pageSize: pageSize,
                    sort: sort,
                    totalCount: totalCount,
                    totalPages: totalPages,
                    hasNextPage: hasNextPage,
                    hasPreviousPage: hasPreviousPage,
                    result: filteredPages
                }
                return {
                    ...state,
                    memberDetails: {
                        ...state.memberDetails,
                        memberUpload: {
                            ...state.memberDetails.memberUpload,
                            importMemberDetails: pagedResult,
                            memberImportFileCheck: memberImportFileCheck
                        }
                    }
                }
            }
        case types.GET_POLICY_MEMBER_DETAILS_END_MICORESHARED:
            {
                let memberDetails = state.memberDetails.memberUpload.importMemberDetailsOriginal;
                let currentPage = constants.IMPORT_MEMBER_FIRST_PAGE;
                let pageSize = constants.IMPORT_MEMBER_PAGE_SIZE
                let sort = null
                let totalCount = action.result.length;
                let totalPages = Math.ceil(totalCount / constants.IMPORT_MEMBER_PAGE_SIZE)
                let hasNextPage = currentPage == totalPages ? false : true
                let hasPreviousPage = false
                let result = action.result.slice(constants.IS_ZERO, constants.IMPORT_MEMBER_PAGE_SIZE);
                let pagedResult = {
                    currentPage: currentPage,
                    pageSize: pageSize,
                    sort: sort,
                    totalCount: totalCount,
                    totalPages: totalPages,
                    hasNextPage: hasNextPage,
                    hasPreviousPage: hasPreviousPage,
                    result: result
                }
                let duplicateMessage = "";
                let duplicatedCheck = false;
                let principalMessage = "";
                let principalCheck = false;
                action.result.map((item) => {
                    if (item.duplicationMessage != "") {
                        duplicateMessage = duplicateMessage.concat(item.duplicationMessage + ";\n ");
                        duplicatedCheck = true
                    }
                    if (item.principalMessage != "") {
                        principalMessage = item.principalMessage
                        principalCheck = true
                    }
                });
                let memberImportFileCheck = action.result.length == constants.IS_ZERO ? false : true;
                return {
                    ...state,
                    memberDetails: {
                        ...state.memberDetails,
                        memberUpload: {
                            ...state.memberDetails.memberUpload,
                            importMemberDetails: pagedResult,
                            importMemberDetailsOriginal: action.result,
                            memberImportFileCheck: memberImportFileCheck,
                            duplicationMessage: duplicateMessage,
                            isDuplicated: duplicatedCheck,
                            principalMessage: principalMessage,
                            isPrincipalMessage: principalCheck
                        }
                    }
                }
            }
        case types.GET_POLICY_MEMBER_DETAILS_STATUS_CHECK_MICORESHARED: {
            var statusCheckCount = action.result.filter(x => x.isValid == true);
            var statusCheck = statusCheckCount.length >= constants.IS_ONE ? true : false
            return {
                ...state,
                memberDetails: {
                    ...state.memberDetails,
                    memberUpload: {
                        ...state.memberDetails.memberUpload,
                        importMemberDataIsValid: statusCheck,
                    }
                }
            }
        }
        case types.RESET_UPLOAD_MEMBER_DATA_MICORESHARED: {
            return {
                ...state,
                memberDetails: {
                    ...state.memberDetails,
                    memberUpload: {
                        ...state.memberDetails.memberUpload,
                        currentMemberImportPageId: 0,
                        memberImportFile: null,
                        memberImportFileName: null,
                        memberImportFileType: null,
                        memberImportFileEncryptedId: null,
                        memberImportFileId: null,
                        memberImportFileCheck: false,
                        importMemberDetails: [],
                        importMemberDetailsOriginal: [],
                        importMemberDataIsValid: false,
                        encryptedFileIdWithErrors: null,
                    }
                }
            }
        }
        case types.GET_VERIFICATION_BATCH_LISTING_END: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    dohBatchListing: action.result,
                }
            }
        }
        case types.GET_CURRENT_DOH_MEMBER_INFO_END: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    dohBatchDetails: action.result,
                    filterdBatchDetailsResult: action.result.result,
                }
            }
        }
        case types.UPDATE_CURRENT_BATCH_PARAMS: {

            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    [action.payload.name]: action.payload.value
                    // currentBatchId:action.payload.currentBatchId,
                    // currentActionSource:action.payload.currentActionSource,
                }
            }
        }
        case types.GET_DOH_MEMBER_BY_ID_END: {
            return {
                ...state,
                dohMemberDetail: {
                    ...state.dohMemberDetail,
                    policyNumber: action.payload.result == null ? null : action.payload.result.policyNumber,
                    documentId: action.payload.result == null ? null : action.payload.result.documentId,
                    mstMemberId: action.payload.result == null ? null : action.payload.result.mstMemberId,
                    quotationId: action.payload.result == null ? null : action.payload.result.quotationId,
                    transmissionLastTryDate: action.payload.result == null ? null : action.payload.result.transmissionLastTryDate,
                    transmissionTryCount: action.payload.result == null ? null : action.payload.result.transmissionTryCount,
                    dohVerificationResponse: action.payload.result == null ? null : action.payload.result.dohVerificationResponse,
                    shafafiyaUploadResponse: action.payload.result == null ? null : action.payload.result.shafafiyaUploadResponse,
                    isDohVerifiedYn: action.payload.result == null ? null : action.payload.result.isDohVerifiedYn,
                    isDohUploadedYn: action.payload.result == null ? null : action.payload.result.isDohUploadedYn,
                    unifiedNumber: action.payload.result == null ? null : action.payload.result.unifiedNumber,
                    identityCardNumber: action.payload.result == null ? null : action.payload.result.identityCardNumber,
                    identityCardIssueDt: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.identityCardIssueDt),
                    identityCardExpiryDt: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.identityCardExpiryDt),
                    nationalityId: action.payload.result == null ? null : action.payload.result.nationalityId,
                    nationalityShaId: action.payload.result == null ? null : action.payload.result.nationalityShaId,
                    nationalityDescAr: action.payload.result == null ? null : action.payload.result.nationalityDescAr,
                    nationalityDescEn: action.payload.result == null ? null : action.payload.result.nationalityDescEn,
                    personFullNameAr: action.payload.result == null ? null : action.payload.result.personFullNameAr,
                    personFirstNameAr: action.payload.result == null ? null : action.payload.result.personFirstNameAr,
                    personSecondNameAr: action.payload.result == null ? null : action.payload.result.personSecondNameAr,
                    personThirdNameAr: action.payload.result == null ? null : action.payload.result.personThirdNameAr,
                    personFourthNameAr: action.payload.result == null ? null : action.payload.result.personFourthNameAr,
                    personClanNameAr: action.payload.result == null ? null : action.payload.result.personClanNameAr,
                    personFullNameEn: action.payload.result == null ? null : action.payload.result.personFullNameEn,
                    personFirstNameEn: action.payload.result == null ? null : action.payload.result.personFirstNameEn,
                    personSecondNameEn: action.payload.result == null ? null : action.payload.result.personSecondNameEn,
                    personThirdNameEn: action.payload.result == null ? null : action.payload.result.personThirdNameEn,
                    personFourthNameEn: action.payload.result == null ? null : action.payload.result.personFourthNameEn,
                    personClanNameEn: action.payload.result == null ? null : action.payload.result.personClanNameEn,
                    personKhulasitQaidNumber: action.payload.result == null ? null : action.payload.result.personKhulasitQaidNumber,
                    personFamilyBookNumber: action.payload.result == null ? null : action.payload.result.personFamilyBookNumber,
                    personEdbarahNumber: action.payload.result == null ? null : action.payload.result.personEdbarahNumber,
                    genderId: action.payload.result == null ? null : action.payload.result.genderId,
                    genderDescAr: action.payload.result == null ? null : action.payload.result.genderDescAr,
                    genderDescEn: action.payload.result == null ? null : action.payload.result.genderDescEn,
                    occupationId: action.payload.result == null ? null : action.payload.result.occupationId,
                    occupationDescAr: action.payload.result == null ? null : action.payload.result.occupationDescAr,
                    occupationDescEn: action.payload.result == null ? null : action.payload.result.occupationDescEn,
                    faithId: action.payload.result == null ? null : action.payload.result.faithId,
                    faithDescAr: action.payload.result == null ? null : action.payload.result.faithDescAr,
                    faithDescEn: action.payload.result == null ? null : action.payload.result.faithDescEn,
                    dob: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.dob),
                    countryOfBirthId: action.payload.result == null ? null : action.payload.result.countryOfBirthId,
                    countryOfBirthShaId: action.payload.result == null ? null : action.payload.result.countryOfBirthShaId,
                    countryOfBirthDescAr: action.payload.result == null ? null : action.payload.result.countryOfBirthDescAr,
                    countryOfBirthDescEn: action.payload.result == null ? null : action.payload.result.countryOfBirthDescEn,
                    emirateOfBirthId: action.payload.result == null ? null : action.payload.result.emirateOfBirthId,
                    emirateOfBirthDescAr: action.payload.result == null ? null : action.payload.result.emirateOfBirthDescAr,
                    emirateOfBirthDescEn: action.payload.result == null ? null : action.payload.result.emirateOfBirthDescEn,
                    cityOfBirthId: action.payload.result == null ? null : action.payload.result.cityOfBirthId,
                    cityOfBirthDescAr: action.payload.result == null ? null : action.payload.result.cityOfBirthDescAr,
                    cityOfBirthDescEn: action.payload.result == null ? null : action.payload.result.cityOfBirthDescEn,
                    placeOfBirthAr: action.payload.result == null ? null : action.payload.result.placeOfBirthAr,
                    placeOfBirthEn: action.payload.result == null ? null : action.payload.result.placeOfBirthEn,
                    maritalStatusId: action.payload.result == null ? null : action.payload.result.maritalStatusId,
                    maritalStatusDescAr: action.payload.result == null ? null : action.payload.result.maritalStatusDescAr,
                    maritalStatusDescEn: action.payload.result == null ? null : action.payload.result.maritalStatusDescEn,
                    religionId: action.payload.result == null ? null : action.payload.result.religionId,
                    religionDescAr: action.payload.result == null ? null : action.payload.result.religionDescAr,
                    religionDescEn: action.payload.result == null ? null : action.payload.result.religionDescEn,
                    sponsorNumber: action.payload.result == null ? null : action.payload.result.sponsorNumber,
                    sponsorNameEn: action.payload.result == null ? null : action.payload.result.sponsorNameEn,
                    sponsorNameAr: action.payload.result == null ? null : action.payload.result.sponsorNameAr,
                    personTypeId: action.payload.result == null ? null : action.payload.result.personTypeId,
                    personTypeDescAr: action.payload.result == null ? null : action.payload.result.personTypeDescAr,
                    personTypeDescEn: action.payload.result == null ? null : action.payload.result.personTypeDescEn,
                    errorCode: action.payload.result == null ? null : action.payload.result.errorCode,
                    errorDesc: action.payload.result == null ? null : action.payload.result.errorDesc,
                    passportExpiryDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.passportExpiryDate),
                    passportIssueDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.passportIssueDate),
                    passportNumber: action.payload.result == null ? null : action.payload.result.passportNumber,
                    passportIssueCountryId: action.payload.result == null ? null : action.payload.result.passportIssueCountryId,
                    passportIssueCountryDescAr: action.payload.result == null ? null : action.payload.result.passportIssueCountryDescAr,
                    passportIssueCountryDescEn: action.payload.result == null ? null : action.payload.result.passportIssueCountryDescEn,
                    passportIssuePlace: action.payload.result == null ? null : action.payload.result.passportIssuePlace,
                    passportType: action.payload.result == null ? null : action.payload.result.passportType,
                    passportTypeId: action.payload.result == null ? null : action.payload.result.passportTypeId,
                    passportTypeDescAr: action.payload.result == null ? null : action.payload.result.passportTypeDescAr,
                    passportTypeDescEn: action.payload.result == null ? null : action.payload.result.passportTypeDescEn,
                    immigrationNumber: action.payload.result == null ? null : action.payload.result.immigrationNumber,
                    immigrationIssueDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.immigrationIssueDate),
                    immigartionExpiryDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.immigartionExpiryDate),
                    batchId: action.payload.result == null ? null : action.payload.result.batchId,
                    transactionId: action.payload.result == null ? null : action.payload.result.transactionId,
                    endorsementId: action.payload.result == null ? null : action.payload.result.endorsementId,
                    transmissionDate: action.payload.result == null ? null : action.payload.result.transmissionDate,
                    dohLogMemberId: action.payload.result == null ? null : action.payload.result.dohLogMemberId,
                    finalStatus: action.payload.result == null ? null : action.payload.result.finalStatus,




                    firstName: action.payload.result == null ? null : action.payload.result.personFullNameEn,
                    firstNameEN: action.payload.result == null ? null : action.payload.result.personFirstNameEn,
                    middleNameEN: action.payload.result == null ? null : action.payload.result.middleNameEn,
                    lastNameEN: action.payload.result == null ? null : action.payload.result.lastNameEn,
                    firstNameAR: action.payload.result == null ? null : action.payload.result.personFirstNameAr,
                    middleNameAR: action.payload.result == null ? null : action.payload.result.middleNameAr,
                    lastNameAR: action.payload.result == null ? null : action.payload.result.lastNameAr,
                    contactNumber: action.payload.result == null ? null : action.payload.result.contactNumber,
                    nationalityCode: action.payload.result == null ? null : action.payload.result.nationalityCode,
                    city: action.payload.result == null ? null : action.payload.result.cityName,
                    medicalIdNo: action.payload.result == null ? null : action.payload.result.medicalIdNo,
                    relation: action.payload.result == null ? null : action.payload.result.relation,
                    relationTo: action.payload.result == null ? null : action.payload.result.relationTo,
                    payerId: action.payload.result == null ? null : action.payload.result.payerId,
                    packageName: action.payload.result == null ? null : action.payload.result.packageName,
                    startDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.startDate),
                    renewalDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.renewelDate),
                    expiryDate: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.expiryDate),
                    grossPremium: action.payload.result == null ? null : action.payload.result.grossPremium,
                    policyHolder: action.payload.result == null ? null : action.payload.result.policyHolder,
                    companyId: action.payload.result == null ? null : action.payload.result.companyId,
                    collectedPremium: action.payload.result == null ? null : action.payload.result.collectedPremium,
                    vat: action.payload.result == null ? null : action.payload.result.vat,
                    vatPerc: action.payload.result == null ? null : action.payload.result.vatPercent,
                    //  status:action.payload.result == null ? null : action.payload.result.status,
                    shafafiyaStatusType: action.payload.result == null ? null : action.payload.result.shafafiyaStatusType,
                }
            }
        }

        case types.UPDATE_DOH_MEMBER_INFO_PARAMS: {
            return {
                ...state,
                dohMemberDetail: {
                    ...state.dohMemberDetail,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        /*  case types.UPDATE_SHAHFAFIYA_BATCH_LISTING_CHECKBOX_STATE: {
              return {
                  ...state,
                  memberDetails: {
                      ...state.memberDetails,
                      memberUpload: {
                          ...state.memberDetails.memberUpload,
                          currentMemberImportPageId: 0,
                      }
                  }
              }
          }*/
        case types.UPDATE_DOH_BATCH_LISTING_CHECKBOX_STATE: {
            console.log("action.payload.checked", action.payload.checked, "-", action.payload.id)
            let checked = action.payload.checked;
            const searchResults = state.dohVerification.dohBatchListing.result;
            console.log("searchresults", searchResults)
            const updatedResults = searchResults.map((result) => {
                if (result.batchId == action.payload.id) {
                    return {
                        ...result,
                        isChecked: checked
                    };
                }
                return result;
            });
            console.log("aupdatedResults", updatedResults)

            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    dohBatchListing: {
                        ...state.dohVerification.dohBatchListing,
                        result: updatedResults
                    },

                },
            };

        }
        case types.UPDATE_DOH_MEMBER_SEARCH_PARAMS: {

            if (state.dohVerification.currentActionSource == appConstants.DHA_VERIFICATION) {
                let memberTableValuesOriginal = state.dohVerification.dhaBatchDetails;
                let filteredValues = memberTableValuesOriginal?.result?.filter((e) => e?.fullName?.toLowerCase()?.match(action?.payload?.value?.toLowerCase()));
                return {
                    ...state,

                    dohVerification: {
                        ...state.dohVerification,
                        filterdDhaBatchDetailsResult: filteredValues

                    }
                }
            } else {
                let memberTableValuesOriginal = state.dohVerification.dohBatchDetails;
                let filteredValues = memberTableValuesOriginal?.result?.filter((e) => e?.personFullNameEn?.toLowerCase()?.match(action?.payload?.value?.toLowerCase()));
                return {
                    ...state,

                    dohVerification: {
                        ...state.dohVerification,
                        filterdBatchDetailsResult: filteredValues

                    }
                }
            }

        }

        case types.UPDATE_DHA_MEMBER_INFO_PARAMS: {
            return {
                ...state,
                dhaMemberDetail: {
                    ...state.dhaMemberDetail,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.GET_DHA_MEMBER_BY_ID_END: {
            return {
                ...state,
                dhaMemberDetail: {
                    ...state.dhaMemberDetail,
                    registrationUploadId: action.payload.result == null ? null : action.payload.result.registrationUploadId,
                    batchId: action.payload.result == null ? null : action.payload.result.batchId,
                    documentId: action.payload.result == null ? null : action.payload.result.documentId,
                    endorsementId: action.payload.result == null ? null : action.payload.result.endorsementId,
                    memberId: action.payload.result == null ? null : action.payload.result.memberId,
                    header: action.payload.result == null ? null : action.payload.result.header,
                    senderId: action.payload.result == null ? null : action.payload.result.senderId,
                    receiverId: action.payload.result == null ? null : action.payload.result.receiverId,
                    payerId: action.payload.result == null ? null : action.payload.result.payerId,
                    tpaId: action.payload.result == null ? null : action.payload.result.tpaId,
                    intermediaryId: action.payload.result == null ? null : action.payload.result.intermediaryId,
                    transactionDate: action.payload.result == null ? null : action.payload.result.transactionDate,
                    recordCount: action.payload.result == null ? null : action.payload.result.recordCount,
                    dispositionFlag: action.payload.result == null ? null : action.payload.result.dispositionFlag,
                    memberType: action.payload.result == null ? null : action.payload.result.memberType,
                    fullName: action.payload.result == null ? null : action.payload.result.fullName,
                    contactNumber: action.payload.result == null ? null : action.payload.result.contactNumber,
                    dob: action.payload.result == null ? null : appUtility.formatDate(action.payload.result.dob),
                    gender: action.payload.result == null ? null : action.payload.result.gender,
                    nationality: action.payload.result == null ? null : action.payload.result.nationality,
                    passportNumber: action.payload.result == null ? null : action.payload.result.passportNumber,
                    maritalStatus: action.payload.result == null ? null : action.payload.result.maritalStatus,
                    emirate: action.payload.result == null ? null : action.payload.result.emirate,
                    residentialLocation: action.payload.result == null ? null : action.payload.result.residentialLocation,
                    workLocation: action.payload.result == null ? null : action.payload.result.workLocation,
                    salary: action.payload.result == null ? null : action.payload.result.salary,
                    commission: action.payload.result == null ? null : action.payload.result.commission,
                    emiratesIdNumber: action.payload.result == null ? null : action.payload.result.emiratesIdNumber,
                    uidNumber: action.payload.result == null ? null : action.payload.result.uidNumber,
                    gdrfaFileNumber: action.payload.result == null ? null : action.payload.result.gdrfaFileNumber,
                    birthCertificateNumber: action.payload.result == null ? null : action.payload.result.birthCertificateNumber,
                    relation: action.payload.result == null ? null : action.payload.result.relation,
                    relationTo: action.payload.result == null ? null : action.payload.result.relationTo,
                    productOrigin: action.payload.result == null ? null : action.payload.result.productOrigin,
                    productCode: action.payload.result == null ? null : action.payload.result.productCode,
                    productId: action.payload.result == null ? null : action.payload.result.productId,
                    policySequence: action.payload.result == null ? null : action.payload.result.policySequence,
                    topUpPolicy: action.payload.result == null ? null : action.payload.result.topUpPolicy,
                    enrollmentDate: action.payload.result == null ? null : action.payload.result.enrollmentDate,
                    deletionDate: action.payload.result == null ? null : action.payload.result.deletionDate,
                    grossPremium: action.payload.result == null ? null : action.payload.result.grossPremium,
                    netPremium: action.payload.result == null ? null : action.payload.result.netPremium,
                    intermediaryFee: action.payload.result == null ? null : action.payload.result.intermediaryFee,
                    tpaFees: action.payload.result == null ? null : action.payload.result.tpaFees,
                    tpaFeeType: action.payload.result == null ? null : action.payload.result.tpaFeeType,
                    ipCopay: action.payload.result == null ? null : action.payload.result.ipCopay,
                    opCopay: action.payload.result == null ? null : action.payload.result.opCopay,
                    opConsultationCopay: action.payload.result == null ? null : action.payload.result.opConsultationCopay,
                    pharmacyCopay: action.payload.result == null ? null : action.payload.result.pharmacyCopay,
                    dentalCopay: action.payload.result == null ? null : action.payload.result.dentalCopay,
                    opticalCopay: action.payload.result == null ? null : action.payload.result.opticalCopay,
                    maternityCopay: action.payload.result == null ? null : action.payload.result.maternityCopay,
                    entityType: action.payload.result == null ? null : action.payload.result.entityType,
                    entityId: action.payload.result == null ? null : action.payload.result.entityId,
                    establishmentEmail: action.payload.result == null ? null : action.payload.result.establishmentEmail,
                    photo: action.payload.result == null ? null : action.payload.result.photo,
                    responseStatusCode: action.payload.result == null ? null : action.payload.result.responseStatusCode,
                    responseTransactionId: action.payload.result == null ? null : action.payload.result.responseTransactionId,
                    dhaMemberId: action.payload.result == null ? null : action.payload.result.dhaMemberId,
                    responseMessage: action.payload.result == null ? null : action.payload.result.responseMessage,
                    responseReport: action.payload.result == null ? null : action.payload.result.responseReport,
                    approvalDate: action.payload.result == null ? null : action.payload.result.approvalDate,
                    createdDateTime: action.payload.result == null ? null : action.payload.result.createdDateTime,
                    createdBy: action.payload.result == null ? null : action.payload.result.createdBy,
                    nationalityId: action.payload.result == null ? null : action.payload.result.nationalityId,
                    memberTypeId: action.payload.result == null ? null : action.payload.result.memberTypeId,
                    genderId: action.payload.result == null ? null : action.payload.result.genderId,
                }
            }
        }
        case types.GET_CURRENT_DHA_MEMBER_INFO_END: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    dhaBatchDetails: action.result,
                    filterdDhaBatchDetailsResult: action.result.result,
                }
            }
        }
        case types.CALCULATE_HAAD_PENALTY_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        haadPenalty: action.payload.haadPenalty.haadPenalty,
                        finalPenalty: state[action.payload.memberType].params.waiveOffAmt == null ? action.payload.haadPenalty.haadPenalty : action.payload.haadPenalty.haadPenalty - state[action.payload.memberType].params.waiveOffAmt,
                        cutOffDate: action.payload.haadPenalty.cutOffDate == null ? null : appUtility.formatDate(action.payload.haadPenalty.cutOffDate),
                        elapsedDays: action.payload.haadPenalty.elapsedDays ?? 0,
                    }
                }
            }
        case types.UPDATE_CHANGE_OF_CATEGORY_HAS_ERROR_MICORESHARED: {
            console.log("i am hit")
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        changeOfCategoryHasError: action.payload.hasError
                    }
                }
            }
        }


        case types.UPDATE_MEDICAL_CARDS_BATCH_FILE_CHANGE_END: {

            return {
                ...state,
                medicalCardNoBatchUpload: {
                    ...state.medicalCardNoBatchUpload,
                    batchUploadedFileName: action.payload.updatedFile.batchUploadedFileName,
                    batchUploadedFileType: action.payload.updatedFile.batchUploadedFileType,
                    batchUploadedEncryptedFileId: action.payload.updatedFile.batchUploadedEncryptedFileId,
                    batchUploadFileId: action.payload.updatedFile.batchUploadFileId,
                    duplicationCount: null,
                    successCount: null,
                    duplicatedRecords: [],
                    //memberImportFileCheck: memberImportedFileCheck,
                }
            }
        }
        case types.MEDICAL_CARDS_BATCH_INFO_CHANGE: {
            return {
                ...state,
                medicalCardNoBatchUpload: {
                    ...state.medicalCardNoBatchUpload,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.CLEAR_MEDICAL_CARDS_BATCH_FILE_CHANGE: {
            return {
                ...state,
                medicalCardNoBatchUpload: {
                    ...state.medicalCardNoBatchUpload,
                    tpaId: null,
                    batchUploadedEncryptedFileId: null,
                    batchUploadedFileName: null,
                    batchUploadedFileType: null,
                    batchUploadFileId: null,
                    batchUploadFile: null,
                    duplicationCount: null,
                    successCount: null,
                    duplicatedRecords: [],
                }
            }
        }
        case types.UPLOAD_MEDICAL_CARD_BATCH_END: {

            return {
                ...state,
                medicalCardNoBatchUpload: {
                    ...state.medicalCardNoBatchUpload,
                    successCount: action.result.successCount,
                    duplicationCount: action.result.duplicationCount,
                    duplicatedRecords: action.result.validationResult,
                }
            }
        }
        case types.UPDATE_INSTALLMENT_PARAMS: {
            let slNo = parseFloat(action.payload.id);
            let installments = state.installments.result;
            const updatedInstallments = installments.map((result) => {
                if (result.docInstId == slNo) {
                    return {
                        ...result,
                        [action.payload.name]: action.payload.value
                    };
                }
                return result;
            });
            return {
                ...state,
                installments: {
                    ...state.installments,
                    result: updatedInstallments,
                }
            }
        }
        case types.UPDATE_SUBGROUP_BILLING_PARAMS: {
            let slNo = Number(action.payload.id);
            let subgroupBilling = state.subgroupBilling.result;
            const updatedSubgroup = subgroupBilling.map((result) => {
                if (result.subgroupId == slNo) {
                    if (action.payload.name == "subgroupPremAmtFc" || action.payload.name == "vatAmtFc") {
                        return {
                            ...result,
                            [action.payload.name]: action.payload.value,
                            totalAmtFc: appUtility.round(Number(result.chargesFc ?? 0) + Number(result.subgroupPremAmtFc ?? 0) + Number(result.vatAmtFc ?? 0))
                        };
                    }
                    else if (action.payload.name == "subgroupPremAmtLc" || action.payload.name == "vatAmtLc") {
                        return {
                            ...result,
                            [action.payload.name]: action.payload.value,
                            totalAmtLc: appUtility.round(Number(result.chargesLc) + Number(result.subgroupPremAmtLc) + Number(result.vatAmtLc))
                        };
                    }
                    else {
                        return {
                            ...result,
                            [action.payload.name]: action.payload.value
                        };
                    }
                }
                return result;
            });
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: updatedSubgroup,
                }
            }
        }

        case types.CLEAR_ACCOUNT_DETAILS_IN_INSTALLMENTS: {
            let slNo = parseFloat(action.payload.id);
            let installments = state.installments.result;
            const updatedInstallments = installments.map((result) => {
                if (result.docInstId == slNo) {
                    return {
                        ...result,
                        docInstBankCode: null,
                        docInstBankName: null,
                    };
                }
                return result;
            });
            return {
                ...state,
                installments: {
                    ...state.installments,
                    result: updatedInstallments,
                }
            }
        }
        case types.GET_INSTALLMENT_PREMIUM_END: {
            return {
                ...state,
                installments: {
                    ...state.installments,
                    result: action.result,
                }
            }
        }
        case types.GET_SUBGROUP_BILLING_END: {
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: action.result,
                }
            }
        }

        case types.UPDATE_INSTALLMENT_CURRENT_ID: {
            return {
                ...state,
                installments: {
                    ...state.installments,
                    currentSrlNo: action.payload.srlNo,
                }
            }
        }
        case types.UPDATE_SUBGROUP_CURRENT_ID: {
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    currentSrlNo: action.payload.srlNo,
                }
            }
        }

        case types.RESET_INSTALLMENTS: {
            return {
                ...state,
                installments: initialState.installments
            }
        }
        case types.ADD_NEW_SUBGROUP_BILLING_ROW: {
            let subgroupBilling = state.subgroupBilling.result;
            let insuredCode = state.policyInformation.insuredCode;
            let insuredName = state.policyInformation.insuredName;
            var srlNos = subgroupBilling.map(x => x.subgroupId);
            let vatType = null;
            let vatPerc = null;
            if (state.masters.vatTypeRateMasters.length == 1) {
                vatType = state.masters.vatTypeRateMasters[0].taxrId;
                vatPerc = state.masters.vatTypeRateMasters[0].taxrRatePerc;

            }
            //const maxId = Math.max(srlNos)
            const maxId = Math.max.apply(Math, srlNos)
            //console.log("loadingMaxId", loadingMaxId)
            subgroupBilling.push(
                {
                    subgroupId: srlNos.length == 0 ? 1 : maxId + 1,
                    subgroupAccountCode: null,
                    subgroupAccountName: null,
                    noOfLives: null,
                    subgroupPremAmtFc: null,
                    subgroupPremAmtLc: null,
                    vatType: vatType,
                    vatPerc: vatPerc,
                    vatAmtFc: 0,
                    vatAmtLc: null,
                    totalAmtFc: null,
                    totalAmtLc: null,
                    documentId: null,
                    chargesFc: null,
                    chargesLc: null,
                    subgroupSponsorCode: insuredCode,
                    subgroupSponsorId: null,
                    amlStatus: null,
                    amlStatusDt: null,
                    amlId: null,
                    subgroupNo: null,
                    isChecked: null,
                    subgroupIsAdded: "Y",
                }
            )
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: subgroupBilling
                }
            }
        }
        case types.DELETE_SUBGROUP_BILLING_ROW: {
            let subgroupBilling = state.subgroupBilling.result;
            let insuredCode = state.policyInformation.insuredCode;
            var updatedSubgroupBilling = subgroupBilling.filter(p => p.isChecked != true)

            if (state.policyEndorsement.endorsementTypeId == appConstants.ENDORSEMENT_TYPE_ADDITION_SUBGROUP) {
                updatedSubgroupBilling = subgroupBilling.filter(p => !(p.isChecked == true && p.subgroupIsAdded == "Y"))
            }


            if (updatedSubgroupBilling.length == 0) {
                updatedSubgroupBilling = [
                    {
                        subgroupId: 1,
                        subgroupAccountCode: null,
                        subgroupAccountName: null,
                        noOfLives: null,
                        subgroupPremAmtFc: null,
                        subgroupPremAmtLc: null,
                        vatType: null,
                        vatPerc: null,
                        vatAmtFc: 0,
                        vatAmtLc: null,
                        totalAmtFc: null,
                        totalAmtLc: null,
                        documentId: null,
                        chargesFc: null,
                        chargesLc: null,
                        subgroupSponsorCode: insuredCode,
                        subgroupSponsorId: null,
                        amlStatus: null,
                        amlStatusDt: null,
                        amlId: null,
                        subgroupNo: null,
                        isChecked: null,
                    },
                ]
            }
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: updatedSubgroupBilling
                }
            }
        }
        case types.UPDATE_ALL_SUBGROUP_TABLE_CHECKBOX_PARAMS: {
            let subgroupBilling = state.subgroupBilling.result;
            let isCheckBoxChecked = action.payload.checked
            // Use map() to update the isChecked property of each member
            let updatedResults = []
            if (state.policyEndorsement.endorsementTypeId != appConstants.ENDORSEMENT_TYPE_ADDITION_SUBGROUP) {
                updatedResults = subgroupBilling.map((result) => {
                    return {
                        ...result,
                        isChecked: isCheckBoxChecked
                    }
                });
            }


            if (state.policyEndorsement.endorsementTypeId == appConstants.ENDORSEMENT_TYPE_ADDITION_SUBGROUP) {
                updatedResults = subgroupBilling.map(result => {
                    if (result.subgroupIsAdded == "Y") {
                        return {
                            ...result,
                            isChecked: isCheckBoxChecked
                        }
                    }
                    else {
                        return {
                            ...result,

                        }
                    }

                })
            }
            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: updatedResults,
                    hasCheckedBoxInTable: isCheckBoxChecked,
                }
            }

        }
        case types.UPDATE_SUBGROUP_TABLE_CHECKBOX_PARAMS: {
            let subgroupBilling = state.subgroupBilling.result;
            let updatedResults = subgroupBilling.map((result) => {
                if (result.subgroupId == action.payload.id) {
                    return {
                        ...result,
                        isChecked: action.payload.checked
                    }
                }
                return result;
            });
            let hasCheckedBoxInLoading = updatedResults.filter(p => p.isChecked == true).length > 0 ? true : false;

            return {
                ...state,
                subgroupBilling: {
                    ...state.subgroupBilling,
                    result: updatedResults,
                    hasCheckedBoxInTable: hasCheckedBoxInLoading,
                }
            }
        }
        case types.GET_SUBGROUP_MASTERS_END:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    subgroupMasters: action.payload
                }
            }
        case types.RESET_COMMUNICATION: {
            let oringinalComm = state.communication.originalCommunication;
            let communicationMaxId = Math.max.apply(Math, oringinalComm.map(function (o) { return o.srlNo; }));
            // const communicationMaxId = Math.max(oringinalComm.map(x => x.srlNo))
            oringinalComm.push({
                srlNo: communicationMaxId + 1,
                referredBy: null,
                referralStatus: null,
                referralStatusId: null,
                referralMessage: '',
                referralDate: appUtility.formatDate(appConstants.TODAY),
                premium: 0,
                disabled: false
            });
            return {
                ...state,
                communication: {
                    ...state.communication,
                    filteredCommunication: oringinalComm
                }
            }
        }
        case types.GET_COMMUNICATION_VALUES_END: {
            let updatedCommunication = action.data.communications;
            let communicationMaxId = Math.max.apply(Math, updatedCommunication.map(function (o) { return o.srlNo; }));
            // let communicationMaxId = Math.max(updatedCommunication.map(x => parseFloat(x.srlNo)))
            updatedCommunication.push({
                srlNo: communicationMaxId + 1,
                referredBy: null,
                referralStatus: null,
                referralStatusId: null,
                referralMessage: null,
                referralDate: appUtility.formatDate(appConstants.TODAY),
                premium: 0,
                disabled: false
            });


            return {
                ...state,
                communication: {
                    ...state.communication,
                    filteredCommunication: updatedCommunication,
                    originalCommunication: action.data.communications
                }
            }
        }
        case types.UPDATE_REMARKS_PARAMS: {
            let slNo = parseFloat(action.payload.id);
            let remarks = state.remarks.filteredRemarks;
            const updatedRemarks = remarks.map((result) => {
                if (result.srlNo == slNo) {
                    return {
                        ...result,
                        remarks: action.payload.value
                    };
                }
                return result;
            });
            return {
                ...state,
                remarks: {
                    ...state.remarks,
                    filteredRemarks: updatedRemarks,
                }
            }

        }
        case types.RESET_REMARKS: {
            let oringinalRemark = state.remarks.originalRemarks;
            let remarksMaxId = Math.max.apply(Math, oringinalRemark.map(function (o) { return o.srlNo; }));
            // const communicationMaxId = Math.max(oringinalComm.map(x => x.srlNo))
            oringinalRemark.push({
                srlNo: remarksMaxId + 1,
                remarks: '',
                name: null,
                disabled: false
            });
            return {
                ...state,
                remarks: {
                    ...state.remarks,
                    filteredRemarks: oringinalRemark
                }
            }
        }
        case types.GET_REMARKS_VALUES_END: {
            let updatedRemark = action.data.remarks;
            let remarksMaxId = Math.max.apply(Math, updatedRemark.map(function (o) { return o.srlNo; }));
            // let communicationMaxId = Math.max(updatedCommunication.map(x => parseFloat(x.srlNo)))
            updatedRemark.push({
                srlNo: remarksMaxId + 1,
                remarks: '',
                name: null,
                disabled: false,
                referralDate: appUtility.formatDate(appConstants.TODAY),
            });
            return {
                ...state,
                remarks: {
                    ...state.remarks,
                    filteredRemarks: updatedRemark,
                    originalRemarks: action.data.remarks
                }
            }
        }
        case types.UPDATE_COMMUNICATION_PARAMS: {
            let slNo = parseFloat(action.payload.id);
            let communication = state.communication.filteredCommunication;
            const updatedCommunication = communication.map((result) => {
                if (result.srlNo == slNo) {
                    return {
                        ...result,
                        referralMessage: action.payload.value
                    };
                }
                return result;
            });
            return {
                ...state,
                communication: {
                    ...state.communication,
                    filteredCommunication: updatedCommunication,
                }
            }

        }

        case types.UPDATE_PREMIUM_BIFURCATION_PARAMS: {
            return {
                ...state,
                premiumBifurcation: {
                    ...state.premiumBifurcation,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_PREMIUM_BIFURCATION: {
            return {
                ...state,
                premiumBifurcation: initialState.premiumBifurcation
            }
        }
        case types.GET_PREMIUM_BIFURCATION_END: {
            return {
                ...state,
                premiumBifurcation: action.payload
            }
        }
        case types.DELETE_CHARGES_ROW: {
            let filteredRows = state.charges.chargesTable.filter(m => m.tempId !== action.payload.tempId).slice();
            //  const spliceCharges = [...state.charges.chargesTable]
            //   spliceCharges.splice(action.payload, 1)
            return {
                ...state,
                charges: {
                    ...state.charges,
                    chargesTable: filteredRows
                }
            }
        }
        case types.UPDATE_CHARGES_ID: {
            let spliceCharges = []
            for (let i = 0; i < state.charges.chargesTable.length; i++) {
                let Arr = {
                    ...state.charges.chargesTable[i],
                    tempId: i
                }
                spliceCharges.push(Arr)
            }
            return {
                ...state,
                charges: {
                    ...state.charges,
                    chargesTable: spliceCharges
                }
            }
        }
        case types.ADD_CHARGES_NEW_ROW: {
            return {
                ...state,
                charges:
                {
                    ...state.charges,
                    chargesTable:
                        [
                            ...state.charges.chargesTable,
                            {
                                tempId: null,
                                chargesId: null,
                                chargeName: null,
                                applyType: appConstants.CHARGE_APPLY_TYPE_MANUAL,
                                vatApplyType: state.charges.vatTypeId,
                                memberCharges: 0,
                                vatRate: state.charges.quotationVatPercentage,
                                vatamt: null,
                                chargeFCAMT: null,
                                chargeLCAMT: null,
                                isDefaultYN: 'N',
                                isRefundable: 'N',

                            }
                        ]
                }
            }
        }
        case types.UPDATE_CHARGES_TABLE_PARAMS_IN_SUMMARY: {
            console.log(action.payload.name, action.payload.value, action.payload.tempId)
            let chargelist = state.charges.chargesTable;

            let index = chargelist.findIndex(p => p.tempId == action.payload.tempId);

            console.log(index)
            let Arr = {
                ...state.charges.chargesTable[index],
                [action.payload.name]: action.payload.value
            }

            console.log("2", index)
            Arr.memberCharges = Arr.memberCharges == 0 || Arr.memberCharges == '' ? 0 : Arr.memberCharges;
            var chageName = Arr.chargeName;
            var vatAmount = 0;
            let chargesEntered = Arr.memberCharges;
            if (Arr.isRefundable === "N") {
                if (Number(chargesEntered) < 0) {
                    chargesEntered = 0;
                }
            }
            console.log("3", chargesEntered)
            var vatRate = Arr.vatRate == null || Arr.vatRate == "" ? Number(0) : Number(Arr.vatRate);
            vatAmount = ((vatRate / 100) * chargesEntered);
            var amountNet = Number(vatAmount) + Number(chargesEntered);
            console.log(amountNet, vatAmount, vatRate, index)
            let arrayAfterCalculation = {
                ...state.charges.chargesTable[index],
                memberCharges: appUtility.round(chargesEntered),
                vatamt: appUtility.round(vatAmount),
                chargeFCAMT: appUtility.round(amountNet),
                chargeLCAMT: appUtility.round(amountNet),
                chargeName: chageName,
                applyType: Arr.applyType,
                vatApplyType: Arr.vatApplyType,
                vatRate: Arr.vatRate,
                tempId: action.payload.tempId,
                isDefaultYN: Arr.isDefaultYN,
                isRefundable: Arr.isRefundable,
                modifyYn: Arr.modifyYn,
            }
            console.log("5 arrayAfterCalculation", arrayAfterCalculation)
            const chargesUpdated = [...state.charges.chargesTable]
            chargesUpdated.splice(index, 1)
            chargesUpdated.splice(index, 0, arrayAfterCalculation);
            return {
                ...state,
                charges: {
                    ...state.charges,

                    chargesTable: chargesUpdated,

                }
            }
        }
        case types.UPDATE_MANUAL_CHARGE_PROPS_SUMMARY: {
            console.log(action.payload.name, action.payload.value, action.payload.tempId)
            let chargelist = state.charges.chargesTable;

            let index = chargelist.findIndex(p => p.tempId == action.payload.tempId);
            let Arr = {
                ...state.charges.chargesTable[index]
            }
            let isDef = 'N';
            let isRefundable = 'N';
            let isModifyYn = 'N';
            let applyTypeId = appConstants.CHARGE_APPLY_TYPE_MANUAL;
            let masterCharges = state.charges.defaultChargesSetup
            let defualtCharge = masterCharges.filter(p => p.chargeId == Arr.chargeName);
            console.log("hiit", defualtCharge)
            if (defualtCharge) {
                if (defualtCharge.length > 0) {
                    isDef = defualtCharge[0].defaultYn;
                    isRefundable = defualtCharge[0].isRefundableYn;
                    applyTypeId = defualtCharge[0].applyTypeId;
                    isModifyYn = defualtCharge[0].modifyYn;
                    console.log("hiit", isDef, isRefundable, applyTypeId)
                }
            }
            console.log(isDef, isRefundable, applyTypeId)

            var chageName = Arr.chargeName;

            let arrayAfterCalculation = {
                ...state.charges.chargesTable[index],
                tempId: action.payload.tempId,
                chargesId: null,
                chargeName: chageName,
                applyType: applyTypeId,
                vatApplyType: state.charges.vatTypeId,
                memberCharges: 0,
                vatRate: state.charges.quotationVatPercentage,
                vatamt: 0,
                chargeFCAMT: 0,
                chargeLCAMT: 0,
                isDefaultYN: isDef,
                isRefundable: isRefundable,
                modifyYn: isModifyYn,

            }
            console.log("5 arrayAfterCalculation", arrayAfterCalculation)
            const chargesUpdated = [...state.charges.chargesTable]
            chargesUpdated.splice(index, 1)
            chargesUpdated.splice(index, 0, arrayAfterCalculation);
            return {
                ...state,
                charges: {
                    ...state.charges,

                    chargesTable: chargesUpdated,

                }
            }
        }
        case types.UPDATE_TOTAL_CHARGES_END: {
            return {
                ...state,
                charges: {
                    ...state.charges,
                    chargesVAT: action.payload.chargesVAT,
                    grossChargesWithoutVAT: action.payload.chargeswithOutVAT,
                    grossChargesSection: action.payload.grossChargesSection
                }
            }
        }
        case types.VALIDATE_SUMMARY_CHARGES_END:
            return {
                ...state,
                charges: {
                    ...state.charges,
                    validatedCharges: action.payload.result,
                }
            }
        case types.SEARCH_IN_COSTING_SHEET_BY_PARAMS: {
            var costingSheetValues = (state.costingSheet.resultOriginal).slice();

            if (state.costingSheet.benefitName) {
                costingSheetValues = costingSheetValues.filter(p => p.benefitName === state.costingSheet.benefitName);
            }
            if (state.costingSheet.categoryName) {
                costingSheetValues = costingSheetValues.filter(p => p.categoryName === state.costingSheet.categoryName);
            }
            if (state.costingSheet.networkName) {
                costingSheetValues = costingSheetValues.filter(p => p.networkName === state.costingSheet.networkName);
            }
            if (state.costingSheet.genderName) {
                costingSheetValues = costingSheetValues.filter(p => p.genderName === state.costingSheet.genderName);
            }
            if (state.costingSheet.ageSlab) {
                costingSheetValues = costingSheetValues.filter(p => p.ageSlab === state.costingSheet.ageSlab);
            }
            if (state.costingSheet.relation) {
                costingSheetValues = costingSheetValues.filter(p => p.relation === state.costingSheet.relation);
            }
            var currentPage = constants.COSTING_SHEET_FIRST_PAGE;
            var pageSize = constants.COSTING_SHEET_PAGE_SIZE
            var sort = null
            var totalCount = costingSheetValues.length;
            var totalPages = Math.ceil(totalCount / constants.COSTING_SHEET_PAGE_SIZE)
            var hasNextPage = currentPage == totalPages ? false : true
            var hasPreviousPage = false
            var result = costingSheetValues.slice(0, constants.COSTING_SHEET_PAGE_SIZE);
            var pagedResult = {
                currentPage: currentPage,
                pageSize: pageSize,
                sort: sort,
                totalCount: totalCount,
                totalPages: totalPages,
                hasNextPage: hasNextPage,
                hasPreviousPage: hasPreviousPage,
                result: result
            }
            return {
                ...state,
                costingSheet: {
                    ...state.costingSheet,
                    result: pagedResult,
                }
            }
        }
        case types.UPDATE_COSTING_SHEET_SEARCH_PARAMS: {
            return {
                ...state,
                costingSheet: {
                    ...state.costingSheet,
                    [action.payload.name]: action.payload.value,
                }
            }
        }
        case types.UPDATE_CHECKLIST_PARAMS: {
            let slNo = parseFloat(action.payload.id);
            let checkList = state.checkList;
            const updatedCheckList = checkList.map((result) => {
                if (result.srlNo == slNo) {
                    return {
                        ...result,
                        [action.payload.name]: action.payload.checked
                    };
                }
                return result;
            });
            return {
                ...state,
                checkList: updatedCheckList
            }

        }
        case types.GET_CHECKLIST_END: {
            return {
                ...state,
                checkList: action.payload
            }

        }
        case types.UPDATE_MEMBER_SEARCH_TAB: {
            if (action.payload == "#policyWise") {
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        policyWise: true,
                        memberWise: false,

                        // selectedMemberField: null,

                        // memberFieldValue: null,
                        // memberFieldValue: null,

                        //search result
                        isSearchMemberResult: false,
                        // showMembers: false,
                        // memberFilteredDetails: [],
                        // memberTableDisplay: [],
                        // selectAll: false,
                        // memberFieldId: null,

                        // searchMember: null

                    }
                }
            }
            if (action.payload == "#memberWise") {
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        policyWise: false,
                        memberWise: true,

                        // policyNo: null,
                        // isActiveList: false,
                        // isMemberList: false,

                        //search result
                        isSearchMemberResult: false,
                        // showMembers: false,
                        // memberFilteredDetails: [],
                        // memberTableDisplay: [],
                        // selectAll: false,
                        // memberFieldId: null,

                        // memberFieldValue: null,
                        // searchMember: null
                    }
                }
            }

        }
        case types.UPDATE_MEMBER_SEARCH_FILTER_PARAMS: {

            if (action.payload.value == "false") {
                if (action.payload.name == "policyWise") {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            policyWise: true,
                            memberWise: false,

                            selectedMemberField: null,


                            memberFieldValue: null,

                            //search result
                            isSearchMemberResult: false,
                            showMembers: false,
                            memberFilteredDetails: [],
                            memberTableDisplay: [],
                            selectAll: false,
                            memberFieldId: null,

                            memberFieldValue: null,
                            searchMember: null

                        }
                    }
                }
                if (action.payload.name == "memberWise") {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            policyWise: false,
                            memberWise: true,

                            policyNo: null,
                            isActiveList: false,
                            isMemberList: false,

                            //search result
                            isSearchMemberResult: false,
                            showMembers: false,
                            memberFilteredDetails: [],
                            memberTableDisplay: [],
                            selectAll: false,
                            memberFieldId: null,

                            memberFieldValue: null,
                            searchMember: null
                        }
                    }
                }
                if (action.payload.name == "isActiveList") {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            isActiveList: true,
                            isMemberList: false
                        }
                    }
                }
                if (action.payload.name == "isMemberList") {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            isActiveList: false,
                            isMemberList: true
                        }
                    }
                }

            }
            if (action.payload.value == "true") {
                if (action.payload.name == "selectAll") {
                    var memberDetails = state.memberSearchFilter.memberFilteredDetails
                    var changedArr = []
                    memberDetails.map((member) => {
                        let obj = {
                            isChecked: false,
                            value: member.value
                        }
                        changedArr.push(obj)
                    })

                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            [action.payload.name]: action.payload.value,
                            memberFilteredDetails: changedArr,
                            memberTableDisplay: changedArr
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            [action.payload.name]: false
                        }
                    }
                }
            }



            return {
                ...state,
                memberSearchFilter: {
                    ...state.memberSearchFilter,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_SEARCH_MEMBER_RESULTS: {

            if (action.payload.length > 0) {

                let memberSearch = state.memberSearchFilter






                if (memberSearch.memberWise == true) {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            isSearchMemberResult: true,
                            showMembers: true,
                            isActiveListSearched: false,
                            memberFilteredDetails: action.payload,
                            memberTableDisplay: action.payload,
                            memberFieldId: memberSearch.selectedMemberField,

                            memberFieldValue: memberSearch.memberFieldValue,
                        }
                    }

                }
                if (memberSearch.isActiveList) {
                    return {
                        ...state,
                        memberSearchFilter: {
                            ...state.memberSearchFilter,
                            isSearchMemberResult: true,
                            showMembers: true,
                            isActiveListSearched: true,
                            memberFilteredDetails: action.payload,
                            memberTableDisplay: action.payload
                        }
                    }
                }
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        isSearchMemberResult: true,
                        showMembers: true,
                        isActiveListSearched: false,
                        memberFilteredDetails: action.payload,
                        memberTableDisplay: action.payload
                    }
                }
            }
            else {
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        isSearchMemberResult: true,
                        showMembers: false,
                        memberFilteredDetails: [],
                        memberTableDisplay: []
                    }
                }
            }

        }
        case types.UPDATE_CHECKBOX_CHANGE_MEMBER_SEARCH_TABLE: {
            let memberSearch = state.memberSearchFilter
            let arr = []

            if (action.payload.name == "selectAll") {
                let value = null
                if (action.payload.value == "false") {
                    value = true
                }
                if (action.payload.value == "true") {
                    value = false
                }
                memberSearch.memberTableDisplay.map((member) => {
                    member.isChecked = value
                    arr.push(member)
                })

                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        selectAll: value,
                        memberTableDisplay: arr,

                    }
                }

            }
            if (action.payload.name == "selectMembers") {
                memberSearch.memberTableDisplay.map((member) => {
                    if (member.value.rNo == action.payload.value) {
                        member.isChecked = member.isChecked == true ? false : true
                    }
                    arr.push(member)
                })

                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        memberTableDisplay: arr,
                    }
                }
            }
        }
        case types.RESET_MEMBER_SEARCH: {

            // if(memberSearchFilter.policyWise == true){

            // }
            // if(memberSearchFilter.memberWise == true){

            // }
            return {
                ...state,
                memberSearchFilter: {
                    ...state.memberSearchFilter,


                    policyId: null,
                    //component a
                    policyNo: null,
                    isActiveList: false,
                    isMemberList: false,
                    insuredName: null,
                    //component b
                    selectedMemberField: null,

                    memberFieldValue: null,

                    //search result
                    isSearchMemberResult: false,
                    showMembers: false,
                    memberFilteredDetails: [],
                    memberTableDisplay: [],
                    memberFieldId: null,
                    searchMember: null
                }

            }
        }
        case types.RESET_MEMBER_SEARCH_FILTER_PARAMS: {
            let memberSearch = state.memberSearchFilter
            if (memberSearch.policyWise == true) {
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        //component a
                        policyNo: null,
                        isActiveList: false,
                        isMemberList: false,
                    }
                }
            }
            if (memberSearch.memberWise) {
                return {
                    ...state,
                    memberSearchFilter: {
                        ...state.memberSearchFilter,
                        //component b
                        selectedMemberField: null,

                        memberFieldValue: null,
                    }
                }
            }
        }
        case types.RESET_SEARCH_MEMBER_TABLE: {
            let memberFilteredDetails = state.memberSearchFilter.memberFilteredDetails

            return {
                ...state,
                memberSearchFilter: {
                    ...state.memberSearchFilter,
                    memberTableDisplay: memberFilteredDetails,
                    searchMember: null
                }
            }
        }

        case types.UPDATE_STAGE_STATUS_CHANGE_POLICY:
            return {
                ...state,
                summaryStageStatus: {
                    ...state.summaryStageStatus,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_SUMMARY_PAGE_STATUS_MASTER_END_POLICY:
            return {
                ...state,
                summaryStageStatus: {
                    ...state.summaryStageStatus,
                    statusMasters: action.result
                }
            }


        case types.GET_PAYMENT_INFORMATION_END_MICORESHARED: {
            return {
                ...state,
                paymentInformation: {
                    ...state.paymentInformation,
                    customerName: action.payload.customerName,
                    customerEmail: action.payload.customerEmail,
                    customerPhone: action.payload.customerPhone,
                    amount: action.payload.amount,
                    description: action.payload.referenceText,
                    referenceId: action.payload.referenceId
                }
            }
        }

        case types.UPDATE_PAYMENT_TRANSACTION_PARAMS_MICORESHARED: {
            return {
                ...state,
                paymentTransactions: {
                    ...state.paymentTransactions,
                    [action.payload.name]: action.payload.value

                }
            }
        }
        case types.RESET_EMAIL_INFORMATION_MICORESHARED: {
            return {
                ...state,
                emailInformation: {
                    ...state.emailInformation,
                    customerEmail: null,
                    referenceNo: null,
                    paymentLink: null
                }
            }
        }
        case types.UPDATE_EMAIL_PARAMS_MICORESHARED: {
            return {
                ...state,
                emailInformation: {
                    ...state.emailInformation,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_PAYMENT_TRANSACTION_PARAMS_MICORESHARED: {
            return {
                ...state,
                paymentTransactions: {
                    ...state.paymentTransactions,
                    agreeTerms: false
                }
            }
        }
        case types.UPDATE_APPROVAL_INFORMATION_MICORESHARED: {
            return {
                ...state,
                approvalInformation: {
                    ...state.approvalInformation,
                    [action.payload.name]: action.payload.value

                }
            }
        }
        case types.GET_APPROVAL_INFORMATION_END_MICORESHARED: {
            return {
                ...state,
                approvalInformation: {
                    ...state.approvalInformation,
                    accountName: action.payload.accountName,
                    accountNo: action.payload.accountCode,
                    insuredName: action.payload.insuredName,
                    insuredCode: action.payload.insuredCode,
                    insuredId: action.payload.insuredId,
                    policyId: action.payload.policyId,
                    policyNo: action.payload.policyNo,
                    policyEffectiveDate: action.payload.policyEffectiveDate == null ? null : appUtility.formatDate(action.payload.policyEffectiveDate),
                    policyExpiryDate: action.payload.policyExpiryDate == null ? null : appUtility.formatDate(action.payload.policyExpiryDate),
                    policyBroker: action.payload.agentId,
                    commission: action.payload.brokerageRate,
                    commissionAmount: action.payload.brokerageAmount,
                    product: action.payload.product,
                    businessType: action.payload.businessType,
                    netToCustomer: action.payload.netToCustomer,
                    endorsementEffectiveDate: action.payload.endorsementEffectiveDate == null ? null : appUtility.formatDate(action.payload.endorsementEffectiveDate),
                    endorsementExpiryDate: action.payload.endorsementExpiryDate == null ? null : appUtility.formatDate(action.payload.endorsementExpiryDate),
                    endorsementSerialNo: action.payload.endorsementSerialNo,
                    treatyId: action.payload.treatyId,

                },
                accountDetails: {
                    ...state.accountDetails,
                    searchText: action.payload.accountNo,
                },
            }
        }
        case types.CLEAR_ACCOUNT_DETAILS_IN_APPROVAL_INFORMATION:
            return {
                ...state,
                approvalInformation: {
                    ...state.approvalInformation,
                    accountNo: '',
                    accountName: '',
                }
            }
        case types.UPDATE_MEMBER_UPLOAD_PARAMS_MICORESHARED:
            return {
                ...state,
                memberDetails: {
                    ...state.memberDetails,
                    memberUpload: {
                        ...state.memberDetails.memberUpload,
                        [action.payload.name]: action.payload.value,
                    }
                }
            }
        case types.RESET_DOH_VERIFICATION_DETAILS:
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    currentBatchId: '',
                    currentActionSource: '',
                    actionSourceType: '',//to be used for search
                    batchStatusType: '',
                    batchId: '',
                    referNo: '',
                    showBatchDetails: false,
                    dohBatchListing: [],
                    filterdBatchDetailsResult: [],
                    dohBatchDetails: [],

                    dhaBatchDetails: [],
                    filterdDhaBatchDetailsResult: [],
                    batchFilterBy: null,
                    nasBatchDetails: [],
                    cocBatchDetails: [],
                }
            }
        ///////cardbatch processing/////////////
        case types.CLEAR_CARD_BATCH_INFO: {
            return {
                ...state,
                cardbatchInformation: {
                    ...state.cardbatchInformation,
                    policyNo: '',
                    printStatusYN: 'N',
                    cardPrinterId: '',
                    //table params
                    showSearchResult: false,
                    isSubmit: false,

                    searchResultClass: "collapse show",
                    searchClass: "collapse show",
                    batchFilteredResults: [],
                    batchTableDisplay: []
                }
            }
        }
        case types.UPDATE_CARD_BATCH_INFORMATION_PROPERTY: {
            return {
                ...state,
                cardbatchInformation: {
                    ...state.cardbatchInformation,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_AFTER_BATCH_SUBMIT: {

            return {
                ...state,
                cardbatchInformation: {
                    ...state.cardbatchInformation,
                    showSearchResult: true,
                    isSubmit: true,
                    batchFilteredResults: action.payload.result,
                    batchTableDisplay: action.payload.result,
                    isSearchResultPendingPrint: action.payload.checkVal
                }
            }
        }
        case types.UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_PARAMS: {
            return {
                ...state,
                medicalCardMembersSearch: {
                    ...state.medicalCardMembersSearch,
                    [action.payload.name]: action.payload.value
                }

            }
        }
        case types.CLEAR_MEDICAL_CARD_MEMBERS_SEARCH: {
            if (action.payload == 'clearTable') {
                return {
                    ...state,
                    medicalCardMembersSearch: {
                        ...state.medicalCardMembersSearch,
                        cardPrinterId: null,
                        isSubmit: false,
                        selectAll: false,
                        showSearchResult: false,
                        searchResult: [],
                        selectedMembers: null,
                        searchSelector: null,
                    }
                }
            }
            else if (action.payload == 'clearAll') {
                return {
                    ...state,
                    medicalCardMembersSearch: {
                        ...state.medicalCardMembersSearch,

                        endorsementNo: null,
                        category: null,
                        subGroup: null,      // above this are values from select and below are the ones from input field
                        staffId: null,
                        cardPrinterId: null,
                        memberName: null,
                        memberId: null,
                        cardNo: null,

                        printStatusYN: "N",
                        isSubmit: false,
                        selectAll: false,
                        showSearchResult: false,
                        searchResult: [],
                        searchResultClass: "collapse show",
                        searchClass: "collapse show",
                        //printMessage: {},
                        selectedMembers: null,
                        searchSelector: null,
                    }
                }
            }

        }
        case types.UPDATE_MEDICAL_CARD_CHECKBOX_CHANGE: {

            const selectAll = (state.medicalCardMembersSearch.selectAll).valueOf() == true ? false : true

            const checkboxResult = state.medicalCardMembersSearch.searchResult.map(a => ({ ...a }))

            console.log(checkboxResult)

            if (action.payload.name == 'selectAll') {


                for (var i = 0; i < checkboxResult.length; i++) {

                    if (checkboxResult[i].members) {
                        checkboxResult[i].selectIndividualMember = selectAll
                    }
                    else {
                        checkboxResult[i].selectPrincipal = selectAll
                        for (var k = 0; k < checkboxResult[i].dependentInst.length ? checkboxResult[i].dependentInst.length : 0; k++) {
                            checkboxResult[i].dependentInst[k].selectDependent = selectAll
                            //searchResult[i].dependent[k].selectDependent =searchResult[i].dependentInst[k].selectDependent == true ? false : true
                        }
                    }
                }
                return {
                    ...state,
                    medicalCardMembersSearch: {
                        ...state.medicalCardMembersSearch,
                        selectAll: state.medicalCardMembersSearch.selectAll == true ? false : true,
                        searchResult: checkboxResult
                    }
                }
            }
            else {
                //range selector
                if (action.payload.name == 'selectedMembers') {
                    var count = Number(action.payload.value)
                    for (var j = 0; j < checkboxResult.length; j++) {

                        if (count != 0) {
                            if (checkboxResult[j].members) {
                                checkboxResult[j].selectIndividualMember = true
                            }
                            else {
                                checkboxResult[j].selectPrincipal = true
                                count = count - 1

                                for (var k = 0; k < checkboxResult[j].dependentInst.length ? checkboxResult[j].dependentInst.length : 0; k++) {
                                    if (count != 0) {
                                        checkboxResult[j].dependentInst[k].selectDependent = true
                                        count = count - 1
                                    }
                                    else {
                                        checkboxResult[j].dependentInst[k].selectDependent = false
                                    }
                                }
                            }
                        }
                        else {
                            if ((checkboxResult[j].members)) {
                                checkboxResult[j].selectIndividualMember = false
                            }
                            else {
                                checkboxResult[j].selectPrincipal = false
                                for (var k = 0; k < checkboxResult[j].dependentInst.length ? checkboxResult[j].dependentInst.length : 0; k++) {
                                    checkboxResult[j].dependentInst[k].selectDependent = false
                                }
                            }
                        }


                    }
                }

                //principal 

                if (action.payload.name == 'selectPrincipal') {

                    for (var j = 0; j < checkboxResult.length; j++) {
                        if (checkboxResult[j].principalInst.memberID == action.payload.value) {
                            checkboxResult[j].selectPrincipal = checkboxResult[j].selectPrincipal == true ? false : true
                            for (var k = 0; k < checkboxResult[j].dependentInst.length ? checkboxResult[j].dependentInst.length : 0; k++) {
                                checkboxResult[j].dependentInst[k].selectDependent = checkboxResult[j].selectPrincipal
                            }
                        }
                    }
                }

                //dependent 
                if (action.payload.name == 'selectDependent') {

                    for (var j = 0; j < checkboxResult.length; j++) {
                        if (checkboxResult[j].principalInst.memberID == action.payload.id) {

                            for (var k = 0; k < checkboxResult[j].dependentInst.length; k++) {
                                if (checkboxResult[j].dependentInst[k].result.memberID == action.payload.value) {
                                    checkboxResult[j].dependentInst[k].selectDependent = checkboxResult[j].dependentInst[k].selectDependent == true ? false : true
                                }
                            }
                        }
                    }
                }

                //individual member
                if (action.payload.name == 'selectIndividualMember') {

                    for (var j = 0; j < checkboxResult.length; j++) {
                        if (checkboxResult[j].members.memberID == action.payload.value) {
                            checkboxResult[j].selectIndividualMember = checkboxResult[j].selectIndividualMember == true ? false : true
                        }
                    }
                }

                return {
                    ...state,
                    medicalCardMembersSearch: {
                        ...state.medicalCardMembersSearch,
                        searchResult: checkboxResult
                    }
                }
            }


        }
        case types.UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_INFORMATION: {
            return {
                ...state,
                medicalCardMembersSearch: {
                    ...state.medicalCardMembersSearch,
                    searchResult: action.Result
                }
            }
        }
        ///////cardbatch processing/////////////   
        ///////ExcelReportByDate/////////////   
        case types.UPDATE_EXPORT_REPORT_BY_DATE_PARAMS: {
            return {
                ...state,
                excelReportByDate: {
                    ...state.excelReportByDate,
                    [action.payload.name]: action.payload.value
                }

            }
        }
        ///////ExcelReportByDate/////////////   

        case types.GET_CASHIERS_MASTERS_END:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    cashierMasters: action.result,
                }
            }
        case types.UPDATE_MICORE_MODULE_PERMISSIONS2_PARAMS_MICORESHARED:

            return {

                ...state,

                checkPermissions: {

                    ...state.checkPermissions,

                    ...action.payload

                }

            }
        case types.WAIVE_OFF_FINAL_PENALTY_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        finalPenalty: action.payload.value == null ? state[action.payload.memberType].params.finalPenalty : state[action.payload.memberType].params.haadPenalty - action.payload.value
                    }
                }
            }
        case types.GET_NAS_BATCH_DETAILS_END_MICORESHARED: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    nasBatchDetails: action.result,

                }
            }
        }
        case types.UPDATE_VISA_EMIRATES_MASTER_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newVisaEmirateMasters: action.result,
                    newProductMasters: initialState.changeProduct.newProductMasters,
                    newPortalPlanMasters: initialState.changeProduct.newPortalPlanMasters,
                    newPlanMasters: initialState.changeProduct.newPlanMasters
                }
            }
        case types.UPDATE_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newProductMasters: action.result,
                    newPortalPlanMasters: initialState.changeProduct.newPortalPlanMasters,
                    newPlanMasters: initialState.changeProduct.newPlanMasters
                }
            }
        case types.UPDATE_PORTAL_PLAN_BY_PRODUCT_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newPortalPlanMasters: action.result,
                    newPlanMasters: initialState.changeProduct.newPlanMasters
                }
            }
        case types.UPDATE_PLAN_BY_PRODUCT_MICORESHARED:
            var payload = action.result
            var planMasters = payload.map((res) => {
                return {
                    planId: res.planId,
                    planName: res.planName,
                    planCode: res.planCode,
                    networkId: null
                }
            })
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newPlanMasters: planMasters,

                }
            }
        case types.RESET_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newProduct: null,
                    newPortalPlanType: null,
                    newPlan: null,
                    newProductMasters: initialState.changeProduct.newProductMasters,
                    newPortalPlanMasters: initialState.changeProduct.newPortalPlanMasters,
                    newPlanMasters: initialState.changeProduct.newPlanMasters
                }
            }
        case types.RESET_PORTAL_PLAN_BY_PRODUCT_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newPortalPlanType: null,
                    newPlan: null,
                    newPortalPlanMasters: initialState.changeProduct.newPortalPlanMasters,
                    newPlanMasters: initialState.changeProduct.newPlanMasters
                }
            }
        case types.RESET_PLAN_BY_PRODUCT_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newPlan: null,
                    newPlanMasters: initialState.changeProduct.newPlanMasters,

                }
            }
        case types.UPDATE_CHANGE_PRODUCT_PARAMS_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.CLEAR_CHANGE_PRODUCT_PARAMS_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newVisaEmirate: null,
                    newProduct: null,
                    newPortalPlanType: null,
                    newPlan: null
                }
            }
        case types.GET_PLANS_BY_PRODUCT_AND_PORTAL_PLAN_TYPE_ID_END_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    newPlanMasters: action.payload
                }
            }
        case types.UPDATE_CHANGE_ITEM_PARAMS_MICORESHARED:
            return {
                ...state,
                changeProduct: {
                    ...state.changeProduct,
                    changeItem: action.payload
                }
            }
        case types.NAS_WORK_LOCATION_MASTER_MICORESHARED: {

            return {
                ...state,
                nasMemberDetail: {
                    ...state.nasMemberDetail,
                    workLocationMasters: action.payload.location
                }
            }
        }

        case types.NAS_RESIDENT_LOCATION_MASTER_MICORESHARED: {

            return {
                ...state,
                nasMemberDetail: {
                    ...state.nasMemberDetail,
                    residentLocationMasters: action.payload.location
                }
            }
        }
        case types.NAS_UPDATE_MEMBER_PARAMS:
            return {
                ...state,
                nasMemberDetail: {
                    ...state.nasMemberDetail,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.CLEAR_NAS_MEMBER_PARAMS:
            return {
                ...state,
                nasMemberDetail: {
                    ...state.nasMemberDetail,
                    memberDocId: null,
                    memberTransId: null,
                    firstName: null,
                    middleName: null,
                    lastName: null,
                    emiratesId: null,
                    dob: null,
                    uidNo: null,
                    passportNo: null,
                    salaryBandId: null,
                    salary: null,
                    locationEmirateId: null,
                    residentEmirateId: null,
                    workLocationId: null,
                    nationalityId: null,

                    workLocationMasters: [
                        { cityId: 0, cityName: null }
                    ],
                    residentLocationMasters: [
                        { cityId: 0, cityName: null }
                    ],

                }
            }
        case types.GET_NAS_MEMBER_DETAILS_END:
            console.log(action.payload.details.masterMemberId, action.payload.details)
            return {
                ...state,
                nasMemberDetail: {
                    ...state.nasMemberDetail,
                    memberDocId: action.payload.details.masterMemberId,
                    memberTransId: action.payload.details.memberTransId,
                    firstName: action.payload.details.firstName,
                    middleName: action.payload.details.middleName,
                    lastName: action.payload.details.lastName,
                    emiratesId: action.payload.details.emiratesId,
                    dob: action.payload.details == null ? null : appUtility.formatDate(action.payload.details.dob),
                    uidNo: action.payload.details.uidNo,
                    passportNo: action.payload.details.passportNumber,
                    salaryBandId: action.payload.details.salaryBandId,
                    salary: action.payload.details.salary,
                    nationalityId: action.payload.details.nationalityId,
                    salaryBandId: action.payload.details.salaryBandId,
                    workLocationId: action.payload.details.workLocationId,
                    workEmirateId: action.payload.details.workEmirateId,
                    documentId: action.payload.details.documentId,
                    endorsementId: action.payload.details.endorsmentId,

                    // locationEmirateId: action.payload.details.locationEmirateId,
                    // residentEmirateId: action.payload.details.residentEmirateId,
                    // workLocationId: action.payload.details.,
                    // nationalityId: action.payload.details.,

                    // workLocationMasters: [
                    //     { cityId: 0, cityName: null }
                    // ],
                    // residentLocationMasters: [
                    //     { cityId: 0, cityName: null }
                    // ],

                }
            }
        ///job assignment/////////////////////////////////  
        case types.UPDATE_JOB_ASSIGNMENT_PARAMS: {
            return {
                ...state,
                jobAssignment: {
                    ...state.jobAssignment,
                    userVal: {
                        ...state.jobAssignment.userVal,
                        [action.payload.name]: action.payload.value
                    }
                }
            }
        }
        case types.CLEAR_JOB_ASSIGNMENT_PARAMS: {
            return {
                ...state,
                jobAssignment: {
                    ...state.jobAssignment,
                    userVal: initialState.jobAssignment.userVal
                }
            }
        }
        case types.CLEAR_JOB_ASSIGNMENT: {
            return {
                ...state,
                jobAssignment: initialState.jobAssignment
            }
        }
        case types.UPDATE_JOB_ASSIGNMENT_SECTION_INFO:
            return {
                ...state,
                jobAssignment: {
                    ...state.jobAssignment,
                    // sectionInfo: {
                    //     ...state.jobAssignment.sectionInfo,
                    //     //find why the actionpayload name and value dance dont work
                    //     selectedResults: action.payload
                    //    // [action.payload.name]: action.payload.value
                    // }
                    selectedResults: action.payload
                }
            }
        case types.UPDATE_JOB_ASSIGNMENT_FIELD: {
            return {
                ...state,
                jobAssignment: {
                    ...state.jobAssignment,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.UPDATE_USER_MASTER_BY_GROUP: {

            return {
                ...state,
                masters: {
                    ...state.masters,
                    userMastersByGroup: action.payload,
                }
            }
        }
        case types.UPDATE_TASK_USERS_MASTER: {
            let users = action.payload
            console.log('usersbygroup', users)
            return {
                ...state,
                jobAssignment: {
                    ...state.jobAssignment,
                    userMasters: action.payload,

                }
            }
        }

        ///job assignment/////////////////////////////////         

        case types.GET_TAX_MASTERS_END_MICORESHARED:
            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        vatPerc: action.payload.sr.vatRate
                    }
                }

            }

        case types.UPDATE_MATERNITY_VALUES_BY_EMIRATE_END_MICORESHARED:
            return {
                ...state,
                policyInformation: {
                    ...state.policyInformation,
                    ...state.policyInformation,
                    maternityMaxAge: action.payload.maternityMaxAge,
                    maternityMinAge: action.payload.maternityMinAge
                }
            }

        ///documents listing/////////////////////////////        
        case types.UPDATE_DOCUMENTS_LISTING_PARAMS_MICORESHARED: {
            return {
                ...state,
                documentsListing: {
                    ...state.documentsListing,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.RESET_DOCUMENTS_LISTING_MICORESHARED: {
            return {
                ...state,
                documentsListing: initialState.documentsListing

                // documentsListing: {
                //     ...state.documentsListing,

                //     searchClass: "collapse show",

                //     searchResultClass: "collapse show",
                //     showSearchResult: [],
                //     searchResult: []
                // }
            }
        }
        ///documents listing/////////////////////////////      

        case types.RESET_CUSTOM_TARRIF_UPLOAD:
            return {
                ...state,
                tariffUpload: {
                    ...state.tariffUpload,
                    categoryId: '',
                    ageBandsList: [],
                    //categoriesList: [],
                }
            }
        case types.UPDATE_CUSTOM_TARIFF_RATES_PARAMS:
            return {
                ...state,
                tariffUpload: {
                    ...state.tariffUpload,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.GET_CUSTOM_TARIFF_RATES_END:
            console.log("2", action.result)
            return {
                ...state,
                tariffUpload: {
                    ...state.tariffUpload,
                    ageBandsList: action.result

                }
            }
        case types.UPDATE_TARIFF_RATES_PARAMS: {
            console.log("1", action.payload.fieldName, action.payload.value, action.payload.fieldName, action.payload.ageBandId)
            let rows = state.tariffUpload.ageBandsList;
            let index = rows.findIndex(p => p.ageBandFactor == action.payload.ageBandId + "" + action.payload.genderId);
            console.log("2", index)
            let Arr = {
                ...state.tariffUpload.ageBandsList[index],
                [action.payload.fieldName]: action.payload.value
            }
            console.log("3", Arr)
            const slicedArray = [...state.tariffUpload.ageBandsList]
            slicedArray.splice(index, 1)
            slicedArray.splice(index, 0, Arr);
            console.log("4", slicedArray)
            return {
                ...state,
                tariffUpload: {
                    ...state.tariffUpload,
                    ageBandsList: slicedArray,
                }
            }
        }
        case types.GET_CATEGORIES_LIST_FROM_DOCUMENT_TOB:
            return {
                ...state,
                tariffUpload: {
                    ...state.tariffUpload,
                    categoriesList: action.result,
                }
            }
        case types.UPDATE_ALL_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS: {
            let searchResults = state.policySearch.searchResult;
            const isChecked = action.payload.checked
            // Update the "isChecked" property for each item in the search results
            searchResults.result = searchResults.result.map(item => ({
                ...item,
                isChecked
            }))
            return {
                ...state,

                policySearch: {
                    ...state.policySearch,

                    searchResult: searchResults,
                    hasCheckedBoxInSearchResult: isChecked
                }
            }
        }
        case types.UPDATE_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS: {
            let checked = action.payload.checked;

            const searchResults = state.policySearch.searchResult.result;
            const updatedResults = searchResults.map((result) => {

                if (result.rNo == action.payload.id) {

                    return {
                        ...result,
                        isChecked: checked
                    };
                }

                return result;
            });

            const hasCheckedBoxInSearchResult = updatedResults.some(
                (result) => result.isChecked
            );

            return {
                ...state,

                policySearch: {
                    ...state.policySearch,

                    searchResult: {
                        ...state.policySearch.searchResult,
                        result: updatedResults
                    },
                    hasCheckedBoxInSearchResult,
                },
            };
        }
        case types.GET_COC_BATCH_DETAILS_END_MICORESHARED: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    cocBatchDetails: action.result,

                }
            }
        }

        case types.GET_MEMBER_SHAFAFIYA_HIST_END: {
            return {
                ...state,
                memberShafafiyaHist: action.value
            }
        }
        case types.GET_MEMBER_SHAFAFIYA_HIST_END: {
            return {
                ...state,
                memberShafafiyaHist: []
            }
        }

        case types.UPDATE_HAAD_PENALTY_CHECKBOX_PARAMS_POLICY: {
            let isChecked = action.payload.checked;

            if (isChecked == null) {
                isChecked = false;
            }

            return {
                ...state,
                [action.payload.memberType]: {
                    ...state[action.payload.memberType],
                    params: {
                        ...state[action.payload.memberType].params,
                        isHaadManualYN: isChecked
                    }
                }
            }


        }

        case types.GET_ICP_BATCH_DETAILS_END_MICORESHARED: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    icpMemberBatchDetails: action.result,

                }
            }
        }

        case types.GET_ICP_POLICY_BATCH_DETAILS_END_MICORESHARED: {
            return {
                ...state,
                dohVerification: {
                    ...state.dohVerification,
                    icpPolicyDetail: {
                        ...state.dohVerification.icpPolicyDetail,
                        policyNo: action.result.policyNo,
                        endorsementType: action.result.endorsementType,
                        documentType: action.result.documentType,
                        productType: action.result.productType,
                        plan: action.result.plan,
                        policyIssueDate: action.result.policyIssueDate == null ? null : appUtility.formatDate(action.result.policyIssueDate),
                        policyStartDate: action.result.policyStartDate == null ? null : appUtility.formatDate(action.result.policyStartDate),
                        policyExpiryDate: action.result.policyExpiryDate == null ? null : appUtility.formatDate(action.result.policyExpiryDate),
                        policyOwnerName: action.result.policyOwner,
                        policyOwnerId: action.result.policyOwnerId,
                        policyOwnerType: action.result.insuredType,
                        cancellationDate: action.result.cancellationDate == null ? null : appUtility.formatDate(action.result.cancellationDate),
                        isIcpVerifiedYN: action.result.isIcpVerifiedYN,
                        errorMessage: action.result.errorMessage

                    }
                }
            }
        }

        /*Group Renewal*/
        case types.UPDATE_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED:
            return {
                ...state,
                groupRenewalSearch: {
                    ...state.groupRenewalSearch,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.CLEAR_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED:
            return {
                ...state,
                groupRenewalSearch: {
                    ...state.groupRenewalSearch,
                    product: null,
                    branch: null,
                    insuredName: null,
                    expiryFromDate: appUtility.addDays(appUtility.getCurrentDate(), 1),
                    expiryToDate: appUtility.getPlusOneMonthToCurrentDate(),
                    policyNo: null,
                    businessType: null,
                    agent: null,
                    isSubmit: false,
                    isAgentEnabled: false,
                    productType: null,
                    currentPolicyNo: null,
                    productMasters: [
                        { productId: 0, productName: null, productCode: null }
                    ],
                    documentType: null,
                    searchResult: [],
                    currentPolicyNo: null,
                    showSearchResult: false,
                    isSubmit: false
                }
            }
        case types.UPDATE_GROUP_RENEWAL_SEARCH_RESULT_MICORESHARED:
            let hasGroupRenewalCheckedBoxInSearchResult = false
            return {
                ...state,
                groupRenewalSearch: {
                    ...state.groupRenewalSearch,
                    searchResult: action.pagedResult,
                    hasCheckedBoxInSearchResult: hasGroupRenewalCheckedBoxInSearchResult
                }
            }
        case types.SHOW_GROUP_RENEWAL_TABLE_SEARCH_RESULTS_MICORESHARED:
            return {
                ...state,
                groupRenewalSearch: {
                    ...state.groupRenewalSearch,
                    currentPolicyNo: null,
                    showSearchResult: action.payload
                }
            }
        case types.SHOW_GROUP_RENEWAL_SEARCH_RESULTS_MICORESHARED:
            return {
                ...state,
                groupRenewalSearch: {
                    ...state.groupRenewalSearch,
                    isSubmit: true
                }
            }
        case types.GET_MEDICAL_OLD_AGE_CUT_OFF_DATE_MICORESHARED: {
            return {
                ...state,
                medicalOldAGeCUttOffDate: {
                    ...state.medicalOldAGeCUttOffDate,
                    ageCutOffDate: action.payload == null ? null : appUtility.formatDate(action.payload),
                }
            }
        }
        case types.GET_TREATY_MASTERS_END_MICORESHARED: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    treatyMasters: action.payload,

                }
            }
        }
        default:
            return state;
    }
}

